/**
 * Nabu Main API
 * 1.0.0
 * DO NOT MODIFY - This file has been generated using oazapfts.
 * See https://www.npmjs.com/package/oazapfts
 */
import * as Oazapfts from "oazapfts/lib/runtime";
import * as QS from "oazapfts/lib/runtime/query";

import { apiConfig } from '@/config'
import { Schema2 } from '@/models'
export const defaults: Oazapfts.RequestOpts = {
    baseUrl: `${apiConfig().apiUrl}`,
};
const oazapfts = Oazapfts.runtime(defaults);
export const servers = {
    localServerInstance: "http://localhost:3000",
    developmentServerInstance: "https://develop.nabu.io",
    productionServerInstance: "https://app.nabu.io"
};
export type Paging = {
    total_count: number;
    page_size: number;
    page_count: number;
};
export type Uuid = string;
export type Group = {
    createdAt?: string;
    updatedAt?: string;
    gid?: Uuid;
    /** string data model with a sequence of 32 characters (String32) */
    name?: string;
    directAffiliation?: boolean;
    selectAsDefault?: boolean;
    organization?: Uuid;
    /** Group Type : SERVICE, TEAM, OFFICE, ORGANIZATION or UNDEFINED (GroupType) */
    "type"?: Type;
    groupRegistrationNumber?: Uuid;
    /** List of SettingKey references */
    settings?: Uuid[];
    /** List of Group references */
    children?: Uuid[];
    parent?: Uuid;
    /** List of GroupAddress references */
    addressBook?: Uuid[];
    /** List of User references */
    members?: Uuid[];
};
export type CompanyRegistrationNumber = {
    createdAt?: string;
    updatedAt?: string;
    crnid?: Uuid;
    /** string data model with a sequence of 32 characters (String32) */
    value?: string;
    /** country code : string data model with a sequence of three-letter code (ISO 3166 alpha-3)  (CountryCodeISO3) */
    country?: string;
};
export type Organization = {
    createdAt?: string;
    updatedAt?: string;
    oid?: Uuid;
    /** string data model with a sequence of 64 characters (String64) */
    name?: string;
    mainGroup?: Group;
    registrationNumber?: (CompanyRegistrationNumber) | null;
    /** Whether Hyperline billing is enabled for the organization */
    hyperlineBillingEnabled?: boolean | null;
    /** True when admin pricing overrides are set */
    customPricing?: boolean | null;
    /** Active billing plan id when configured (starter|growth|enterprise) */
    planId?: string | null;
    /** Who decides access rights in the organization (ADR 0033): the contract roles (legacy), still them with gaps counted (observation), or the accesses (active). The webapp opens the roles screens only in active. */
    authzMode?: AuthzMode;
};
export type PartialCompanyRegistrationNumber = {
    /** string data model with a sequence of 32 characters (String32) */
    value?: string;
    /** country code : string data model with a sequence of three-letter code (ISO 3166 alpha-3)  (CountryCodeISO3) */
    country?: string;
};
export type PartialOrganization = {
    /** string data model with a sequence of 64 characters (String64) */
    name?: string;
    mainGroup?: Group;
    registrationNumber?: PartialCompanyRegistrationNumber;
};
export type Office = {
    /** Office ID */
    officeId?: string;
    /** Office name */
    label?: string;
    /** Office code */
    value?: string;
    /** Office street */
    street?: string;
    /** Office zip code */
    zipCode?: string;
    /** Office city */
    city?: string;
    /** Office country */
    country?: string;
    /** List of roles */
    roles?: ("DEP" | "DES" | "TRA")[];
    /** Office start date */
    startDate?: string;
    /** Office end date */
    endDate?: string;
    /** Office is active */
    isActive?: boolean;
    /** Office creation date */
    createdAt?: string;
    /** Office update date */
    updatedAt?: string;
};
export type Selector = {
    value?: string;
    label?: string;
};
export type SecurePassword = string | null;
export type UserProfile = {
    createdAt?: string;
    updatedAt?: string;
    /** string data model with a sequence of 32 characters (String32) */
    firstName?: string;
    /** string data model with a sequence of 32 characters (String32) */
    lastName?: string;
    /** Position Type : REGISTERED_CUSTOMS_REPRESENTATIVE, CUSTOMS_MANAGER, CUSTOMS_TEAM_MANAGER, INFORMATION_SYSTEMS_MANAGER, NABU_ADMINISTRATOR or SYSTEM_AGENT (PositionType) */
    position?: Position | null;
    /** Language identification : string data model - 2letters-2letters based on IETF Language Identification Tag - BCP47  (LanguageIETF) */
    language?: Language;
};
export type User = {
    createdAt?: string;
    updatedAt?: string;
    uid?: Uuid;
    /** email address : string data model referred to the addr-spec defined in RFC 5322 (Email) */
    email?: string | null;
    password?: SecurePassword;
    /** boolean : string data model with a sequence of 4 letters : True or False (boolean) */
    active?: boolean;
    /** Position Type : USER, MANAGER, ADMIN, SUPERADMIN, GUEST or AGENT (RoleType) */
    role?: Role;
    /** List of Group references */
    groups?: Uuid[];
    profile?: (UserProfile) | null;
    organization?: Uuid;
};
export type PartialUser = {
    /** email address : string data model referred to the addr-spec defined in RFC 5322 (Email) */
    email?: string | null;
    password?: SecurePassword;
    /** boolean : string data model with a sequence of 4 letters : True or False (boolean) */
    active?: boolean;
    /** Position Type : USER, MANAGER, ADMIN, SUPERADMIN, GUEST or AGENT (RoleType) */
    role?: Role;
    /** List of Group references */
    groups?: Uuid[];
    profile?: UserProfile;
    organization?: Uuid;
};
export type CreatedUser = User & {
    /** false: the user exists but the invitation email could not be sent, resend it with POST /users/{uid}/send-invitation-email. */
    invitationEmailSent?: boolean;
};
export type UserNotificationEmailPrefs = {
    /** Accusé de réception d'une déclaration */
    declarationAcknowledgment?: boolean;
    /** Confirmation de finalisation d'une déclaration */
    declarationFinalization?: boolean;
    /** Alerte d'erreur sur le traitement d'une déclaration */
    declarationError?: boolean;
    /** Alerte d'erreur pipeline ou traitement manuel de fichier */
    fileError?: boolean;
};
export type UserNotificationPreferences = {
    email?: UserNotificationEmailPrefs;
};
export type PatchUserNotificationPreferencesPayload = {
    email: {
        declarationAcknowledgment?: boolean;
        declarationFinalization?: boolean;
        declarationError?: boolean;
        fileError?: boolean;
    };
};
export type DeclarationBetaPreferences = {
    sourceDocument?: PanelPlacement;
    controlPanel?: ControlPanelPlacement;
    assistant?: PanelPlacement;
    homeTab?: DeclarationHomeTab;
};
export type ConsoleTableColumnIds = string[];
export type ConsoleTableLayout = {
    order: ConsoleTableColumnIds;
    hidden: ConsoleTableColumnIds;
};
export type UserUiPreferences = {
    theme?: Theme;
    declarationInterface?: DeclarationInterface;
    /** Folder preparation preselected in the upload wizard and new mailhooks. Null until the user chooses one. */
    defaultPreparation?: (PreparationMode) | null;
    declarationBeta?: DeclarationBetaPreferences;
    /** Keys of the announcements (banners, news) the user has closed. They are no longer shown, on any device. */
    dismissedAnnouncements?: string[];
    /** Console table layouts, by table id. Console-only keys: the webapp does not read them. */
    consoleTables?: {
        [key: string]: ConsoleTableLayout;
    };
};
export type PatchUserUiPreferencesPayload = {
    theme?: Theme;
    declarationInterface?: DeclarationInterface;
    /** Folder preparation preselected in the upload wizard and new mailhooks. Null until the user chooses one. */
    defaultPreparation?: (PreparationMode) | null;
    declarationBeta?: {
        sourceDocument?: PanelPlacement;
        controlPanel?: ControlPanelPlacement;
        assistant?: PanelPlacement;
        homeTab?: DeclarationHomeTab;
    };
    /** Adds an announcement key to dismissedAnnouncements, keeping the others. Idempotent. */
    dismissAnnouncement?: string;
    /** Console table layouts by table id: a layout replaces that table's, null resets it to the default, tables left out are kept. */
    consoleTables?: {
        [key: string]: {
            order: ConsoleTableColumnIds;
            hidden: ConsoleTableColumnIds;
        } | null;
    };
};
export type UuidNullable = string | null;
export type UserSettingKey = {
    uskid?: UuidNullable;
    /** string data model with a sequence of 16 characters (String16) */
    key?: string;
    label?: string;
    value?: string | null;
    category?: string | null;
    lockedOnGroupAt?: string | null;
    groupValues?: {
        value?: string;
        groupName?: string;
    }[];
    userId?: Uuid;
    refSchema?: UuidNullable;
    schemaId?: UuidNullable;
    createdAt?: string;
    updatedAt?: string;
};
export type UserSettingKeyUpdatePayload = {
    /** key of the setting to update */
    key: string;
    /** value for the setting key */
    value: string | null;
}[];
export type PartialUserSettingKey = {
    /** string data model with a sequence of 16 characters (String16) */
    key?: string;
    /** string data model with a sequence of 256 characters (String256) */
    value?: string;
    userId?: Uuid;
    refSchema?: UuidNullable;
};
export type GroupCreationPayload = {
    /** string data model with a sequence of 32 characters (String32) */
    name: string;
    organization: Uuid;
    /** Group Type : SERVICE, TEAM, OFFICE, ORGANIZATION or UNDEFINED (GroupType) */
    "type": Type;
    parent: Uuid;
};
export type PartialGroup = {
    /** string data model with a sequence of 32 characters (String32) */
    name?: string;
    organization?: Uuid;
    /** Group Type : SERVICE, TEAM, OFFICE, ORGANIZATION or UNDEFINED (GroupType) */
    "type"?: Type;
    groupRegistrationNumber?: Uuid;
    /** List of SettingKey references */
    settings?: Uuid[];
    /** List of Group references */
    children?: Uuid[];
    parent?: Uuid;
    /** List of GroupAddress references */
    addressBook?: Uuid[];
    /** List of User references */
    members?: Uuid[];
};
export type SettingKey = {
    createdAt?: string;
    updatedAt?: string;
    skid?: Uuid;
    /** string data model with a sequence of 16 characters (String16) */
    key?: string;
    /** string data model with a sequence of 256 characters (String256) */
    value?: string;
    group?: Uuid;
    refSchema?: Uuid;
    decSettingKeyId?: number;
    decSettingKeyOptionId?: number;
};
export type PartialSettingKey = {
    /** string data model with a sequence of 16 characters (String16) */
    key?: string;
    /** string data model with a sequence of 256 characters (String256) */
    value?: string;
    group?: Uuid;
    refSchema?: Uuid;
};
export type GroupSettingKey = {
    skid?: UuidNullable;
    key?: string;
    label?: string;
    value?: string | null;
    category?: string | null;
    lockedAt?: string | null;
    parentGroupValues?: {
        value?: string;
        groupName?: string;
    }[];
    groupId?: UuidNullable;
    schemaId?: UuidNullable;
    createdAt?: string | null;
    updatedAt?: string | null;
};
export type SettingKeyUpdatePayload = {
    /** key of the setting to update */
    key: string;
    /** value for the setting key */
    value: string | null;
    lockedAt: string | null;
};
export type GroupApiKey = {
    id?: UuidNullable;
    groupId: Uuid;
    userId: Uuid;
    /** Name of the API key */
    name: string;
    /** Cryptographic algorithm used by the key */
    algorithm: string;
    /** Fingerprint of the public key (SHA-256 hash, first 16 bytes in hex) */
    fingerprint: string;
    createdAt?: string | null;
};
export type CreateGroupApiKeyPayload = {
    /** Name of the API key (must be unique within the group) */
    name: string;
    /** Cryptographic algorithm (must match the public key) */
    algorithm: string;
    /** Public key in PEM format (SPKI) */
    publicKey: string;
};
export type DeclarationSummary = {
    id?: Uuid;
    /** Rang de l'envoi dans l'itération (0 en mono-envoi). */
    consignmentIndex?: number;
    consignmentId?: string | null;
    iteration?: number;
    state?: State;
    /** Version optimiste : +1 par lot d'événements appliqué. */
    version?: number;
    /** Avancement calculé à la génération : required{total,filled,missing}, fields{total,filled}, validated, blocking, warnings. */
    progress?: {
        [key: string]: any;
    };
    delivery?: {
        [key: string]: any;
    };
    updatedAt?: string;
};
export type BatchImportFile = {
    createdAt?: string;
    updatedAt?: string;
    fuid?: Uuid;
    /** string data model with a sequence of 255 characters (String255) */
    name?: string;
    /** Media Type : string data model - simplified : x Letters slash x Letters - RFC6838 & RFC4855 (MimeTypeSimple) */
    "type"?: string | null;
    /** url data : string data model referred to the Uniform Resource Locators defined in RFC 1738 (SimpleUrl) */
    location?: string | null;
    batchImportId?: Uuid;
};
export type ClientOrganization = {
    createdAt?: string;
    updatedAt?: string;
    coid?: Uuid;
    /** string data model with a sequence of 32 characters (String32) */
    name?: string;
    /** List of Group references */
    group?: Uuid[];
    organization?: Uuid;
    /** List of User references */
    members?: Uuid[];
    notes?: string | null;
};
export type BatchImportMetadata = {
    /** string data model with a sequence of 255 characters (String255) */
    dataSetName?: string;
    /** Source Type : EMAIL, FTP, API or SERVICE (SourceType) */
    source?: Source | null;
    submitter?: User;
    client?: (ClientOrganization) | null;
    exportConfiguration?: Uuid;
    /** The type of declaraction selected by configuration */
    exportType?: string;
    fluxId?: UuidNullable;
    decIntegrationId?: number | null;
};
export type Tag = {
    id?: UuidNullable;
    text: string;
    color?: string | null;
    organizationId?: UuidNullable;
    labels?: {
        [key: string]: string;
    } | null;
    createdAt?: string | null;
    updatedAt?: string | null;
};
export type LoginParameter = {
    /** email address : string data model referred to the addr-spec defined in RFC 5322 (Email) */
    email?: string;
    password?: string;
};
export type Transport = {
    createdAt?: string;
    updatedAt?: string;
    tid?: Uuid;
    /** Transport Type : FTP, SFTP or API (TransportType) */
    "type"?: Type2 | null;
    /** string data model with a sequence of 16 characters (String16) */
    name?: string;
    /** url address : string data model referred to the Uniform Resource Locators defined in RFC 1738 (UrlAddress) */
    address?: string | null;
    /** number : Any number. number is defined from -oo to +oo (number) */
    port?: number;
    authentication?: LoginParameter;
};
export type ExportDataTemplate = {
    createdAt?: string;
    updatedAt?: string;
    consolidateWith?: string[] | null;
    eid?: Uuid;
    /** string data model with a sequence of 32 characters (String32) */
    name?: string;
    dataschema?: Uuid;
    exportUiFormId?: Uuid;
};
export type Configuration = {
    createdAt?: string;
    updatedAt?: string;
    cid?: Uuid;
    /** string data model with a sequence of 32 characters (String32) */
    name?: string;
    groupId?: Uuid;
    transport?: Transport;
    template?: ExportDataTemplate;
    /** preset object */
    preset?: object | null;
    decTypeName?: string | null;
    decIntegrationId?: number | null;
};
export type DocumentType = {
    createdAt?: string;
    updatedAt?: string;
    dtid: Uuid;
    /** string data model with a sequence of 16 characters (String16) */
    name?: string;
    /** string data model with a sequence of 128 characters (String128) */
    description?: string;
    schema?: Uuid;
    /** HEX Color code */
    color?: string;
    /** if true, only the header of the document can be classified/extracted */
    extractHeaderOnly?: boolean;
    /** string describing if the documenty type is lead or secondary */
    role?: string;
};
export type ResourceLinks = {
    /** url data : string data model referred to the Uniform Resource Locators defined in RFC 1738 (SimpleUrl) */
    file?: string | null;
    /** url data : string data model referred to the Uniform Resource Locators defined in RFC 1738 (SimpleUrl) */
    imageLarge?: string | null;
    /** url data : string data model referred to the Uniform Resource Locators defined in RFC 1738 (SimpleUrl) */
    imageMedium?: string | null;
    /** url data : string data model referred to the Uniform Resource Locators defined in RFC 1738 (SimpleUrl) */
    imageSmall?: string | null;
};
export type DocumentPage = {
    /** Unsigned integer 16 bits : integer data model defined from 0 to 65535 (Uint16) */
    pageIndex?: number;
    /** boolean : string data model with a sequence of 4 letters : True or False (boolean) */
    active?: boolean;
    /** string data model with a sequence of 128 characters (String128) */
    sourceFileName?: string | null;
    page?: Uuid;
    resources?: ResourceLinks;
};
export type Document = {
    createdAt?: string;
    updatedAt?: string;
    pdid?: Uuid;
    batchImportId?: Uuid;
    layerId?: Uuid;
    documentType?: DocumentType;
    /** List of DocumentPage */
    pages?: DocumentPage[];
};
export type BatchImportComment = {
    comment?: string;
    userId?: Uuid;
    id?: Uuid;
    createdAt?: string;
    updatedAt?: string;
};
export type BatchImport = {
    /** Déclarations agentiques COURANTES du dossier (produit agentique, table declaration). Vide pour un dossier legacy, qui n'a que son export. */
    declarations?: DeclarationSummary[];
    createdAt?: string;
    updatedAt?: string;
    expectedAt?: string;
    readAt?: string | null;
    groupId?: UuidNullable;
    groupName?: string | null;
    /** Derived description: for email/api source = data set name; for web (manuel) = Client organisation / ref Nabu / ref client (non-empty parts only). */
    description?: string | null;
    fbid?: Uuid;
    referenceNabu?: string | null;
    referenceClient?: string | null;
    unifillStatus?: string | null;
    unifillStatusReason?: {
        code?: string;
        message?: string;
    } | null;
    /** True when the batch is driven by the Temporal pipeline (false only for old legacy batches). */
    useTemporal?: boolean;
    /** True when the batch follows the agentic path (stored declaration) and must open the declaration screen, not the extraction one. Fastify strips undeclared properties at serialisation, so the flag only reaches the client if it is declared here. */
    isAgentic?: boolean;
    /** Temporal workflow overall status (running, waiting-uploads, waiting-human, completed, failed). Null for legacy batches. */
    workflowOverallStatus?: string | null;
    /** Temporal workflow current step (awaiting-uploads, file-processing, extraction, mapping, awaiting-classification, awaiting-declaration, export). Null for legacy batches. */
    workflowCurrentStep?: string | null;
    /** batch_import.iteration. Ahead of the current declarations' iteration while a relaunch reads the batch again (TEC-1792): the screen keeps them read-only until the new ones are written. */
    iteration?: number;
    lastLog?: {
        /** Execution State */
        executionState?: ExecutionState | null;
        /** Status of the last batch import log
         Batch Step Status : upload, segmentation, mapping, page-ocr, export, extraction */
        step?: string | null;
        /** Name of the last batch import log step */
        stepName?: string | null;
        /** Why this step ended this way. On a failure, the cause shown to the user: processing-timeout (stopped by the stuck-folder control), workflow-lost, workflow-stuck, files-timeout. Fastify strips undeclared properties at serialisation, so it only reaches the client because it is declared here. */
        reason?: string | null;
        /** When this log was written, i.e. when the folder stopped on a failure. */
        createdAt?: string | null;
    } | null;
    /** Status of the last batch import log
     Batch Step Status : UPLOAD, SEGMENTATION, EXTRACTING, MAPPING, MAPPED, EXPORT, EXPORTED, EXPORT_FAILED, FAILED (BatchStepStatus) */
    batchImportLogStatus?: BatchImportLogStatus | null;
    /** Statut affiché du dossier, celui que filtre `states` et que compte GET /search/batch-imports/status-counts : ABANDONED quand le workflow a renoncé à attendre la validation (human-timeout, 15 jours), FAILED quand le dernier log a échoué sur une étape bloquante, sinon batchImportLogStatus. batchImportLogStatus reste FAILED pour un abandon. */
    displayStatus?: DisplayStatus | null;
    batchImportLogId?: Uuid;
    /** List of BatchImportFile */
    files?: BatchImportFile[];
    metadata?: BatchImportMetadata;
    /** Tags associated with the batch import */
    tags?: Tag[] | null;
    targetDataSet?: Uuid;
    /** Every data_set of this batch import with its export (1:1), i.e. every declaration to produce, in delivery order. `targetDataSet` and `export` above are the primary (first) one. Only returned by GET /batch-imports/{fbid}. */
    datasets?: {
        /** 0-based rank in the delivery order — the number of the declaration in the UI. */
        index?: number;
        datasetId?: Uuid;
        exportId?: UuidNullable;
        /** data_set state : queued, running, completed, failed, canceled */
        state?: string | null;
        /** export.last_transfer_state — null while the declaration has never been sent */
        lastTransferState?: string | null;
        /** When the operator validated this declaration, for the current run. Null = still to validate; cleared on re-mapping so it never claims a validation the workflow no longer holds. */
        validatedAt?: string | null;
    }[];
    configuration?: Configuration;
    clientOrganization?: {
        name?: string;
        id?: Uuid;
    } | null;
    /** ExporterInfo */
    exporter?: {
        name?: string | null;
        country?: string | null;
    };
    /** ImporterInfo */
    importer?: {
        name?: string | null;
        country?: string | null;
    };
    "export"?: {
        exportId?: UuidNullable;
        filenames?: string | null;
        /** S3 key of the generated export file (single XML or zip archive) */
        s3Key?: string | null;
        metadata?: {
            totalAmount?: number;
            totalGrossWeight?: number;
            totalPackage?: number;
            countPositions?: number;
        };
        lastTransferAt?: string | null;
        /** string data model with a sequence of 32 characters (String32) */
        lastTransferState?: string;
        /** string data model with a sequence of 256 characters */
        lastTransferReason?: string | null;
    };
    documents?: Document[];
    comments?: BatchImportComment[];
    emailSource?: {
        "from"?: string;
        to?: string;
        date?: string;
        subject?: string;
        body?: string;
        attachments?: {
            filename?: string;
            contentType?: string;
        }[];
    };
};
export type PartialBatchImportMetadata = {
    /** string data model with a sequence of 255 characters (String255) */
    dataSetName?: string;
    /** Source Type : EMAIL, FTP, API or SERVICE (SourceType) */
    source?: Source | null;
    submitter?: Uuid;
    client?: UuidNullable;
    exportConfiguration?: Uuid;
};
export type PartialBatchImport = {
    /** Status of the last batch import log
     Batch Step Status : UPLOAD, SEGMENTATION, MAPPING, MAPPED, EXPORT, EXPORTED (BatchStepStatus) */
    batchImportLogStatus?: BatchImportLogStatus2 | null;
    readAt?: string | null;
    batchImportLogId?: Uuid;
    /** List of BatchImportFile */
    files?: BatchImportFile[];
    metadata?: PartialBatchImportMetadata;
    targetDataSet?: Uuid;
    /** List of Document references */
    documents?: Uuid[];
    /** List of Page references */
    pagelist?: Uuid[];
};
export type BatchImportValidationProgressItem = {
    exportId: Uuid;
    batchImportLogStatus: BatchImportLogStatus3;
};
export type BatchImportValidationProgressRequest = {
    items: BatchImportValidationProgressItem[];
};
export type ExportValidationProgress = {
    completed: number;
    total: number;
};
export type BatchImportValidationProgressResponse = {
    data: {
        [key: string]: ExportValidationProgress;
    };
};
export type PartialUpdateBatchImport = {
    dataSetName?: string;
    /** New owner (référent) of the batch import, a member of its group. Changes only the owner: nothing is reprocessed, unlike configure (TEC-1823). */
    userId?: Uuid;
    readAt?: string | null;
    clientOrganizationId?: UuidNullable;
    /** Unifill Status : processing, done, error (UnifillStatus) */
    unifillStatus?: UnifillStatus | null;
    unifillStatusReason?: {
        code?: string;
        message?: string;
    } | null;
};
export type SubmitExtractionQualityFeedbackPayload = {
    /** Legacy questionnaire score from 1 to 5, accepted until every webapp sends score (TEC-1704). Never sent together with score. */
    rating?: number | null;
    /** NPS score from 0 (very dissatisfied) to 10 (very satisfied), TEC-1704 */
    score?: number | null;
    /** Optional free-text comment */
    comment?: string | null;
};
export type ExtractionQualityFeedbackDocumentTypeSnapshot = {
    id: Uuid;
    name: string;
};
export type ExtractionQualityFeedback = {
    id: Uuid;
    batchImportId: Uuid;
    exportId?: UuidNullable;
    userId: Uuid;
    rating?: number | null;
    score?: number | null;
    comment?: string | null;
    clientOrganizationId?: UuidNullable;
    groupId?: UuidNullable;
    fluxId?: UuidNullable;
    exportTemplateId?: UuidNullable;
    decTypeName?: string | null;
    decIntegrationId?: number | null;
    documentTypes?: ExtractionQualityFeedbackDocumentTypeSnapshot[] | null;
    extractionSource?: ExtractionSource | null;
    createdAt: string;
    updatedAt: string;
};
export type BatchImportConfigurationPayload = {
    /** Configuration Id to use for declaration. */
    configurationId: Uuid;
    /** Flux Id to apply on declaration. If not specified, no flux is applied. */
    fluxId: UuidNullable;
    /** User Id to apply on declaration. */
    userId?: Uuid;
    /** List of documents. Used to update the current segmentation/classification. */
    documents?: {
        /** DocumentType id. Used to classify the document. */
        documentTypeId: UuidNullable;
        /** Layer id. Use it to extract document data. */
        layerId: UuidNullable;
        /** List of pages in the document. */
        pages: {
            /** Page id. */
            page: Uuid;
            /** Page index */
            pageIndex: number;
            /** Disable the page if you don't wish to extract data from it. */
            active: boolean;
        }[];
    }[];
};
export type BatchImportLog = {
    createdAt?: string;
    updatedAt?: string;
    fblid?: Uuid;
    /** Batch Step Status : PENDING,RUNNING,INCOMPLETE,CANCELED,FAILED or SUCCEEDED (BatchStepStatus) */
    state?: State2 | null;
    /** string data model with a sequence of 16 characters (String16) */
    name?: string;
    /** string data model with a sequence of 32 characters (String32) */
    reason?: string;
    /** string data model with a sequence of 32 characters (String32) */
    stepName?: string;
    batchImport?: Uuid;
    executionState?: string;
};
export type BatchImportHistoryActor = {
    "type": Type3;
    userId?: Uuid;
    displayName?: string | null;
};
export type BatchImportHistoryResolved = {
    decEntryLabels?: {
        [key: string]: string;
    };
    clientOrganizationNames?: {
        [key: string]: string;
    };
    documentLabels?: {
        [key: string]: string;
    };
    automationGroupNames?: {
        [key: string]: string;
    };
};
export type BatchImportHistoryEntry = {
    id: Uuid;
    createdAt: string;
    actionType: string;
    payload: {
        [key: string]: any;
    };
    actor: BatchImportHistoryActor;
    exportId?: UuidNullable;
    resolved?: BatchImportHistoryResolved;
};
export type BatchImportHistoryCollection = {
    paging: Paging;
    data: BatchImportHistoryEntry[];
};
export type PartialBatchImportLog = {
    /** Batch Step Status : PENDING,RUNNING,INCOMPLETE,CANCELED,FAILED or SUCCEEDED (BatchStepStatus) */
    state?: State2 | null;
    /** string data model with a sequence of 16 characters (String16) */
    name?: string;
    /** string data model with a sequence of 32 characters (String32) */
    reason?: string;
    /** string data model with a sequence of 32 characters (String32) */
    stepName?: string;
    batchImport?: Uuid;
};
export type PartialBatchImportFile = {
    /** string data model with a sequence of 255 characters (String255) */
    name?: string;
    /** Media Type : string data model - simplified : x Letters slash x Letters - RFC6838 & RFC4855 (MimeTypeSimple) */
    "type"?: string | null;
    /** url data : string data model referred to the Uniform Resource Locators defined in RFC 1738 (SimpleUrl) */
    location?: string | null;
    batchImportId?: Uuid;
};
export type DataSource = {
    createdAt?: string;
    updatedAt?: string;
    dsid?: Uuid;
    /** string data model with a sequence of 16 characters (String16) */
    "type"?: string;
    data?: {
        [key: string]: any;
    }[];
    /** Extraction method that produced this data source */
    extractionSource?: ExtractionSource2 | null;
};
export type PartialDataSource = {
    /** string data model with a sequence of 16 characters (String16) */
    "type"?: string;
    data?: {
        [key: string]: any;
    }[];
};
export type DataSourceCorrectionEntry = {
    id?: Uuid;
    timestamp?: string;
    added?: {
        [key: string]: any;
    }[];
    removed?: {
        [key: string]: any;
    }[];
    modified?: {
        [key: string]: any;
    }[];
};
export type DataSourceRevision = {
    revid?: Uuid;
    timestamp?: string;
    data?: {
        [key: string]: any;
    }[];
};
export type Vertex = {
    /** number : Any number. number is defined from -oo to +oo (number) */
    x?: number;
    /** number : Any number. number is defined from -oo to +oo (number) */
    y?: number;
};
export type BoundingBox = {
    topLeft?: Vertex;
    bottomRight?: Vertex;
};
export type Image = {
    /** url data : string data model referred to the Uniform Resource Locators defined in RFC 1738 (SimpleUrl) */
    URL?: string | null;
    bbox?: BoundingBox;
};
export type Word = {
    bbox?: BoundingBox;
    /** string data model with a sequence of characters (string) */
    content?: string;
};
export type Line = {
    bbox?: BoundingBox;
    /** List of Word */
    words?: Word[];
};
export type Text = {
    bbox?: BoundingBox;
    /** List of Line */
    lines?: Line[];
};
export type Page = {
    createdAt?: string;
    updatedAt?: string;
    /** Unsigned integer 16 bits : integer data model defined from 0 to 65535 (Uint16) */
    fileIndex?: number;
    pid?: Uuid;
    batchImportId?: Uuid;
    /** List of Image */
    images?: Image[];
    /** List of Text */
    texts?: Text[];
    file?: Uuid;
};
export type PartialPage = {
    /** Unsigned integer 16 bits : integer data model defined from 0 to 65535 (Uint16) */
    fileIndex?: number;
    batchImportId?: Uuid;
    /** List of Image */
    images?: Image[];
    /** List of Text */
    texts?: Text[];
    file?: Uuid;
};
export type SettingKeyV2 = {
    decSettingKeyId?: number;
    decSettingKeyOptionId?: number;
    value?: string;
    inherited?: boolean;
    lockedAt?: string | null;
    createdAt?: string;
    updatedAt?: string;
};
export type SettingKeyToValidatePayload = {
    /** key of the setting to update */
    key: string;
    /** value for the setting key */
    value: string | null;
}[];
export type SettingKeyValidationResponse = {
    /** key of the setting to update */
    key: string;
    /** string data model with a sequence of 32 characters (String32) */
    message: string;
}[];
export type ExportUiFormData = {
    id: string;
    title: string;
    category: ExportUiFormDataCategory;
    isFluxSettingSwitch?: boolean;
    children: {
        [key: string]: any;
    }[];
};
export type ExportUiForm = {
    createdAt?: string;
    updatedAt?: string;
    eufid?: Uuid;
    /** string data model with a sequence of 32 characters (String32) */
    label?: string;
    groupId?: Uuid;
    exportDataTemplateId?: Uuid;
    data?: ExportUiFormData;
};
export type ExportDataItemTable = {
    tableId?: string;
    row?: number;
    column?: number;
} | null;
export type ExportDataItemOcr = {
  text?: string | null
  rawText?: string | null
  pageId?: UuidNullable
  position?: number[] | null
  confidence?: number | null
  sources?: {
    documentId?: string
    pageId?: string
  }[]
}
export type ExportDataItem = {
    id: string;
    /** url address : string data model referred to the Uniform Resource Locators defined in RFC 1738 (UrlAddress) */
    url: string | null;
    formSchemaId: string;
    decEntryId?: number;
    value: string | null;
    isValidated: boolean;
    readOnly: boolean;
    refParentCellId?: string;
    sequentialRow?: number;
    isConsolidatedCell?: boolean;
    table?: ExportDataItemTable;
    ocr: (ExportDataItemOcr) | null;
    metadata: {
        documentId?: string;
        tupleId?: string;
        operationOrigin?: {
            [key: string]: any;
        };
        [key: string]: any;
    } | null;
};
export type ExportTableGridPart = {
    pageId: string;
    position: number[];
    rows: {
        index?: number;
        top?: number;
    }[];
};
export type ExportDataTable = {
    id?: string;
    exportId?: string;
    schemaPath?: string;
    updatedCells?: ExportDataItem[];
    updatedFields?: {
        id?: Uuid;
        value?: string | null;
        formSchemaId?: string;
    }[];
    consolidatedAt?: string | null;
    grid?: ExportTableGridPart[];
    cells?: ExportDataItem[];
    isMainTable?: boolean;
    isMergeableTable?: boolean;
};
export type ExportDataTotal = {
    id: string;
    decEntryId: number;
    documentId: UuidNullable;
    exportTableId?: UuidNullable;
    value: string | null;
    ocr: (ExportDataItemOcr) | null;
};
export type ExportData = {
    createdAt?: string;
    updatedAt?: string;
    autoValidationAt?: string;
    lastTransferAt?: string | null;
    /** string data model with a sequence of 32 characters (String32) */
    lastTransferState?: string;
    /** string data model with a sequence of 256 characters */
    lastTransferReason?: string | null;
    exid?: Uuid;
    /** string data model with a sequence of 32 characters (String32) */
    state?: string;
    data?: {
        /** List of Fields */
        fields?: ExportDataItem[];
        /** List of Tables */
        tables?: ExportDataTable[];
        totals?: ExportDataTotal[];
    };
    template?: Uuid;
    rationale?: string | null;
};
export type PartialExportData = {
    exid?: Uuid;
    /** string data model with a sequence of 32 characters (String32) */
    state?: string;
    createdAt?: string;
    updatedAt?: string;
    autoValidationAt?: string;
    /** string data model with a sequence of 32 characters (String32) */
    name?: string;
    lastTransferAt?: string | null;
    /** string data model with a sequence of 32 characters (String32) */
    lastTransferState?: string;
    /** string data model with a sequence of 256 characters */
    lastTransferReason?: string | null;
};
export type ExportValidation = {
    itemId?: Uuid;
    /** string data model with a sequence of 32 characters (String32) */
    itemJsonPath?: string;
    /** string data model with a sequence of 32 characters (String32) */
    "type"?: string;
    /** string data model with a sequence of 32 characters (String32) */
    message?: string;
    instancePaths?: string[];
};
export type ExportPartialUpdatedData = {
    upsertedFields: ExportDataItem[];
    upsertedCells: ExportDataItem[];
    deletedIds: Uuid[];
};
export type ConsolidateV2Payload = {
    savedConsolidationId?: number | null;
    decEntryIds?: number[] | null;
};
export type ExportTableRowCreationPayload = {
    refIndex: number;
    refTop?: number;
    refBottom?: number;
    pageId: Uuid;
    rowCells: {
        row: number;
        column: number;
        value: string | null;
        ocr?: {
            text: string | null;
            rawText: string | null;
            pageId: Uuid;
            position: number[];
            confidence?: number | null;
        };
    }[];
};
export type ExportTableRowDeletionPayload = {
    /** export index of the row to delete */
    refIndex: number;
};
export type ExportTableCellBatchUpdatePayload = {
    cells: {
        id: Uuid;
        value?: string | null;
        isValidated?: boolean;
        readOnly?: boolean;
        ocr?: {
            text: string | null;
            rawText: string | null;
            pageId: Uuid;
            position: number[];
            confidence?: number | null;
        };
    }[];
};
export type ExportTableGridPartCreationPayload = {
    grid: {
        pageId: string;
        position: number[];
    };
    firstRowCells?: {
        column: number;
        value: string | null;
        ocr?: {
            text: string | null;
            rawText: string | null;
            pageId: Uuid;
            position: number[];
            confidence?: number | null;
        };
    }[];
    cells?: {
        row: number;
        column: number;
        value: string | null;
        ocr?: {
            text: string | null;
            rawText: string | null;
            pageId: Uuid;
            position: number[];
            confidence?: number | null;
        };
    }[];
};
export type ExportTablePageDeletionPayload = {
    pageId: Uuid;
};
export type ExportTableColumnDeletionPayload = {
    /** export index of the column to delete */
    refIndex: number;
};
export type ExportTableTotalCreationPayload = {
    /** ID of the declaration entry */
    decEntryId: number;
    /** Value of the total */
    value: string | null;
    /** ID of the document */
    documentId?: string | null;
    /** OCR data */
    ocr?: {
        /** OCR text */
        text?: string;
        /** Raw OCR text */
        rawText?: string;
        /** Page ID */
        pageId?: string;
        /** Position coordinates */
        position?: number[];
        /** OCR confidence level */
        confidence?: number;
    } | null;
};
export type ExportTableTotalUpdatePayload = {
    /** Value of the total */
    value?: string | null;
    /** ID of the document */
    documentId?: string | null;
    /** OCR data */
    ocr?: {
        /** OCR text */
        text?: string;
        /** Raw OCR text */
        rawText?: string;
        /** Page ID */
        pageId?: string;
        /** Position coordinates */
        position?: number[];
        /** OCR confidence level */
        confidence?: number;
    } | null;
};
export type DeclarationView = {
    [key: string]: any;
};
export type DeclarationEvent = {
    [key: string]: any;
};
export type DeclarationEventBatch = {
    /** Identifiant du lot, choisi par le client : un lot rejoué par le réseau ne s'applique pas deux fois. */
    batchId?: string;
    /** La version que l'écran affichait. 409 si elle a bougé. */
    baseVersion: number;
    events: {
        "type": Type4;
        gesture?: string;
        expect?: string[];
        keys?: string[];
        total?: string;
        basis?: Basis;
        weightBy?: string | null;
        [key: string]: any;
    }[];
};
export type DeclarationEventsApplied = {
    [key: string]: any;
};
export type DeclarationAutomationRunRequest = {
    automationGroupId: Uuid;
};
export type DeclarationAutomationRun = {
    /** Version of the declaration the preview was computed on; send it back as baseVersion to apply */
    version: number;
    automationGroupName: string;
    proposals: {
        lineId: string;
        path: string;
        /** Current value, null when empty */
        before?: any;
        /** Value set by the automation */
        after?: any;
        overwritesCorrection: boolean;
    }[];
    rejected: {
        lineId?: string;
        path?: string;
        /** Proposed value */
        value?: any;
        reason?: string;
    }[];
    ignored: number;
};
export type DeclarationAutomationApplyRequest = {
    automationGroupId: Uuid;
    baseVersion: number;
};
export type DeclarationAutomationApplied = {
    [key: string]: any;
};
export type PartialExportUiForm = {
    /** string data model with a sequence of 32 characters (String32) */
    label?: string;
    data?: ExportUiFormData;
    groupId?: Uuid;
    exportDataTemplateId?: Uuid;
};
export type PartialExportDataTemplate = {
    /** string data model with a sequence of 32 characters (String32) */
    name?: string;
    dataschema?: Uuid;
};
export type PartialClientOrganization = {
    /** string data model with a sequence of 32 characters (String32) */
    name?: string;
    /** List of Group references */
    group?: Uuid[];
    organization?: Uuid;
    /** List of User references */
    members?: Uuid[];
    notes?: string | null;
};
export type CreateConfigurationPayload = {
    /** Configuration name */
    name: string;
    groupId: Uuid;
    transportId: Uuid;
    decIntegrationId?: number | null;
};
export type PartialTransport = {
    /** Transport Type : FTP, SFTP or API (TransportType) */
    "type"?: Type5 | null;
    /** string data model with a sequence of 16 characters (String16) */
    name?: string;
    /** url address : string data model referred to the Uniform Resource Locators defined in RFC 1738 (UrlAddress) */
    address?: string | null;
    /** number : Any number. number is defined from -oo to +oo (number) */
    port?: number;
    authentication?: {
        /** email or name */
        email?: string;
        /** password */
        password?: string;
    };
};
export type PartialConfiguration = {
    transport?: PartialTransport;
    template?: PartialExportDataTemplate;
    /** string data model with a sequence of 32 characters (String32) */
    name?: string;
    groupId?: Uuid;
    /** preset object */
    preset?: object | null;
    decIntegrationId?: number | null;
};
export type TransportCollection = {
    data?: Transport[];
};
export type GroupConfigurationFieldOption = {
    groupConfigurationFieldOptionId?: number | null;
    refGroupConfigurationField?: number | null;
    value?: string | null;
    label?: string | null;
};
export type GroupConfigurationKey = {
    groupConfigurationKeyId?: number | null;
    refGroup?: UuidNullable;
    refGroupConfigurationField?: number | null;
    value?: string | null;
};
export type GroupConfigurationFieldWithOptions = {
    groupConfigurationFieldId?: number | null;
    name?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    options?: GroupConfigurationFieldOption[];
    selectedValue?: GroupConfigurationKey;
};
export type CreateGroupConfigurationKeyPayload = {
    group_configuration_field_id: number;
    group_configuration_field_option_id: number;
    group_id: Uuid;
};
export type UpdateGroupConfigurationKeyPayload = {
    group_configuration_key_id: number;
    group_configuration_field_option_id: number;
    group_id: Uuid;
};
export type FormSchema = {
    [key: string]: any;
};
export type FormLayoutMove = {
    path: string;
    before?: string;
    after?: string;
    first?: boolean;
    last?: boolean;
    section?: string;
};
export type FormLayout = {
    /** Id of the customs-software preset chosen by the group (see FormLayoutState.presets); null = Nabu standard only */
    preset?: string | null;
    /** Tab titles renamed by id; sections are informative for a group layout */
    tabs?: {
        id: string;
        title: string | {
            [key: string]: string;
        };
        sections?: string[];
        collapsed?: boolean;
    }[];
    /** Renamed labels: key = field path or section code, value = the group's own word (not translated) */
    labels?: {
        [key: string]: string;
    };
    moves?: FormLayoutMove[];
    /** Fields hidden by the group; a required field is never hidden */
    hidden?: string[];
    /** Fields the group requires on top of the destination; blocks sending for this group only */
    required?: string[];
    /** Columns of the goods table: same primitives */
    columns?: {
        hidden?: string[];
        moves?: FormLayoutMove[];
    };
};
export type FormLayoutState = {
    layout?: FormLayout;
    /** 0 when nothing is stored yet */
    version?: number;
    updatedAt?: string | null;
    presets?: {
        id?: string;
        software?: string | null;
    }[];
    /** Id of the Nabu standard layout of the declaration type */
    standard?: string;
    /** What, in the stored layout, no longer applies to the current catalogue */
    check?: {
        errors?: string[];
        warnings?: string[];
    };
    [key: string]: any;
};
export type Integration = {
    /** Unique identifier for the integration */
    decIntegrationId?: number;
    /** Name of the integration */
    name?: string;
    /** Declaration type identifier */
    decTypeId?: number;
    /** Name of the declaration type */
    decTypeName?: string;
};
export type IntegrationCollection = {
    data?: Integration[];
};
export type DataSet = {
    createdAt?: string;
    updatedAt?: string;
    dtsid?: Uuid;
    exportId?: Uuid;
    /** string data model with a sequence of 32 characters (String32) */
    name?: string;
    /** List of DataSource references */
    sources?: Uuid[];
    group?: Uuid;
};
export type PartialDataSet = {
    /** string data model with a sequence of 32 characters (String32) */
    name?: string;
    /** List of DataSource references */
    sources?: Uuid[];
    group?: Uuid;
};
export type AccountFeatureList = {
    /** Visible feature flag keys */
    data: string[];
};
export type RecoveryParameter = {
    /** LoginParameter : password */
    login?: {
        password?: SecurePassword;
    };
    previousPassword?: SecurePassword;
    tid?: Uuid;
    token?: Uuid;
};
export type BaseOrganization = {
    /** string data model with a sequence of 64 characters (String64) */
    organizationName?: string;
    /** string data model with a sequence of 32 characters (String32) */
    rootGroupName?: string;
    /** string data model with a sequence of 32 characters (String32) */
    companyRegistrationNumber?: string;
    /** country code : string data model with a sequence of three-letter code (ISO 3166 alpha-3)  (CountryCodeISO3) */
    organizationCountry?: string;
    /** email address : string data model referred to the addr-spec defined in RFC 5322 (Email) */
    userEmail?: string | null;
    userPassword?: SecurePassword;
    /** string data model with a sequence of 32 characters (String32) */
    userFirstName?: string;
    /** string data model with a sequence of 32 characters (String32) */
    userLastName?: string;
    /** Position Type : REGISTERED_CUSTOMS_REPRESENTATIVE, CUSTOMS_MANAGER, CUSTOMS_TEAM_MANAGER, INFORMATION_SYSTEMS_MANAGER, NABU_ADMINISTRATOR or SYSTEM_AGENT(PositionType) */
    userPosition?: UserPosition | null;
    /** Language identification : string data model - 2letters-2letters based on IETF Language Identification Tag - BCP47  (LanguageIETF) */
    userLanguage?: UserLanguage;
    /** send invitation email to user */
    sendInvitationEmail?: boolean;
};
export type PartialDocumentType = {
    /** string data model with a sequence of 16 characters (String16) */
    name?: string;
    /** string data model with a sequence of 128 characters (String128) */
    description?: string;
    schema?: Uuid;
};
export type FileDescriptor = {
    /** array of filename */
    filename?: string;
    /** boolean : string data model with a sequence of 4 letters : True or False (boolean) */
    postscript?: boolean;
    /** Specifies the media type of the resource. This property is used to indicate the format of the file being transmitted */
    contentType?: ContentType | null;
};
export type BatchImportRequest = {
    /** List of FileDescriptor */
    files: FileDescriptor[];
    /** string data model with a sequence of 255 characters (String255) */
    batchName: string;
    groupId: Uuid;
    clientOrganizationId?: UuidNullable;
    configurationId?: UuidNullable;
    fluxId?: UuidNullable;
    /** fast track the batch import (by pass the segmentation and classification steps) */
    fastTrack?: boolean;
    /** the upload files will be zipped into a single file */
    dearchived?: boolean;
    /** Optional tag IDs to associate with the batch import at creation */
    tagIds?: Uuid[];
    /** Force the pipeline routing at creation to BatchImportWorkflowV2 (e2e scenarios). Absent = automatic routing. */
    forceWorkflow?: ForceWorkflow;
    /** Route the batch to the agentic extraction pipeline. Absent or false = classic pipeline. */
    agentic?: boolean;
};
export type BatchImportReceipt = {
    /** Array of string  */
    files?: string[];
    /** Array of string (UrlAddress) */
    storageLocations?: (string | null)[];
    batchImportID?: Uuid;
    /** Ids of the created files, in the order of `files`. Set by push-addition, so the added file can be read by POST /batch-imports/{fbid}/workflow/relaunch (TEC-1792). */
    fileIds?: Uuid[];
};
export type BatchImportAdditionRequest = {
    file: {
        filename: string;
        postscript?: boolean;
        /** The types the pipeline reads (splitAndUploadPages). */
        contentType: ContentType2;
    };
    batchImportID: Uuid;
};
export type Layer = {
    createdAt?: string;
    updatedAt?: string;
    id?: Uuid;
    /** string data model with a sequence of 32 characters (String32) */
    name?: string;
    /** True if default layer for document type */
    isDefault?: boolean;
    documentType?: Uuid;
    /** List of LayerDoc references */
    layerDocs?: Uuid[];
    /** List of PostProcess references */
    postProcesses?: Uuid[];
    /** content type associated with layer, excel or pdf */
    contentType?: string;
    /** source of layer, external or internal */
    source?: string;
};
export type ClientOrganizationSettingKey = {
    createdAt?: string;
    updatedAt?: string;
    coskid?: Uuid;
    /** string data model with a sequence of 16 characters (String16) */
    key?: string;
    /** string data model with a sequence of 256 characters (String256) */
    value?: string;
    clientOrganizationId?: Uuid;
    refSchema?: UuidNullable;
};
export type PartialClientOrganizationSettingKey = {
    /** string data model with a sequence of 16 characters (String16) */
    key?: string;
    /** string data model with a sequence of 256 characters (String256) */
    value?: string;
    clientOrganizationId?: Uuid;
    refSchema?: UuidNullable;
};
export type SettingKeyOptionV2 = {
    id?: Uuid;
    labelCode?: string;
    format?: {
        [key: string]: any;
    };
    formatErrorLabelCode?: string;
    decCatalogId?: Uuid;
    decTypeName?: string;
    decEntryId?: number;
};
export type FluxCreationPayload = {
    exportDataTemplateId?: Uuid;
    name?: string;
    settingKeys?: {
        key?: string;
        value?: string;
    }[];
};
export type CreatedFlux = {
    fluxId?: Uuid;
    name?: string;
    settingKeys?: {
        key?: string;
        value?: string;
    }[];
};
export type FluxCreationPayloadV2 = {
    decIntegrationId: number;
    name: string;
    settingKeys: {
        value: string;
        decSettingKeyOptionId: number;
    }[];
    batchImportId?: string;
};
export type RestrictedUserInfos = {
    uid?: Uuid;
    /** email address : string data model referred to the addr-spec defined in RFC 5322 (Email) */
    email?: string | null;
    /** Position Type : USER, MANAGER, ADMIN, SUPERADMIN, GUEST or AGENT (RoleType) */
    position?: Position2;
    /** string data model with a sequence of 32 characters (String32) */
    firstName?: string;
    /** string data model with a sequence of 32 characters (String32) */
    lastName?: string;
};
export type Flux = {
    fid?: Uuid;
    name?: string;
    groupId?: Uuid;
    exportDataTemplateId?: Uuid;
    createdAt?: string;
    userFluxCreator?: RestrictedUserInfos;
    declarationType?: string;
    exportDataTemplate?: {
        eid?: Uuid;
        exportUiFormId?: Uuid;
    };
    settingKeys?: {
        fskid?: Uuid;
        key?: string;
        value?: string;
    }[];
    sharedWith?: {
        groupId?: Uuid;
        groupName?: string;
        permission?: Permission;
    }[];
    updatedAt?: string;
    exporter?: string;
    buyer?: string;
    decIntegrationId?: number | null;
};
export type PartialFlux = {
    name?: string;
};
export type FluxSettingKey = {
    fskid?: Uuid;
    /** string data model with a sequence of 16 characters (String16) */
    key?: string;
    /** string data model with a sequence of 256 characters (String256) */
    value?: string;
    fluxId?: Uuid;
    schemaId?: UuidNullable;
    createdAt?: string;
    updatedAt?: string;
};
export type CreateFluxSettingKey = {
    /** string data model with a sequence of 16 characters (String16) */
    key: string;
    /** string data model with a sequence of 256 characters (String256) */
    value: string;
    schemaId?: UuidNullable;
};
export type PatchFluxSettingKey = {
    /** string data model with a sequence of 256 characters (String256) */
    value?: string;
};
export type SettingKeyOption = {
    skoid?: Uuid;
    key?: string;
    scope?: Scope;
    label?: string;
    locale?: Locale;
    createdAt?: string;
    updatedAt?: string;
};
export type Statistics = {
    customsFilesToProcess?: number;
    customsFilesExported?: number;
};
export type DashboardTeamActivityMember = {
    userId: string;
    firstName?: string | null;
    lastName?: string | null;
    role?: string | null;
    position?: string | null;
    /** Folders with batch_import_log_status EXPORTED (same as Complété) whose COALESCE(succeeded last_transfer_at, updated_at) falls in the period. */
    processed: number;
    inProgress: number;
    late: number;
    cadence: number;
    load: number;
};
export type DashboardTeamActivityResponse = {
    agencyId: string;
    agencyName: string;
    period: Period;
    workdays: number;
    capacity: number;
    targetRate: number;
    members: DashboardTeamActivityMember[];
};
export type DashboardFluxMonthVolume = {
    /** Calendar month (YYYY-MM) */
    month: string;
    "import": number;
    "export": number;
    transit: number;
};
export type DashboardFluxVolumeResponse = {
    months: DashboardFluxMonthVolume[];
};
export type InAppNotificationPulse = {
    unreadCount: number;
    headId: UuidNullable;
};
export type InAppNotificationActor = {
    id: Uuid;
    firstName?: string | null;
    lastName?: string | null;
};
export type InAppNotification = {
    id: Uuid;
    "type": Type6;
    readAt: string | null;
    createdAt: string;
    actor: (InAppNotificationActor) | null;
    batchImportId: UuidNullable;
    exportId: UuidNullable;
    payload: {
        [key: string]: any;
    };
};
export type InAppNotificationListResponse = {
    data: InAppNotification[];
    nextCursor: string | null;
};
export type CreateTagPayload = {
    text: string;
    color?: string | null;
    organizationId?: Uuid;
};
export type UpdateTagPayload = {
    text?: string;
    color?: string | null;
};
export type SavedSearch = {
    id?: Uuid;
    /** Target search identifier (e.g. batch-import) */
    scope?: string;
    /** Display name */
    name?: string;
    /** Search parameters: filters, view, orderBy, reverse, page, size (structure depends on scope) */
    payload?: {
        [key: string]: any;
    };
    createdAt?: string | null;
    updatedAt?: string | null;
};
export type CreateSavedSearchPayload = {
    /** Display name */
    name: string;
    /** Target search (e.g. batch-import) */
    scope: Scope2;
    /** Search parameters (structure depends on scope) */
    payload: {
        [key: string]: any;
    };
};
export type UpdateSavedSearchPayload = {
    name?: string;
    /** Search parameters (structure depends on scope) */
    payload?: {
        [key: string]: any;
    };
};
export type ChangelogLocalizedItem = {
    title: string;
    description?: string;
};
export type ChangelogI18NBlock = {
    title?: string;
    description?: string;
};
export type ChangelogI18N = {
    [key: string]: ChangelogI18NBlock;
};
export type ChangelogItemStaff = {
    itemId?: Uuid;
    kind?: Kind;
    i18n?: ChangelogI18N;
    deploymentEnv?: DeploymentEnv | null;
    sortOrder?: number;
    /** Linear identifier (e.g. TEC-1234) */
    sourceRef?: string | null;
    /** Linear issue id */
    sourceId?: string | null;
};
export type ChangelogReleaseListItem = {
    releaseId: Uuid;
    version: string;
    date?: string;
    title?: string;
    description?: string;
    features?: ChangelogLocalizedItem[];
    fixes?: ChangelogLocalizedItem[];
    status?: Status;
    releaseDate?: string;
    i18n?: ChangelogI18N;
    publishedAt?: string | null;
    publishedBy?: Uuid;
    items?: ChangelogItemStaff[];
    createdAt?: string | null;
    updatedAt?: string | null;
};
export type ChangelogReleaseListMeta = {
    hasUnreadLatest?: boolean;
    latestReleaseId?: Uuid;
};
export type ChangelogReleaseListResponse = {
    data?: ChangelogReleaseListItem[];
    meta?: ChangelogReleaseListMeta;
};
export type ChangelogItemPayload = {
    kind: Kind;
    i18n: ChangelogI18N;
    deploymentEnv?: DeploymentEnv | null;
    sortOrder?: number;
    sourceRef?: string | null;
    sourceId?: string | null;
};
export type CreateChangelogReleasePayload = {
    version: string;
    releaseDate: string;
    i18n: ChangelogI18N;
    items?: ChangelogItemPayload[];
};
export type ChangelogReleaseStaff = {
    releaseId?: Uuid;
    version?: string;
    status?: Status;
    releaseDate?: string;
    i18n?: ChangelogI18N;
    publishedAt?: string | null;
    publishedBy?: Uuid;
    items?: ChangelogItemStaff[];
    createdAt?: string | null;
    updatedAt?: string | null;
};
export type ChangelogLinearImportPayload = {
    /** Linear team name. Defaults to Tech. */
    team?: string;
};
export type ChangelogLinearImportResponse = {
    release: ChangelogReleaseStaff;
    translationWarning?: string;
};
export type PatchChangelogReleasePayload = {
    version?: string;
    releaseDate?: string;
    i18n?: ChangelogI18N;
    items?: ChangelogItemPayload[];
};
export type PlatformSetting = {
    key?: string;
    value?: number;
    defaultValue?: number;
    min?: number;
    max?: number;
    description?: string;
    updatedAt?: string | null;
    updatedBy?: Uuid;
};
export type UpdatePlatformSettingPayload = {
    value: number;
};
export type HelpArticleListItem = {
    id: Uuid;
    title: string;
    category: HelpCategory;
    subcategory?: string;
    language: HelpArticleLanguage;
    readingTimeMinutes?: number;
    isPopular?: boolean;
    updatedAt: string;
};
export type HelpArticleListResponse = {
    articles: HelpArticleListItem[];
    meta: {
        total: number;
    };
};
export type HelpFrequentSearchesResponse = {
    terms: string[];
};
export type HelpSyncRunResponse = {
    syncRunId: Uuid;
    trigger: Trigger;
    startedAt: string;
    finishedAt?: string | null;
    status: Status2;
    articlesAdded: number;
    articlesUpdated: number;
    articlesUnpublished: number;
    errorSummary?: string | null;
};
export type HelpSyncRunListResponse = {
    syncRuns: HelpSyncRunResponse[];
};
export type HelpArticleDetail = {
    id: Uuid;
    title: string;
    category: HelpCategory;
    subcategory?: string;
    language: HelpArticleLanguage;
    readingTimeMinutes?: number;
    isPopular?: boolean;
    viewCount: number;
    userFeedback?: boolean;
    searchKeywords?: string[];
    contentHtml: string;
    updatedAt: string;
};
export type HelpArticleViewResponse = {
    viewCount: number;
};
export type HelpArticleFeedbackRequest = {
    helpful: boolean;
};
export type HelpArticleFeedbackResponse = {
    helpful: boolean;
};
export type NotionHelpCenterWebhookPayload = {
    id?: string;
    "type"?: string;
    verification_token?: string;
    entity?: {
        id?: string;
        "type"?: string;
    };
};
export type HyperlineWebhookPayload = {
    event_type: string;
    data?: {
        id?: string;
        subscription_id?: string;
        [key: string]: any;
    };
};
export type HyperlineWebhookResponse = {
    ok?: boolean;
    status?: string;
    reason?: string;
    skipped?: string;
    credits?: number;
    subscriptionId?: string;
    periodStartedAt?: string;
};
export type AiAgentSkill = {
    id: Uuid;
    name: string;
    description: string;
    icon: AiAgentSkillIcon;
    workMethod: string;
};
export type AiAgentSkillListResponse = {
    skills: AiAgentSkill[];
};
export type AiAgentSkillWritePayload = {
    name: string;
    description?: string;
    icon: AiAgentSkillIcon;
    workMethod?: string;
};
export type WeeklyScoringMetrics = {
    /** Monday of the week (ISO date) */
    weekStart: string;
    /** Sunday of the week (ISO date) */
    weekEnd: string;
    /** Proportion théorique A/B test (interne/total) */
    theoreticalAbTestRatio: number;
    /** Proportion réelle A/B test (vraiment sélectionnée/totale) */
    realAbTestRatio: number;
    /** Proportion documents avec extraction interne exportés */
    internalExportRatio: number;
    /** Proportion documents avec extraction rossum exportés */
    rossumExportRatio: number;
};
export type ScoringMetricsWeeklyResponse = {
    weeks: WeeklyScoringMetrics[];
};
export type EvalVersionSummary = {
    version: string;
    note: string;
    recordedAt: string;
    runId: string;
    gitHead: string;
    provider: string;
    threshold?: number;
    durationMs?: number;
    datasets?: string[];
    summaryExcerpt?: string | null;
    previousVersion?: string | null;
    [key: string]: any;
};
export type EvalScoreboardResponse = {
    versions: EvalVersionSummary[];
    warning?: string;
    [key: string]: any;
};
export type EvalVersionDetail = {
    version: string;
    note: string;
    recordedAt: string;
    runId: string;
    gitHead: string;
    previousVersion?: string | null;
    [key: string]: any;
};
export type ImportSeed = {
    /** Unique identifier of the ImportSeed. */
    isid?: Uuid;
    /** Name of the ImportSeed. */
    name?: string | null;
    /** ID of the user who uploaded the file. */
    userId?: string | null;
    /** Timestamp of when the ImportSeed was created. */
    createdAt?: string | null;
    /** Timestamp of when the ImportSeed was last updated. */
    updatedAt?: string | null;
};
export type ImportSeedPayload = {
    organizations: {
        name: string;
    }[];
    groups: {
        name: string;
        "type": string;
        parent?: string | null;
        organizationName: string;
        users?: {
            email: string;
            role: string;
            active: boolean;
            groupName?: string;
            firstName: string;
            lastName: string;
            position: string;
            language: string;
            password: string;
            sendEmail: boolean;
        }[];
        companyRegistrationNumber: {
            value: string;
            country: string;
        };
        address: {
            givenName: string;
            surname: string;
            companyName: string;
            streetNo: string;
            streetName: string;
            streetType: string;
            floor: string;
            town: string;
            region: string;
            postCode: string;
            country: string;
            tag: string;
        };
    }[];
    name: string;
};
export type CreateEventSubscriptionRequest = {
    /** Group (gid) the subscription is scoped to */
    groupId: Uuid;
    /** Human-readable subscription name */
    name: string;
    /** HTTPS URL of the partner endpoint. */
    targetUrl: string;
    /** Auth strategy for outbound calls */
    authType: AuthType;
    /** Auth configuration. Encrypted at rest before persisting. */
    authConfig: {
        "type": Type7;
        secret: string;
    } | {
        "type": Type8;
        token_url: string;
        client_id: string;
        client_secret: string;
        audience?: string;
        scope?: string;
    };
    /** Filter to these event_type values. NULL = all. */
    eventTypes?: string[] | null;
    /** Filter to these overall_status values. NULL = all. */
    statusFilter?: string[] | null;
};
export type TableAutomationGroupRulePayloadItem = {
    /** Declaration entry ID (field identifier) */
    decEntryId?: number | null;
    /** Column index in the table */
    columnIndex?: number | null;
    /** Custom value to set */
    customValue?: string | null;
    /** Color code for visualization */
    color?: string | null;
};
export type TableAutomationGroupRuleMatchingItem = {
    /** Declaration entry ID (field identifier) */
    decEntryId?: number | null;
    /** Column index in the table */
    columnIndex?: number | null;
    /** Custom value to match against */
    customValue?: string | null;
    /** Relation operator: eq (equals), lt (less than), gt (greater than), includes (substring) */
    relation?: Relation | null;
    /** Color code for visualization */
    color?: string | null;
};
export type AutomationGroup = {
    id: Uuid;
    /** Name of the automation group */
    name: string;
    /** Optional description of the automation group */
    description?: string | null;
    /** List of payload rules */
    payload: TableAutomationGroupRulePayloadItem[];
    /** List of matching rules */
    matching: TableAutomationGroupRuleMatchingItem[];
    /** Row ranges in format 'start:end,start:end' */
    ranges?: string | null;
    /** Reference to client organization (optional) */
    refClientOrganization?: UuidNullable;
    /** Reference to configuration */
    refConfiguration: Uuid;
    /** Reference to group */
    refGroup: Uuid;
    /** Reference to user */
    refUser: Uuid;
    /** Whether the automation group is active */
    active: boolean;
    /** Whether automations should run automatically when a declaration is created */
    autoRunOnCreate?: boolean;
    /** Creation timestamp */
    createdAt?: string | null;
    /** Last update timestamp */
    updatedAt?: string | null;
};
export type CreateAutomationGroupRequestData = {
    /** List of matching rules */
    matching: TableAutomationGroupRuleMatchingItem[];
    /** List of payload rules */
    payload: TableAutomationGroupRulePayloadItem[];
    /** Row ranges in format 'start:end,start:end' */
    ranges?: string | null;
};
export type CreateAutomationGroupRequest = {
    /** Name of the automation group */
    name: string;
    /** Optional description of the automation group */
    description?: string | null;
    /** Configuration ID */
    configurationId: Uuid;
    /** Group ID */
    groupId: Uuid;
    /** User ID */
    userId: Uuid;
    /** Whether the automation group is active */
    active: boolean;
    /** Whether automations should run automatically when a declaration is created */
    autoRunOnCreate?: boolean;
    /** Client organization ID (optional) */
    clientOrganizationId?: UuidNullable;
    data: CreateAutomationGroupRequestData;
    /** Size of the automation group grid file in bytes */
    fileSize?: number;
};
export type UpdateAutomationGroupPayload = {
    /** Name of the automation group */
    name?: string | null;
    /** Optional description of the automation group (set to null to clear) */
    description?: string | null;
    /** Whether the automation group is active */
    active?: boolean | null;
    /** Whether automations should run automatically when a declaration is created (null resets to false) */
    autoRunOnCreate?: boolean | null;
    /** Client organization ID (can be set to null) */
    refClientOrganization?: UuidNullable;
    /** List of payload rules (full replacement when provided) */
    payload?: TableAutomationGroupRulePayloadItem[];
    /** List of matching rules (full replacement when provided) */
    matching?: TableAutomationGroupRuleMatchingItem[];
    /** Row ranges in format 'start:end,start:end' */
    ranges?: string | null;
};
export type DataGridUploadRequest = {
    /** Size of the data-grid.json file in bytes */
    fileSize: number;
    /** Row ranges in format 'start:end,start:end' (line 0 = headers, data from 1 to n-1) */
    ranges?: string | null;
};
export type RagRetrievalStoreRequest = {
    dsid: Uuid;
};
export type BillingCreditPack = {
    credits: number;
    priceEur: number;
    pricePerCredit: number;
};
export type BillingRates = {
    declarationCost?: number;
    articleCost?: number;
    extraCreditPrice?: number;
    setupFee?: number;
    rolloverMonths?: number;
    customPricing?: boolean;
};
export type BillingCreditsSnapshot = {
    balance?: number;
    included?: number;
    purchased?: number;
    gifted?: number;
    consumedEstimate?: number;
    remaining?: number;
    usagePercent?: number;
    threshold?: Threshold;
};
export type BillingCreditsResponse = {
    enrolled: boolean;
    enrollmentReason?: EnrollmentReason;
    /** null when not enrolled; pending = must activate subscription before using credits UI */
    subscriptionActivation?: SubscriptionActivation | null;
    balance: number | null;
    productId?: string | null;
    customerId?: string | null;
    lowThreshold?: number | null;
    declarationsRemaining?: number | null;
    packs?: BillingCreditPack[];
    rates?: BillingRates;
    credits?: BillingCreditsSnapshot;
    mode: Mode;
};
export type BillingSubscriptionResponse = {
    enrolled: boolean;
    enrollmentReason: EnrollmentReason;
    /** pending = enrolled Hyperline customer but no live subscription yet; UI must CTA activate, not show exhausted credits. */
    subscriptionActivation?: SubscriptionActivation;
    /** True when the Hyperline customer has at least one usable payment method. Required before POST /billing/subscription/activate. */
    paymentMethodReady?: boolean;
    plan?: {
        id?: Id;
        name?: string;
        maxUsers?: number | null;
    } | null;
    billingCycle?: BillingCycle;
    currency?: string;
    amountDue?: number | null;
    annualSavingsPercent?: number;
    annualSavingsAmount?: number;
    nextBillingAt?: string | null;
    credits?: BillingCreditsSnapshot;
    rates?: BillingRates;
    mode?: Mode;
};
export type BillingSubscriptionMutationResponse = {
    planId: PlanId2;
    billingCycle: BillingCycle;
    effectiveAt: EffectiveAt;
    hyperlineSynced: boolean;
};
export type BillingCreditsPurchaseResponse = {
    quantity: number;
    unitPrice: number;
    total: number;
    priceId?: string | null;
    credits: BillingCreditsResponse;
    mode: Mode;
};
export type BillingPlansResponse = {
    cycle: Cycle;
    annualDiscountPercent?: number;
    plans: {
        id: Id;
        name: string;
        active: boolean;
        selectable: boolean;
        recommended?: boolean;
        fee: number;
        annualSavingsAmount?: number;
        envelopeCredits: number;
        maxUsers?: number | null;
        rates?: {
            declarationCost?: number;
            articleCost?: number;
            extraCreditPrice?: number;
        };
    }[];
};
export type BillingPaymentMethodItem = {
    id: string;
    brand: Brand;
    last4: string;
    expMonth: number | null;
    expYear: number | null;
    holderName: string | null;
    isDefault: boolean;
    status: Status3;
};
export type BillingPaymentMethodsResponse = {
    items: BillingPaymentMethodItem[];
};
export type BillingPaymentMethodConfirmResponse = {
    id: string;
    status: Status3;
};
export type BillingPaymentMethodSetupResponse = {
    kind: Kind2;
    mode: Mode;
    publicKey: string;
    intentSecret: string;
    intentId: string;
    clientProviderId: string;
    providerName: string;
};
export type BillingPaymentMethodDefaultResponse = {
    id: string;
    isDefault: boolean;
};
export type BillingInvoiceItem = {
    id: string;
    "number": string;
    date: string;
    periodLabel: string;
    periodStartsAt: string | null;
    periodEndsAt: string | null;
    amountHtCents: number;
    currency: string;
    status: Status4;
};
export type BillingInvoicesResponse = {
    items: BillingInvoiceItem[];
};
export type BillingInvoiceDocumentResponse = {
    url: string;
    expiresAt: string | null;
};
export type AdminOrganizationMatchedUser = {
    uid: Uuid;
    email?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    active: boolean;
    /** Groups of the user in this organization, root group excluded */
    groups: {
        gid: Uuid;
        name: string;
    }[];
};
export type AdminOrganization = {
    oid: Uuid;
    name: string;
    createdAt?: string;
    updatedAt?: string;
    hyperlineBillingEnabled?: boolean | null;
    customPricing?: boolean | null;
    planId?: string | null;
    /** True when the organization name matches the term */
    matchedByName: boolean;
    /** Users of the organization matching the term; matchedUsers only lists the first ones */
    matchedUserCount: number;
    matchedUsers: AdminOrganizationMatchedUser[];
};
export type AdminOrganizationCollection = {
    paging: Paging;
    data: AdminOrganization[];
};
export type AdminOrganizationNeighbors = {
    /** Rank in the list, from 1; null when it no longer matches the list (it then keeps its place between its neighbors) */
    position: number | null;
    /** Number of items in the list */
    total: number;
    /** Item just before; null at the start of the list */
    previous: {
        oid: Uuid;
    } | null;
    /** Item just after; null at the end of the list */
    next: {
        oid: Uuid;
    } | null;
};
export type AdminSubscription = {
    organizationId: Uuid;
    organizationName: string;
    /** unpaid: payment failed or an invoice is overdue, whatever the subscription status; none: no Hyperline subscription, or one that never started */
    status: Status5;
    /** Plan of the Nabu catalog (starter, growth, enterprise) */
    planId: string | null;
    /** Hyperline name of a plan outside the Nabu catalog */
    planName: string | null;
    startedAt: string | null;
    /** End of the trial, scheduled end, or renewal, whichever comes first */
    nextDueAt: string | null;
    /** Trial ending within 7 days */
    trialEndsSoon: boolean;
    /** Monthly amount including tax, in cents of currency (estimated ARR / 12 and the tax rate of the last invoice); null when Hyperline does not estimate it */
    monthlyAmountIncludingTaxCents: number | null;
    currency: string | null;
    activeUserCount: number;
    /** Nabu billing of the organization (organization_subscription): active, manual billing, or never configured */
    nabuBilling: NabuBilling;
    /** Ongoing Hyperline subscription while Nabu billing is not active: no credit is debited */
    billingGap: boolean;
};
export type AdminSubscriptionSync = {
    /** End of the last successful synchronization, which the rows reflect */
    lastSyncedAt: string | null;
    lastAttemptAt: string | null;
    /** Error of the last attempt when it failed */
    lastError: string | null;
    /** Ongoing Hyperline subscriptions whose customer matches no organization */
    unmatchedSubscriptionCount: number;
};
export type AdminSubscriptionCollection = {
    data: AdminSubscription[];
    sync: AdminSubscriptionSync;
};
export type AdminHelpArticle = {
    id: Uuid;
    notionPageId: string;
    title: string;
    category: HelpCategory;
    language: HelpArticleLanguage;
    access: Access;
    status: Status6;
    isPopular: boolean;
    viewCount: number;
    notionLastEditedTime: string;
    publishedAt: string | null;
    syncedAt: string;
};
export type AdminHelpCenter = {
    articles: AdminHelpArticle[];
    syncRuns: HelpSyncRunResponse[];
    /** Full sync in progress, null when none. An unfinished run that is not this one was interrupted. */
    runningSyncRunId: string | null;
    /** Latest finished full sync, null when none. Webhook runs can push it out of syncRuns. */
    lastFullSync: (HelpSyncRunResponse) | null;
};
export type AdminDashboard = {
    "from": string;
    to: string;
    /** Segmented or mapped, waiting for the user (neither in error nor still processing), created during the period */
    declarationsInProgress: number | null;
    /** Exported, with a successful transfer during the period */
    declarationsCompleted: number | null;
    activeUsers: {
        userCount: number;
        /** Organizations the active users belong to */
        organizationCount: number;
    } | null;
    subscriptionsMrr: {
        /** Monthly recurring revenue including tax, in euro cents: sum of the monthly amounts of the subscriptions whose status is active in the subscriptions table (paused included; unpaid, trials and cancelled excluded) */
        amountIncludingTaxCents: number;
        /** End of the last successful Hyperline synchronization; null for a recorded figure */
        syncedAt: string | null;
    } | null;
};
export type AdminDeclarationClient = {
    /** Client name, as written in the declaration */
    name: string;
    /** Number of batch imports with this client name */
    declarations: number;
};
export type AdminDeclarationClientCollection = {
    data: AdminDeclarationClient[];
};
export type AdminSearchOrganization = {
    oid: Uuid;
    name: string;
};
export type AdminSearchGroup = {
    gid: Uuid;
    name: string;
    organizationId: Uuid;
    organizationName: string;
};
export type AdminSearchUser = {
    uid: Uuid;
    firstName: string | null;
    lastName: string | null;
    email: string | null;
    /** The user's own organization (user.ref_organization) */
    organizationId: string | null;
    organizationName: string | null;
};
export type AdminSearchDeclaration = {
    fbid: Uuid;
    referenceNabu: string | null;
    referenceClient: string | null;
    /** Name of the dossier */
    dataSetName: string | null;
    createdAt: string;
    /** Organization of the group that owns the batch import */
    organizationId: string | null;
    organizationName: string | null;
};
export type AdminSearchResult = {
    organizations: {
        totalCount: number;
        items: AdminSearchOrganization[];
    };
    groups: {
        totalCount: number;
        items: AdminSearchGroup[];
    };
    users: {
        totalCount: number;
        items: AdminSearchUser[];
    };
    declarations: {
        totalCount: number;
        items: AdminSearchDeclaration[];
    };
};
export type AdminUser = {
    uid: Uuid;
    email?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    organizationId: Uuid;
    organizationName: string;
    /** Groups of the user in this organization, root group excluded: empty when the user is attached at the organization level */
    groups: {
        gid: Uuid;
        name: string;
    }[];
    /** user.role, the same in every organization of the user */
    role: string;
    /** disabled wins; invited while the link received (invitation or lost password) was never used and no login is recorded */
    status: Status7;
    createdAt: string;
    /** Last successful password login, impersonation excluded; null until the first login recorded */
    lastLoginAt: string | null;
};
export type AdminUserCollection = {
    paging: Paging;
    data: AdminUser[];
};
export type AdminUserDetail = {
    uid: Uuid;
    email: string | null;
    firstName: string | null;
    lastName: string | null;
    /** user_profile.language; null without profile */
    language: string | null;
    /** user.role, the same in every organization of the user */
    role: string;
    active: boolean;
    /** disabled wins; invited while the link received (invitation or lost password) was never used and no login is recorded */
    status: Status7;
    organizationId: Uuid;
    createdAt: string;
    /** Last successful password login, impersonation excluded; null until the first login recorded */
    lastLoginAt: string | null;
    /** The user's organization first, then those of their groups, each with the user's agencies (root group excluded) */
    memberships: {
        organizationId: Uuid;
        organizationName: string;
        groups: {
            gid: Uuid;
            name: string;
        }[];
    }[];
    /** All the groups of the user, root group included */
    groupIds: Uuid[];
};
export type AdminUserNeighbors = {
    /** Rank in the list, from 1; null when it no longer matches the list (it then keeps its place between its neighbors) */
    position: number | null;
    /** Number of items in the list */
    total: number;
    /** Item just before; null at the start of the list */
    previous: {
        uid: Uuid;
        organizationId: Uuid;
    } | null;
    /** Item just after; null at the end of the list */
    next: {
        uid: Uuid;
        organizationId: Uuid;
    } | null;
};
export type AdminAuditEvent = {
    id: string;
    action: Action;
    /** Changed fields only: { field: { before, after } }; empty for a sent email */
    changes: {
        [key: string]: any;
    };
    /** Null when the user of the author was deleted */
    actor: {
        uid: Uuid;
        firstName?: string | null;
        lastName?: string | null;
        email?: string | null;
    } | null;
    createdAt: string;
};
export type AdminAuditEventList = {
    data: AdminAuditEvent[];
};
export type AdminInternalNote = {
    id: Uuid;
    content: string;
    /** null when the user of the author was deleted */
    author: {
        uid: Uuid;
        email: string | null;
        firstName: string | null;
        lastName: string | null;
    } | null;
    createdAt: string;
    /** Last change of the text; null while the note was never changed */
    updatedAt: string | null;
    /** The requester is the author: only they can change or delete the note */
    editable: boolean;
};
export type AdminInternalNoteCollection = {
    data: AdminInternalNote[];
};
export type AdminInternalNoteInput = {
    /** Text of the note, stored without its surrounding blanks; blank only is refused */
    content: string;
};
export type AdminPlanRates = {
    planId?: PlanId2;
    declarationCost?: number;
    articleCost?: number;
    extraCreditPrice?: number;
    customPricing?: boolean;
    rolloverMonths?: number;
    maxUsers?: number | null;
    envelopeCredits?: number;
};
export type AdminCreditBalance = {
    productId?: string;
    customerId?: string;
    currentBalance?: number;
    lowCountThreshold?: number | null;
};
export type AdminHyperlineSubscription = {
    status: Status8;
    planId: string | null;
    planName: string | null;
    startedAt: string | null;
    nextDueAt: string | null;
    trialEndsSoon: boolean;
    /** Monthly amount including tax, in cents of currency (estimated ARR / 12 and the tax rate of the last invoice); null when Hyperline does not estimate it */
    monthlyAmountIncludingTaxCents: number | null;
    currency: string | null;
};
export type AdminOrganizationSubscriptionResponse = {
    organizationId: string;
    enrolled: boolean;
    enrollmentReason: EnrollmentReason;
    hyperlineBillingEnabled: boolean;
    planId?: PlanId2 | null;
    billingCycle?: BillingCycle | null;
    blockOnExhaustion?: boolean;
    customPricing?: boolean;
    overrides?: {
        declarationCost?: number | null;
        articleCost?: number | null;
        extraCreditPrice?: number | null;
        envelopeCredits?: number | null;
    } | null;
    catalogRates?: (AdminPlanRates) | null;
    effectiveRates?: (AdminPlanRates) | null;
    hyperlineCustomerId?: string | null;
    hyperlineSubscriptionId?: string | null;
    nextRenewalAt?: string | null;
    updatedAt?: string | null;
    updatedBy?: string | null;
    balance?: (AdminCreditBalance) | null;
    /** Hyperline subscription of the organization at the last synchronization of the subscriptions table; null without one */
    hyperlineSubscription?: (AdminHyperlineSubscription) | null;
    /** Ongoing Hyperline subscription while Nabu billing is not active: no credit is debited */
    billingGap?: boolean;
};
export type AdminCreditGiftResponse = {
    credits: number;
    memo?: string | null;
    balance: (AdminCreditBalance) | null;
    expiresAt: string;
};
export type AdminBillingEvent = {
    id: string;
    action: AdminBillingEventAction;
    /** Structured before/after fields. No localized copy. */
    payload: {
        [key: string]: any;
    };
    actorUserId?: string | null;
    /** Display name from user_profile (first + last). Null if unknown. */
    actorUserName?: string | null;
    createdAt: string;
};
export type AdminBillingEventsList = {
    items: AdminBillingEvent[];
};
export type AdminFeatureFlag = {
    id: Uuid;
    /** snake_case key read by the code */
    key: string;
    name: string;
    description: string;
    enabled: boolean;
    roles: ("SUPERADMIN" | "ADMIN" | "MANAGER" | "USER" | "GUEST")[];
    users: {
        uid: Uuid;
        email?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        organizationName?: string | null;
    }[];
    createdAt: string;
    updatedAt: string;
};
export type AdminFeatureFlagList = {
    data: AdminFeatureFlag[];
};
export type AdminFeatureFlagCreation = {
    /** snake_case key read by the code */
    key: string;
    name: string;
    description?: string;
};
export type AdminFeatureFlagAuditEvent = {
    id: string;
    action: Action2;
    /** Changed fields only: { field: { before, after } }; targeted users as emails */
    changes: {
        [key: string]: any;
    };
    flag: {
        id: Uuid;
        key?: string | null;
        name?: string | null;
    };
    /** Null when the user of the author was deleted */
    actor: {
        uid: Uuid;
        firstName?: string | null;
        lastName?: string | null;
        email?: string | null;
    } | null;
    createdAt: string;
};
export type AdminFeatureFlagAuditEventList = {
    data: AdminFeatureFlagAuditEvent[];
};
export type AdminFeatureFlagUpdate = {
    enabled?: boolean;
    roles?: ("SUPERADMIN" | "ADMIN" | "MANAGER" | "USER" | "GUEST")[];
    userIds?: Uuid[];
    name?: string;
    description?: string;
};
export type ProductTourUserState = {
    status: Status9;
    tourVersion: number;
} | null;
export type ProductTourPublic = {
    id: Uuid;
    key: string;
    version: number;
    contextKey: string;
    autoStart: boolean;
    title: string;
    state: ProductTourUserState;
    steps: {
        id: string;
        anchor: string | null;
        /** Action to open before the step; null for none. */
        action: string | null;
        placement: ProductTourPlacement;
        title: string;
        body: string;
    }[];
};
export type ProductTourPublicList = {
    data: ProductTourPublic[];
};
export type ProductTourStateUpdate = {
    status: Status9;
};
export type ProductTourI18N = {
    fr?: {
        title?: string;
    };
    en?: {
        title?: string;
    };
    de?: {
        title?: string;
    };
};
export type ProductTourStepI18N = {
    fr?: {
        title?: string;
        body?: string;
    };
    en?: {
        title?: string;
        body?: string;
    };
    de?: {
        title?: string;
        body?: string;
    };
};
export type ProductTourStep = {
    id: string;
    /** Anchor id of the webapp registry; null for a centred card. Not checked by the gateway. */
    anchor: string | null;
    /** Action id of the webapp registry, opened before the step (tab, panel) and closed after it; absent or null for none. Not checked by the gateway. TEC-1631. */
    action?: string | null;
    placement: ProductTourPlacement;
    i18n: ProductTourStepI18N;
};
export type ProductTourSteps = ProductTourStep[];
export type ProductTourPublishedContent = {
    contextKey: string;
    autoStart: boolean;
    targetRoles: ("SUPERADMIN" | "ADMIN" | "MANAGER" | "USER" | "GUEST")[];
    featureFlagKey: string | null;
    i18n: ProductTourI18N;
    steps: ProductTourSteps;
} | null;
export type ProductTourAuthor = {
    id: Uuid;
    email?: string | null;
    firstName?: string | null;
    lastName?: string | null;
} | null;
export type ProductTourStaff = {
    id: Uuid;
    key: string;
    name: string;
    contextKey: string;
    /** DRAFT: never published; ONLINE: published and enabled; DISABLED: published, not enabled. */
    status: Status10;
    enabled: boolean;
    /** The draft differs from the published snapshot. */
    hasUnpublishedChanges: boolean;
    published: ProductTourPublishedContent;
    updatedBy: ProductTourAuthor;
    autoStart: boolean;
    targetRoles: ("SUPERADMIN" | "ADMIN" | "MANAGER" | "USER" | "GUEST")[];
    featureFlagKey: string | null;
    i18n: ProductTourI18N;
    steps: ProductTourSteps;
    version: number;
    relaunchedAt: string | null;
    publishedAt: string | null;
    publishedBy: string | null;
    createdAt: string;
    updatedAt: string;
    /** Users who completed or dismissed the tour, states before the last relaunch excluded. */
    stats: {
        completed: number;
        dismissed: number;
    };
};
export type ProductTourStaffList = {
    data: ProductTourStaff[];
};
export type ProductTourContextKey = string;
export type ProductTourRoles = ("SUPERADMIN" | "ADMIN" | "MANAGER" | "USER" | "GUEST")[];
export type ProductTourFeatureFlagKey = string | null;
export type ProductTourCreation = {
    /** snake_case key, cannot change */
    key: string;
    /** Internal name, console only */
    name: string;
    contextKey: ProductTourContextKey;
    autoStart?: boolean;
    targetRoles?: ProductTourRoles;
    featureFlagKey?: ProductTourFeatureFlagKey;
    i18n?: ProductTourI18N;
    steps?: ProductTourSteps;
};
export type ProductTourUpdate = {
    name?: string;
    contextKey?: ProductTourContextKey;
    autoStart?: boolean;
    targetRoles?: ProductTourRoles;
    featureFlagKey?: ProductTourFeatureFlagKey;
    i18n?: ProductTourI18N;
    steps?: ProductTourSteps;
};
export type ProductTourEnabledUpdate = {
    enabled: boolean;
};
export type AdminNpsSummary = {
    responseCount: number;
    responsesWithComment: number;
    promoters: number;
    passives: number;
    detractors: number;
    /** % promoters − % detractors, rounded half away from zero; null without response */
    score: number | null;
    averageScore: number | null;
    distribution: {
        score: number;
        count: number;
        category: NpsCategory;
    }[];
    respondentCount: number;
    userProfiles: {
        promoter: number;
        passive: number;
        detractor: number;
    };
};
export type AdminNpsUserProfile = {
    category: NpsCategory;
    average: number;
    responseCount: number;
};
export type AdminNpsResponse = {
    id: Uuid;
    score: number;
    category: NpsCategory;
    comment: string | null;
    createdAt: string;
    batchImport: {
        id: Uuid;
        referenceNabu: string | null;
    };
    user: {
        uid: Uuid;
        email: string;
        firstName: string | null;
        lastName: string | null;
        organizationName: string | null;
    };
    userProfile: AdminNpsUserProfile;
    tagIds: Uuid[];
};
export type AdminNpsTag = {
    id: Uuid;
    name: string;
    color: string;
};
export type AdminNps = {
    summary: AdminNpsSummary;
    responses: AdminNpsResponse[];
    tags: AdminNpsTag[];
};
export type AdminNpsTagCreation = {
    name: string;
};
export type AdminAiConsumptionModelCost = {
    /** Normalized model id; null when unknown */
    model: string | null;
    provider: string | null;
    /** USD, priced calls only */
    costUsd: number;
    calls: number;
    /** Calls whose model has no price: their cost is unknown, not zero */
    unpricedCalls: number;
};
export type AdminAiConsumptionSummary = {
    /** Sum of the five steps and of the calls outside any dossier; USD, priced calls only */
    costUsd: number;
    /** Calls whose model has no price: their cost is unknown, not zero */
    unpricedCalls: number;
    calls: number;
    errors: number;
    tokens: number;
    /** Dossiers with at least one call in the period, deleted ones included */
    dossiers: number;
    /** Cost of the dossiers / dossiers; null without dossier */
    costPerDossierUsd: number | null;
    /** Calls attached to a dossier / dossiers; null without dossier */
    callsPerDossier: number | null;
    costByProvider: {
        provider: string | null;
        /** USD, priced calls only */
        costUsd: number;
        calls: number;
    }[];
    costByModel: AdminAiConsumptionModelCost[];
    keptValues: {
        /** Unweighted average of the measured dossiers; null without any */
        averageRate: number | null;
        measuredDossiers: number;
        autoDossiers: number;
    };
    /** Calls attached to no dossier (form tools) */
    outsideDossier: {
        /** USD, priced calls only */
        costUsd: number;
        calls: number;
        errors: number;
        /** Calls whose model has no price: their cost is unknown, not zero */
        unpricedCalls: number;
    };
};
export type AdminAiConsumptionStageCost = {
    stage: string;
    /** USD, priced calls only */
    costUsd: number;
    unpricedCalls: number;
    calls: number;
    errors: number;
};
export type AdminAiConsumptionStep = {
    step: AdminAiConsumptionStepKey;
    /** USD, priced calls only */
    costUsd: number;
    /** Calls whose model has no price: their cost is unknown, not zero */
    unpricedCalls: number;
    calls: number;
    errors: number;
    /** Dossiers with a call of this step in the period */
    dossiers: number;
    tokens: number;
    /** Sum of the call durations */
    durationMs: number;
    /** Unknown models excluded */
    byModel: {
        model: string;
        /** USD, priced calls only */
        costUsd: number;
        calls: number;
    }[];
    /** Sub-steps of the step, by cost: for ai, chat (Assistant Nabu) and transcription (its dictation) */
    byStage: AdminAiConsumptionStageCost[];
};
export type AdminAiConsumptionKeptValues = {
    /** On the current declarations, by priority: measured (validated by a user, with proposed values), auto (validated by the system, out of the average), unmeasured (validated or sent without measure), pending (none validated), none (no declaration) */
    status: Status11;
    /** kept / proposed over the measured declarations; null unless measured */
    rate: number | null;
    /** Values proposed by the pipeline, measured declarations only */
    proposed: number;
    /** Values sent as proposed, measured declarations only */
    kept: number;
    /** Current declarations validated or sent */
    validatedDeclarations: number;
    /** Current declarations */
    declarations: number;
};
export type AdminAiConsumptionCell = {
    /** USD, priced calls only */
    costUsd: number;
    /** Calls whose model has no price: their cost is unknown, not zero */
    unpricedCalls: number;
    /** Input (cache included) + output (reasoning included) */
    tokens: number;
    calls: number;
    errors: number;
    /** Distinct pieces: files (split), documents (read), passes (match, complete), conversations (ai) */
    pieces: number;
    /** Sum of the call durations */
    durationMs: number;
    /** Normalized model ids, unknown models excluded */
    models: string[];
    /** By normalized model and provider, unknown models included, by cost: grouped like summary.costByModel, so the console can total the filtered rows */
    byModel: AdminAiConsumptionModelCost[];
    /** ai step only, by cost: chat (Assistant Nabu) and transcription (its dictation); null for the other steps, whose stages stay on the step */
    byStage: AdminAiConsumptionStageCost[] | null;
} | null;
export type AdminAiConsumptionDossier = {
    id: Uuid;
    referenceNabu: string | null;
    /** soft: deleted from the app (deleted_at); hard: the dossier no longer exists */
    deleted: Deleted;
    /** Organization of the dossier group; null when deleted for good */
    organizationId: string | null;
    /** Group of the dossier; null for the root group of its organization */
    agencyId: string | null;
    /** Current owner of the dossier */
    userId: string | null;
    /** Creation of the dossier, not the date of its calls (TEC-1763); null when deleted for good */
    createdAt: string | null;
    /** USD, priced calls only */
    costUsd: number;
    /** Calls whose model has no price: their cost is unknown, not zero */
    unpricedCalls: number;
    tokens: number;
    calls: number;
    errors: number;
    /** Calls of the dossier outside the period, not counted */
    outsidePeriod: {
        calls: number;
        /** USD, priced calls only */
        costUsd: number;
        steps: AdminAiConsumptionStepKey[];
    };
    keptValues: AdminAiConsumptionKeptValues;
    steps: {
        split: AdminAiConsumptionCell;
        read: AdminAiConsumptionCell;
        match: AdminAiConsumptionCell;
        complete: AdminAiConsumptionCell;
        ai: AdminAiConsumptionCell;
    };
};
export type AdminAiConsumption = {
    "from": string;
    to: string;
    /** First recorded call, all periods; null if none */
    measuredSince: string | null;
    /** Each call cost is frozen at the price of its day */
    pricing: {
        currency: Currency;
        /** Price lists used by the priced calls of the period, oldest first */
        asOf: string[];
        /** Price list applied to the new calls */
        current: {
            asOf: string;
            models: {
                model: string;
                provider: string;
                inputUsdPerMTok: number;
                cachedInputUsdPerMTok: number;
                /** null: billed as input */
                cacheWriteUsdPerMTok: number | null;
                outputUsdPerMTok: number;
            }[];
        };
    };
    summary: AdminAiConsumptionSummary;
    /** Always the five steps, in this order: split, read, match, complete, ai */
    steps: AdminAiConsumptionStep[];
    organizations: {
        id: Uuid;
        name: string;
    }[];
    agencies: {
        id: Uuid;
        name: string;
        organizationId: Uuid;
    }[];
    users: {
        id: Uuid;
        name: string | null;
        email: string | null;
    }[];
    /** Normalized ids of the models called for the dossiers of the period */
    models: string[];
    /** Dossiers with at least one call in the period, most expensive first */
    dossiers: AdminAiConsumptionDossier[];
};
export type AdminOrganizationAiAssistant = {
    enabled: boolean;
    monthlyCapUsd: number;
    monthSpentUsd: number;
    /** UTC calendar month of the spending */
    month: string;
    /** disabled wins over quota_reached */
    status: Status12;
};
export type AuthzCatalogue = {
    /** 12 premiers caractères hexadécimaux du SHA-256 du catalogue et de tous ses libellés, quelle que soit la langue. */
    version: string;
    lang: Lang;
    modules: {
        code: string;
        label: string;
    }[];
    /** Un titre de groupe par préfixe d'action (flux pour flux.create). */
    resources: {
        code: string;
        label: string;
    }[];
    actions: {
        code: string;
        "module": string;
        /** Pour l'affichage seulement, jamais pour décider. */
        accessLevel: string;
        label: string;
    }[];
    capacities: {
        code: string;
        "module": string;
        label: string;
        description: string;
        actions: string[];
    }[];
    presets: {
        code: string;
        /** 1 pour le rôle le plus restreint. */
        rank: number;
        label: string;
        description: string;
        capacities: string[];
    }[];
};
export type AuthzCapacityCopies = {
    [key: string]: string[];
};
export type AuthzOrgRole = {
    id: Uuid;
    name: string;
    sourcePreset: SourcePreset;
    capacities: string[];
    capacityCopies: AuthzCapacityCopies;
    createdAt: string;
    updatedAt: string;
};
export type AuthzRoleDefinition = {
    name: string;
    sourcePreset: SourcePreset;
    /** Capacités Nabu suivies telles quelles. */
    capacities: string[];
    capacityCopies: AuthzCapacityCopies;
};
export type AuthzRolePatch = {
    name?: string;
    capacities?: string[];
    capacityCopies?: AuthzCapacityCopies;
};
export type AuthzRoleRef = {
    preset?: Preset | null;
    roleId?: string | null;
};
export type AuthzMoveHoldersRequest = {
    "from": AuthzRoleRef;
    userIds: Uuid[];
};
export type AuthzGrant = {
    id: Uuid;
    userId: Uuid;
    groupId: Uuid;
    preset: Preset | null;
    roleId: string | null;
    includeDescendants: boolean;
    validFrom: string | null;
    validUntil: string | null;
    origin: Origin;
    createdAt: string;
};
export type AuthzGrantRequest = {
    userId: Uuid;
    preset?: Preset | null;
    roleId?: string | null;
    /** Un accès par agence. */
    groupIds: Uuid[];
    includeDescendants: boolean;
    validFrom?: string | null;
    validUntil?: string | null;
};
/**
 * KeepAlive endpoint
 */
export function callKeepAlive(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText("/", {
        ...opts
    }));
}
/**
 * Retrieve all the member resources of the Organization collection resource in the response body.
 */
export function findOrganization({ page, size, orderBy, reverse }: {
    page?: number;
    size?: number;
    orderBy?: string[];
    reverse?: string[];
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            paging?: Paging;
            data?: Organization[];
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/organizations${QS.query(QS.explode({
        page,
        size,
        orderBy,
        reverse
    }))}`, {
        ...opts
    }));
}
/**
 * Creates a new Organization.
 */
export function createOrganization(partialOrganization: PartialOrganization, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: Organization;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>("/organizations", oazapfts.json({
        ...opts,
        method: "POST",
        body: partialOrganization
    })));
}
/**
 * Retrieve all the member resources of the Organization collection resource in the response body.
 */
export function searchOffice({ page, size, search, role }: {
    page?: number;
    size?: number;
    search?: string;
    role?: "DEP" | "DES" | "GUA" | "TRA" | "";
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            data?: Office[];
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/public-search/offices${QS.query(QS.explode({
        page,
        size,
        search,
        role
    }))}`, {
        ...opts
    }));
}
/**
 * Retrieve all the member resources of the Organization collection resource in the response body.
 */
export function searchRegimeDouanier($type: "all" | "regdou" | "compcom" | "regdoupre", { flux, regdou, compcom, regdoupre, locale }: {
    flux?: ("IMPORT" | "EXPORT" | "TRANSIT") | null;
    regdou?: string | null;
    compcom?: string | null;
    regdoupre?: string | null;
    locale?: string | null;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            data?: Selector[];
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/public-search/regime-douaniers/${encodeURIComponent($type)}${QS.query(QS.explode({
        flux,
        regdou,
        compcom,
        regdoupre,
        locale
    }))}`, {
        ...opts
    }));
}
/**
 * Retrieve a member resource of the Organization resources in the response body.
 */
export function findOneOrganization(oid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: Organization;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/organizations/${encodeURIComponent(oid)}`, {
        ...opts
    }));
}
/**
 * Complete update of a Organization.
 */
export function completeUpdateOrganization(oid: Uuid, partialOrganization: PartialOrganization, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: Organization;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/organizations/${encodeURIComponent(oid)}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: partialOrganization
    })));
}
/**
 * Partial update of a Organization.
 */
export function partialUpdateOrganization(oid: Uuid, partialOrganization: PartialOrganization, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: Organization;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/organizations/${encodeURIComponent(oid)}`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: partialOrganization
    })));
}
/**
 * Delete a member resource of the Organization resources.
 */
export function deleteOneOrganization(oid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/organizations/${encodeURIComponent(oid)}`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * Retrieve a member resource of the CompanyRegistrationNumber resources in the response body.
 */
export function findOneCompanyRegistrationNumber(crnid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: CompanyRegistrationNumber;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/company-registration-numbers/${encodeURIComponent(crnid)}`, {
        ...opts
    }));
}
/**
 * Partial update of a CompanyRegistrationNumber.
 */
export function partialUpdateCompanyRegistrationNumber(crnid: Uuid, partialCompanyRegistrationNumber: PartialCompanyRegistrationNumber, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: CompanyRegistrationNumber;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/company-registration-numbers/${encodeURIComponent(crnid)}`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: partialCompanyRegistrationNumber
    })));
}
/**
 * Retrieve all the member resources of the User collection resource in the response body.
 */
export function findUser({ page, size, orderBy, reverse }: {
    page?: number;
    size?: number;
    orderBy?: string[];
    reverse?: string[];
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            paging?: Paging;
            data?: User[];
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/users${QS.query(QS.explode({
        page,
        size,
        orderBy,
        reverse
    }))}`, {
        ...opts
    }));
}
/**
 * Creates a new User.
 */
export function createUser(partialUser: PartialUser, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: CreatedUser;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>("/users", oazapfts.json({
        ...opts,
        method: "POST",
        body: partialUser
    })));
}
/**
 * Retrieve a member resource of the User resources in the response body.
 */
export function findOneUser(uid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: User;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/users/${encodeURIComponent(uid)}`, {
        ...opts
    }));
}
/**
 * Complete update of a User.
 */
export function completeUpdateUser(uid: Uuid, partialUser: PartialUser, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: User;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/users/${encodeURIComponent(uid)}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: partialUser
    })));
}
/**
 * Partial update of a User.
 */
export function partialUpdateUser(uid: Uuid, partialUser: PartialUser, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: User;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/users/${encodeURIComponent(uid)}`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: partialUser
    })));
}
/**
 * Delete a member resource of the User resources.
 */
export function deleteOneUser(uid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/users/${encodeURIComponent(uid)}`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * Get email notification preferences for a user. Accessible by the user themselves or a SUPERADMIN.
 */
export function findUserNotificationPreferences(uid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: UserNotificationPreferences;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/users/${encodeURIComponent(uid)}/notification-preferences`, {
        ...opts
    }));
}
/**
 * Partially update email notification preferences for a user. Accessible by the user themselves or a SUPERADMIN.
 */
export function patchUserNotificationPreferences(uid: Uuid, patchUserNotificationPreferencesPayload: PatchUserNotificationPreferencesPayload, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: UserNotificationPreferences;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/users/${encodeURIComponent(uid)}/notification-preferences`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: patchUserNotificationPreferencesPayload
    })));
}
/**
 * Get UI preferences for a user. Accessible by the user themselves or a SUPERADMIN.
 */
export function findUserUiPreferences(uid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: UserUiPreferences;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/users/${encodeURIComponent(uid)}/ui-preferences`, {
        ...opts
    }));
}
/**
 * Partially update UI preferences for a user. Accessible by the user themselves or a SUPERADMIN.
 */
export function patchUserUiPreferences(uid: Uuid, patchUserUiPreferencesPayload: PatchUserUiPreferencesPayload, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: UserUiPreferences;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/users/${encodeURIComponent(uid)}/ui-preferences`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: patchUserUiPreferencesPayload
    })));
}
/**
 * Retrieve all the member resources of the User Setting Key collection resource in the response body.
 */
export function findUserSettingKeys(uid: Uuid, locale: "fr" | "en", { page, size, orderBy, reverse }: {
    page?: number;
    size?: number;
    orderBy?: string[];
    reverse?: string[];
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: UserSettingKey[];
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/users/${encodeURIComponent(uid)}/settings${QS.query(QS.explode({
        locale,
        page,
        size,
        orderBy,
        reverse
    }))}`, {
        ...opts
    }));
}
/**
 * Update all user setting keys
 */
export function updateUserSettingKeys(uid: Uuid, userSettingKeyUpdatePayload: UserSettingKeyUpdatePayload, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/users/${encodeURIComponent(uid)}/settings`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: userSettingKeyUpdatePayload
    })));
}
/**
 * Retrieve all the member resources of the User Setting Key collection resource in the response body.
 */
export function findUserSettingKey(uid: Uuid, { page, size, orderBy, reverse }: {
    page?: number;
    size?: number;
    orderBy?: string[];
    reverse?: string[];
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            paging?: Paging;
            data?: UserSettingKey[];
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/users/${encodeURIComponent(uid)}/setting-keys${QS.query(QS.explode({
        page,
        size,
        orderBy,
        reverse
    }))}`, {
        ...opts
    }));
}
/**
 * Creates a new SettingKey.
 */
export function createUserSettingKey(uid: Uuid, partialUserSettingKey: PartialUserSettingKey, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: UserSettingKey;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/users/${encodeURIComponent(uid)}/setting-keys`, oazapfts.json({
        ...opts,
        method: "POST",
        body: partialUserSettingKey
    })));
}
/**
 * Send - resend Invitation.
 */
export function sendInvitationEmail(uid: Uuid, body?: {
    uid?: Uuid;
}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/users/${encodeURIComponent(uid)}/send-invitation-email`, oazapfts.json({
        ...opts,
        method: "POST",
        body
    })));
}
/**
 * Send - resend Invitation.
 */
export function batchSendInvitationEmail(body: {
    /** List of User Ids */
    userIds?: Uuid[];
}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            uid?: Uuid;
            /** Email has been sent */
            isSent?: boolean;
        }[];
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>("/users/batch-invitation-email", oazapfts.json({
        ...opts,
        method: "POST",
        body
    })));
}
/**
 * Retrieve a member resource of the User Setting Key resources in the response body.
 */
export function findOneUserSettingKey(uid: Uuid, muskid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: UserSettingKey;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/users/${encodeURIComponent(uid)}/setting-keys/${encodeURIComponent(muskid)}`, {
        ...opts
    }));
}
/**
 * Partial update of a SettingKey.
 */
export function partialUpdateUserSettingKey(uid: Uuid, muskid: Uuid, partialUserSettingKey: PartialUserSettingKey, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: UserSettingKey;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/users/${encodeURIComponent(uid)}/setting-keys/${encodeURIComponent(muskid)}`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: partialUserSettingKey
    })));
}
/**
 * Delete a member resource of the User Setting Key resources.
 */
export function deleteOneUserSettingKey(uid: Uuid, muskid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/users/${encodeURIComponent(uid)}/setting-keys/${encodeURIComponent(muskid)}`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * Retrieve all the member resources of the Group collection resource in the response body.
 */
export function findGroup({ page, size, orderBy, reverse }: {
    page?: number;
    size?: number;
    orderBy?: string[];
    reverse?: string[];
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            paging?: Paging;
            data?: Group[];
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/groups${QS.query(QS.explode({
        page,
        size,
        orderBy,
        reverse
    }))}`, {
        ...opts
    }));
}
/**
 * Creates a new Group.
 */
export function createGroup(groupCreationPayload: GroupCreationPayload, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: Group;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>("/groups", oazapfts.json({
        ...opts,
        method: "POST",
        body: groupCreationPayload
    })));
}
/**
 * Retrieve a member resource of the Group resources in the response body.
 */
export function findOneGroup(gid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: Group;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/groups/${encodeURIComponent(gid)}`, {
        ...opts
    }));
}
/**
 * Complete update of a Group.
 */
export function completeUpdateGroup(gid: Uuid, partialGroup: PartialGroup, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: Group;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/groups/${encodeURIComponent(gid)}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: partialGroup
    })));
}
/**
 * Partial update of a Group.
 */
export function partialUpdateGroup(gid: Uuid, partialGroup: PartialGroup, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: Group;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/groups/${encodeURIComponent(gid)}`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: partialGroup
    })));
}
/**
 * Delete a member resource of the Group resources.
 */
export function deleteOneGroup(gid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/groups/${encodeURIComponent(gid)}`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * Informations on all member resources of the Group collection resource in the response header.
 */
export function findGroupChildren(gid: Uuid, { page, size, orderBy, reverse }: {
    page?: number;
    size?: number;
    orderBy?: string[];
    reverse?: string[];
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            paging?: Paging;
            data?: Group[];
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/groups/${encodeURIComponent(gid)}/children${QS.query(QS.explode({
        page,
        size,
        orderBy,
        reverse
    }))}`, {
        ...opts
    }));
}
/**
 * Retrieve a member resource of the Group resources in the response body.
 */
export function findOneGroupChildren(gid: Uuid, mgid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: Group;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/groups/${encodeURIComponent(gid)}/children/${encodeURIComponent(mgid)}`, {
        ...opts
    }));
}
/**
 * Complete update of a Group.
 */
export function completeUpdateGroupChildren(gid: Uuid, mgid: Uuid, partialGroup: PartialGroup, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: Group;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/groups/${encodeURIComponent(gid)}/children/${encodeURIComponent(mgid)}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: partialGroup
    })));
}
/**
 * Partial update of a Group.
 */
export function partialUpdateGroupChildren(gid: Uuid, mgid: Uuid, partialGroup: PartialGroup, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: Group;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/groups/${encodeURIComponent(gid)}/children/${encodeURIComponent(mgid)}`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: partialGroup
    })));
}
/**
 * Delete a member resource of the Group resources.
 */
export function deleteOneGroupChildren(gid: Uuid, mgid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/groups/${encodeURIComponent(gid)}/children/${encodeURIComponent(mgid)}`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * Informations on all member resources of the SettingKey collection resource in the response header.
 */
export function findGroupSettings(gid: Uuid, { page, size, orderBy, reverse }: {
    page?: number;
    size?: number;
    orderBy?: string[];
    reverse?: string[];
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            paging?: Paging;
            data?: SettingKey[];
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/groups/${encodeURIComponent(gid)}/settings${QS.query(QS.explode({
        page,
        size,
        orderBy,
        reverse
    }))}`, {
        ...opts
    }));
}
/**
 * Creates a new SettingKey.
 */
export function createGroupSettings(gid: Uuid, partialSettingKey: PartialSettingKey, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: SettingKey;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/groups/${encodeURIComponent(gid)}/settings`, oazapfts.json({
        ...opts,
        method: "POST",
        body: partialSettingKey
    })));
}
/**
 * Informations on all member resources of the SettingKey collection resource in the response header.
 */
export function findGroupSettingKeys(gid: Uuid, locale: "fr" | "en", { page, size, orderBy, reverse }: {
    page?: number;
    size?: number;
    orderBy?: string[];
    reverse?: string[];
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: GroupSettingKey[];
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/groups/${encodeURIComponent(gid)}/setting-keys${QS.query(QS.explode({
        locale,
        page,
        size,
        orderBy,
        reverse
    }))}`, {
        ...opts
    }));
}
/**
 * Update all group setting keys
 */
export function updateGroupSettingKeys(gid: Uuid, body: SettingKeyUpdatePayload[], opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/groups/${encodeURIComponent(gid)}/setting-keys`, oazapfts.json({
        ...opts,
        method: "PUT",
        body
    })));
}
/**
 * Retrieve all API keys for a group. Returns only fingerprints, never the full public key.
 */
export function getGroupApiKeys(gid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            data?: GroupApiKey[];
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/groups/${encodeURIComponent(gid)}/api-keys`, {
        ...opts
    }));
}
/**
 * Create a new API key for a group
 */
export function createApiKey(gid: Uuid, createGroupApiKeyPayload: CreateGroupApiKeyPayload, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: {
            automationGroupId?: string;
            s3UploadUrl?: string;
            s3ObjectKey?: string;
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/groups/${encodeURIComponent(gid)}/api-keys`, oazapfts.json({
        ...opts,
        method: "POST",
        body: createGroupApiKeyPayload
    })));
}
/**
 * Delete an API key for a group
 */
export function deleteOneApiKey(gid: Uuid, keyId: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/groups/${encodeURIComponent(gid)}/api-keys/${encodeURIComponent(keyId)}`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * Informations on all member resources of the User collection resource in the response header.
 */
export function findGroupMembers(gid: Uuid, { page, size, orderBy, reverse }: {
    page?: number;
    size?: number;
    orderBy?: string[];
    reverse?: string[];
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            paging?: Paging;
            data?: User[];
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/groups/${encodeURIComponent(gid)}/members${QS.query(QS.explode({
        page,
        size,
        orderBy,
        reverse
    }))}`, {
        ...opts
    }));
}
/**
 * Creates a new User.
 */
export function createGroupMembers(gid: Uuid, partialUser: PartialUser, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: CreatedUser;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/groups/${encodeURIComponent(gid)}/members`, oazapfts.json({
        ...opts,
        method: "POST",
        body: partialUser
    })));
}
/**
 * Retrieve a member resource of the User resources in the response body.
 */
export function findOneGroupMembers(gid: Uuid, muid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: User;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/groups/${encodeURIComponent(gid)}/members/${encodeURIComponent(muid)}`, {
        ...opts
    }));
}
/**
 * Complete update of a User.
 */
export function completeUpdateGroupMembers(gid: Uuid, muid: Uuid, partialUser: PartialUser, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: User;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/groups/${encodeURIComponent(gid)}/members/${encodeURIComponent(muid)}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: partialUser
    })));
}
/**
 * Partial update of a User.
 */
export function partialUpdateGroupMembers(gid: Uuid, muid: Uuid, partialUser: PartialUser, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: User;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/groups/${encodeURIComponent(gid)}/members/${encodeURIComponent(muid)}`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: partialUser
    })));
}
/**
 * Delete a member resource of the User resources.
 */
export function deleteOneGroupMembers(gid: Uuid, muid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/groups/${encodeURIComponent(gid)}/members/${encodeURIComponent(muid)}`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * Retrieve all the member resources of the BatchImport collection resource in the response body.
 */
export function findBatchImport({ view, page, size, orderBy, reverse }: {
    view?: "minimal" | "list";
    page?: number;
    size?: number;
    orderBy?: string[];
    reverse?: string[];
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            paging?: Paging;
            data?: BatchImport[];
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/batch-imports${QS.query(QS.explode({
        view,
        page,
        size,
        orderBy,
        reverse
    }))}`, {
        ...opts
    }));
}
/**
 * Creates a new BatchImport.
 */
export function createBatchImport(partialBatchImport: PartialBatchImport, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: BatchImport;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>("/batch-imports", oazapfts.json({
        ...opts,
        method: "POST",
        body: partialBatchImport
    })));
}
/**
 * Batch validation progress for list/search views. Call after loading batch imports to populate progress indicators without slowing search.
 */
export function postBatchImportsValidationProgress(batchImportValidationProgressRequest: BatchImportValidationProgressRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: BatchImportValidationProgressResponse;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    } | {
        status: number;
    }>("/batch-imports/validation-progress", oazapfts.json({
        ...opts,
        method: "POST",
        body: batchImportValidationProgressRequest
    })));
}
/**
 * Retrieve a member resource of the BatchImport resources in the response body.
 */
export function findOneBatchImport(fbid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: BatchImport;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/batch-imports/${encodeURIComponent(fbid)}`, {
        ...opts
    }));
}
/**
 * Complete update of a BatchImport.
 */
export function completeUpdateBatchImport(fbid: Uuid, partialBatchImport: PartialBatchImport, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: BatchImport;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/batch-imports/${encodeURIComponent(fbid)}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: partialBatchImport
    })));
}
/**
 * Partial update of a BatchImport.
 */
export function partialUpdateBatchImport(fbid: Uuid, partialUpdateBatchImport: PartialUpdateBatchImport, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: BatchImport;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/batch-imports/${encodeURIComponent(fbid)}`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: partialUpdateBatchImport
    })));
}
/**
 * Delete a member resource of the BatchImport resources.
 */
export function deleteOneBatchImport(fbid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/batch-imports/${encodeURIComponent(fbid)}`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * Duplicate batch imports
 */
export function transferBatchImport(body: {
    userId?: Uuid;
    groupId?: Uuid;
}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText("/batch-imports/transfer", oazapfts.json({
        ...opts,
        method: "POST",
        body
    })));
}
/**
 * Replace the list of tags associated with the batch import.
 */
export function setBatchImportTags(batchImportId: Uuid, body: {
    tagIds: Uuid[];
}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/batch-imports/${encodeURIComponent(batchImportId)}/tags`, oazapfts.json({
        ...opts,
        method: "PUT",
        body
    })));
}
/**
 * Duplicate batch imports
 */
export function duplicateBatchImportByFbid(fbid: Uuid, body?: {
    userId?: Uuid;
    groupId?: Uuid;
} | null, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: {
            batchImportId?: Uuid;
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/batch-imports/${encodeURIComponent(fbid)}/duplicate`, oazapfts.json({
        ...opts,
        method: "POST",
        body
    })));
}
/**
 * Informations on all member resources of the Document collection resource in the response header.
 */
export function findBatchImportDocuments(fbid: Uuid, { page, size, orderBy, reverse, declarationId }: {
    page?: number;
    size?: number;
    orderBy?: string[];
    reverse?: string[];
    declarationId?: Uuid;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            paging?: Paging;
            data?: Document[];
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/batch-imports/${encodeURIComponent(fbid)}/documents${QS.query(QS.explode({
        page,
        size,
        orderBy,
        reverse,
        declarationId
    }))}`, {
        ...opts
    }));
}
/**
 * Add comment to batch import
 */
export function addBatchImportComment(fbid: Uuid, body?: {
    comment?: string;
    /** Whether the comment should be treated as urgent */
    isUrgent?: boolean | null;
}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: {
            batchImportId?: Uuid;
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/batch-imports/${encodeURIComponent(fbid)}/comments`, oazapfts.json({
        ...opts,
        method: "POST",
        body
    })));
}
/**
 * Submit declaration feedback: score 0-10 (NPS, TEC-1704) or the legacy rating 1-5 still sent by a webapp that has not switched, and/or a comment. One feedback per batch import.
 */
export function submitBatchImportQualityFeedback(fbid: Uuid, submitExtractionQualityFeedbackPayload: SubmitExtractionQualityFeedbackPayload, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: {
            data: ExtractionQualityFeedback;
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/batch-imports/${encodeURIComponent(fbid)}/quality-feedback`, oazapfts.json({
        ...opts,
        method: "POST",
        body: submitExtractionQualityFeedbackPayload
    })));
}
/**
 * Update BatchImport comment
 */
export function updateBatchImportComment(fbid: Uuid, id: Uuid, body: {
    comment?: string;
    /** Whether the comment should be treated as urgent */
    isUrgent?: boolean | null;
} | null, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: BatchImportComment[];
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/batch-imports/${encodeURIComponent(fbid)}/comments/${encodeURIComponent(id)}`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body
    })));
}
/**
 * Delete BatchImport comment
 */
export function deleteBatchImportComment(fbid: Uuid, id: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/batch-imports/${encodeURIComponent(fbid)}/comments/${encodeURIComponent(id)}`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * Configure batch import
 */
export function configureBatchImport(fbid: Uuid, batchImportConfigurationPayload: BatchImportConfigurationPayload, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: Document[];
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/batch-imports/${encodeURIComponent(fbid)}/configure`, oazapfts.json({
        ...opts,
        method: "POST",
        body: batchImportConfigurationPayload
    })));
}
/**
 * Change the flux (model) of an agentic batch import without reprocessing: the merged settings are re-applied to every current declaration as one revertible apply_settings gesture; corrected, locked or validated fields are kept (TEC-1792).
 */
export function updateBatchImportFlux(fbid: Uuid, body: {
    /** The new flux, or null to remove it */
    fluxId: string | null;
}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            declarations: {
                id: Uuid;
                changed: number;
                kept: number;
            }[];
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/batch-imports/${encodeURIComponent(fbid)}/flux`, oazapfts.json({
        ...opts,
        method: "PUT",
        body
    })));
}
/**
 * Acquire or refresh the edit lock for this batch import (10 min TTL). Returns 409 if another user holds the lock unless force=true.
 */
export function acquireBatchImportEditLock(fbid: Uuid, { force }: {
    force?: boolean;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            expiresAt?: string;
        };
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    }>(`/batch-imports/${encodeURIComponent(fbid)}/lock${QS.query(QS.explode({
        force
    }))}`, {
        ...opts,
        method: "POST"
    }));
}
/**
 * Release the edit lock if held by the current user
 */
export function releaseBatchImportEditLock(fbid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/batch-imports/${encodeURIComponent(fbid)}/lock`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * Retry export for a batch import that has a failed export
 */
export function retryBatchImportExport(fbid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            success?: boolean;
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/batch-imports/${encodeURIComponent(fbid)}/retry-export`, {
        ...opts,
        method: "POST"
    }));
}
/**
 * Retry the delivery of a batch import whose send failed (temporal pipeline). Restarts the workflow at the delivery step; mapping and declaration validation are not replayed.
 */
export function retryBatchImportDelivery(fbid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            retried?: boolean;
        };
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/batch-imports/${encodeURIComponent(fbid)}/retry-delivery`, {
        ...opts,
        method: "POST"
    }));
}
/**
 * Retrieve all the member resources of the BatchImportLog collection resource in the response body.
 */
export function findBatchImportLogs(fbid: Uuid, { orderBy, reverse }: {
    orderBy?: string[];
    reverse?: string[];
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            paging?: Paging;
            data?: BatchImportLog[];
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/batch-imports/${encodeURIComponent(fbid)}/batch-import-logs${QS.query(QS.explode({
        orderBy,
        reverse
    }))}`, {
        ...opts
    }));
}
/**
 * User-facing audit history for a batch import (declaration actions).
 */
export function findBatchImportHistory(fbid: Uuid, { page, size, reverse, q, actionType }: {
    page?: number;
    size?: number;
    reverse?: boolean;
    q?: string;
    actionType?: string;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: BatchImportHistoryCollection;
    } | {
        status: 404;
    }>(`/batch-imports/${encodeURIComponent(fbid)}/history${QS.query(QS.explode({
        page,
        size,
        reverse,
        q,
        actionType
    }))}`, {
        ...opts
    }));
}
/**
 * Flush pending mergeable history entries for a batch import (e.g. end of edit session).
 */
export function flushBatchImportHistoryPending(fbid: Uuid, { actionType }: {
    actionType?: string;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            flushed: number;
        };
    } | {
        status: 404;
    }>(`/batch-imports/${encodeURIComponent(fbid)}/history/flush-pending${QS.query(QS.explode({
        actionType
    }))}`, {
        ...opts,
        method: "POST"
    }));
}
/**
 * Get real-time Temporal workflow progress for a batch import.
 */
export function getBatchImportProgress(fbid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            batchImportId?: string;
            overallStatus?: string;
            currentStep?: string | null;
            files?: {
                fileId?: string;
                status?: string;
                totalPages?: number;
                processedPages?: number;
                documents?: {
                    documentId?: string;
                    status?: string;
                    "type"?: string | null;
                }[];
                skipReason?: string | null;
            }[];
            startedAt?: string;
            updatedAt?: string;
            /** Agentic batches only: what the pipeline read (documents, blocked ones, configuration, parties' countries). */
            agentic?: {
                fileNames?: {
                    [key: string]: string;
                };
                documents?: {
                    documentId?: string;
                    lines?: number;
                }[];
                configuration?: {
                    name?: string;
                    decType?: string | null;
                } | null;
                configurationChosenAutomatically?: boolean;
                sellerCountries?: string[];
                buyerCountries?: string[];
                /** Documents the agentic reading will process (typed, terms and conditions excluded): the denominator of documents read. */
                documentsToRead?: number;
                assembly?: {
                    consignments?: number;
                    backboneKind?: string | null;
                    backboneLabel?: string | null;
                    decidedBy?: string;
                    confidence?: number | null;
                } | null;
            };
        };
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/batch-imports/${encodeURIComponent(fbid)}/workflow/progress`, {
        ...opts
    }));
}
/**
 * Terminate a running or stuck BatchImport workflow.
 */
export function terminateBatchImportWorkflow(fbid: Uuid, body?: {
    reason?: string;
}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            terminated?: boolean;
        };
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 503;
    }>(`/batch-imports/${encodeURIComponent(fbid)}/workflow/terminate`, oazapfts.json({
        ...opts,
        method: "POST",
        body
    })));
}
/**
 * Replay a BatchImport from the beginning: terminates the in-flight workflow, purges documents and pages, then starts a fresh BatchImportWorkflowV2 at file-processing with the files re-read from the database. USER and MANAGER may only relaunch a failed agentic batch import without declaration (and not after a repeated block).
 */
export function resetBatchImportWorkflow(fbid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            replayed?: boolean;
        };
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 503;
    }>(`/batch-imports/${encodeURIComponent(fbid)}/workflow/reset`, {
        ...opts,
        method: "POST"
    }));
}
/**
 * Resume an agentic BatchImport parked in awaiting-configuration with the chosen configuration, at the SAME iteration: already-extracted document facts are reused, only assembly and downstream steps replay.
 */
export function resumeBatchImportWorkflow(fbid: Uuid, body: {
    configurationId: Uuid;
}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            resumed?: boolean;
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/batch-imports/${encodeURIComponent(fbid)}/workflow/resume`, oazapfts.json({
        ...opts,
        method: "POST",
        body
    })));
}
/**
 * Relaunch an agentic BatchImport waiting for the declarant (waiting-human at awaiting-declaration, editable declarations at the batch's iteration) (TEC-1792): change its declaration type (configurationId) and/or read files added by push-addition (fileIds). Starts a NEW iteration where the document facts already read are copied, so no document is read again except the added files. The declarant's corrections are not carried over; the current declarations stay current, read-only, until the new ones are written. Changing the type removes the model (flux). A failed relaunch is resumed by workflow/reset, like a failed first iteration.
 */
export function relaunchBatchImportWorkflow(fbid: Uuid, body?: {
    configurationId?: Uuid;
    fileIds?: Uuid[];
}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            relaunched?: boolean;
            iteration?: number;
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/batch-imports/${encodeURIComponent(fbid)}/workflow/relaunch`, oazapfts.json({
        ...opts,
        method: "POST",
        body
    })));
}
/**
 * Retrieve a member resource of the BatchImportLog resources in the response body.
 */
export function findOneBatchImportLog(fblid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: BatchImportLog;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/batch-import-logs/${encodeURIComponent(fblid)}`, {
        ...opts
    }));
}
/**
 * Complete update of a BatchImportLog.
 */
export function completeUpdateBatchImportLog(fblid: Uuid, partialBatchImportLog: PartialBatchImportLog, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: BatchImportLog;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/batch-import-logs/${encodeURIComponent(fblid)}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: partialBatchImportLog
    })));
}
/**
 * Partial update of a BatchImportLog.
 */
export function partialUpdateBatchImportLog(fblid: Uuid, partialBatchImportLog: PartialBatchImportLog, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: BatchImportLog;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/batch-import-logs/${encodeURIComponent(fblid)}`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: partialBatchImportLog
    })));
}
/**
 * Delete a member resource of the BatchImportLog resources.
 */
export function deleteOneBatchImportLog(fblid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/batch-import-logs/${encodeURIComponent(fblid)}`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * Retrieve all the member resources of the BatchImportFile collection resource in the response body.
 */
export function findBatchImportFile({ page, size, orderBy, reverse }: {
    page?: number;
    size?: number;
    orderBy?: string[];
    reverse?: string[];
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            paging?: Paging;
            data?: BatchImportFile[];
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/batch-import-files${QS.query(QS.explode({
        page,
        size,
        orderBy,
        reverse
    }))}`, {
        ...opts
    }));
}
/**
 * Creates a new BatchImportFile.
 */
export function createBatchImportFile(partialBatchImportFile: PartialBatchImportFile, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: BatchImportFile;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>("/batch-import-files", oazapfts.json({
        ...opts,
        method: "POST",
        body: partialBatchImportFile
    })));
}
/**
 * Retrieve a member resource of the BatchImportFile resources in the response body.
 */
export function findOneBatchImportFile(fuid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: BatchImportFile;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/batch-import-files/${encodeURIComponent(fuid)}`, {
        ...opts
    }));
}
/**
 * Complete update of a BatchImportFile.
 */
export function completeUpdateBatchImportFile(fuid: Uuid, partialBatchImportFile: PartialBatchImportFile, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: BatchImportFile;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/batch-import-files/${encodeURIComponent(fuid)}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: partialBatchImportFile
    })));
}
/**
 * Partial update of a BatchImportFile.
 */
export function partialUpdateBatchImportFile(fuid: Uuid, partialBatchImportFile: PartialBatchImportFile, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: BatchImportFile;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/batch-import-files/${encodeURIComponent(fuid)}`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: partialBatchImportFile
    })));
}
/**
 * Delete a member resource of the BatchImportFile resources.
 */
export function deleteOneBatchImportFile(fuid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/batch-import-files/${encodeURIComponent(fuid)}`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * Retrieve all the member resources of the DataSource collection resource in the response body.
 */
export function findDataSource({ page, size, orderBy, reverse }: {
    page?: number;
    size?: number;
    orderBy?: string[];
    reverse?: string[];
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            paging?: Paging;
            data?: DataSource[];
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/data-sources${QS.query(QS.explode({
        page,
        size,
        orderBy,
        reverse
    }))}`, {
        ...opts
    }));
}
/**
 * Creates a new DataSource.
 */
export function createDataSource(partialDataSource: PartialDataSource, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: DataSource;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>("/data-sources", oazapfts.json({
        ...opts,
        method: "POST",
        body: partialDataSource
    })));
}
/**
 * Retrieve a member resource of the DataSource resources in the response body.
 */
export function findOneDataSource(dsid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: DataSource;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/data-sources/${encodeURIComponent(dsid)}`, {
        ...opts
    }));
}
/**
 * Complete update of a DataSource.
 */
export function completeUpdateDataSource(dsid: Uuid, partialDataSource: PartialDataSource, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: DataSource;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/data-sources/${encodeURIComponent(dsid)}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: partialDataSource
    })));
}
/**
 * Partial update of a DataSource.
 */
export function partialUpdateDataSource(dsid: Uuid, partialDataSource: PartialDataSource, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: DataSource;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/data-sources/${encodeURIComponent(dsid)}`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: partialDataSource
    })));
}
/**
 * Delete a member resource of the DataSource resources.
 */
export function deleteOneDataSource(dsid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/data-sources/${encodeURIComponent(dsid)}`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * List displayable documents
 */
export function findDocuments({ $type, page, size }: {
    $type?: "png" | "json";
    page?: number;
    size?: number;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            data?: {
                documentId?: string;
                index?: number;
                createdAt?: string;
                state?: string;
                batchImportId?: string;
                filename?: string;
                extractionScores?: {
                    extractionScore?: number;
                    extractionSource?: string | null;
                }[];
            }[];
            pagination?: {
                page?: number;
                limit?: number;
                total?: number;
                totalPages?: number;
                hasNext?: boolean;
                hasPrev?: boolean;
            };
        };
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>(`/documents${QS.query(QS.explode({
        "type": $type,
        page,
        size
    }))}`, {
        ...opts
    }));
}
/**
 * Retrieve a member resource of the Document resources in the response body.
 */
export function findOneDocument(pdid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: Document;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/documents/${encodeURIComponent(pdid)}`, {
        ...opts
    }));
}
/**
 * Delete a member resource of the Document resources.
 */
export function deleteOneDocument(pdid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/documents/${encodeURIComponent(pdid)}`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * Retrieve all data sources linked to a given document.
 */
export function findDocumentDataSources(pdid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: DataSource[];
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/documents/${encodeURIComponent(pdid)}/data-sources`, {
        ...opts
    }));
}
/**
 * Diff the full corrected data array against the current state and append a revision.
 */
export function applyDataSourceCorrection(pdid: Uuid, dsid: Uuid, body: {
    data: {
        [key: string]: any;
    }[];
}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: {
            entry?: {
                [key: string]: any;
            } | null;
            data?: {
                [key: string]: any;
            }[];
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/documents/${encodeURIComponent(pdid)}/data-sources/${encodeURIComponent(dsid)}/correction`, oazapfts.json({
        ...opts,
        method: "POST",
        body
    })));
}
/**
 * List the revisions (diff entries) of a data source, oldest first; the first entry is the original extraction.
 */
export function listDataSourceRevisions(pdid: Uuid, dsid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: DataSourceCorrectionEntry[];
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/documents/${encodeURIComponent(pdid)}/data-sources/${encodeURIComponent(dsid)}/revision`, {
        ...opts
    }));
}
/**
 * Return the latest revision; if the data source has no corrections yet, seed and return its original extraction as the first revision.
 */
export function getLatestRevision(pdid: Uuid, dsid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: DataSourceRevision;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/documents/${encodeURIComponent(pdid)}/data-sources/${encodeURIComponent(dsid)}/revision/latest`, {
        ...opts
    }));
}
/**
 * Return the full reconstructed state of a data source at the given revision.
 */
export function getDataSourceRevision(pdid: Uuid, dsid: Uuid, revid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: DataSourceRevision;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/documents/${encodeURIComponent(pdid)}/data-sources/${encodeURIComponent(dsid)}/revision/${encodeURIComponent(revid)}`, {
        ...opts
    }));
}
/**
 * Delete an intermediary revision, folding its diff into the next revision so the resolved data and all surviving revisions stay unchanged. The seed and latest revisions cannot be deleted.
 */
export function deleteDataSourceRevision(pdid: Uuid, dsid: Uuid, revid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            data?: {
                [key: string]: any;
            }[];
            correctionHistory?: DataSourceCorrectionEntry[];
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/documents/${encodeURIComponent(pdid)}/data-sources/${encodeURIComponent(dsid)}/revision/${encodeURIComponent(revid)}`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * Retrieve all pages linked to a given document, ordered by page index.
 */
export function findDocumentPages(pdid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: DocumentPage[];
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/documents/${encodeURIComponent(pdid)}/pages`, {
        ...opts
    }));
}
/**
 * Retrieve all the member resources of the Page collection resource in the response body.
 */
export function findPage({ page, size, orderBy, reverse }: {
    page?: number;
    size?: number;
    orderBy?: string[];
    reverse?: string[];
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            paging?: Paging;
            data?: Page[];
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/pages${QS.query(QS.explode({
        page,
        size,
        orderBy,
        reverse
    }))}`, {
        ...opts
    }));
}
/**
 * Creates a new Page.
 */
export function createPage(partialPage: PartialPage, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: Page;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>("/pages", oazapfts.json({
        ...opts,
        method: "POST",
        body: partialPage
    })));
}
/**
 * Retrieve a member resource of the Page resources in the response body.
 */
export function findOnePage(pid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: Page;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/pages/${encodeURIComponent(pid)}`, {
        ...opts
    }));
}
/**
 * Complete update of a Page.
 */
export function completeUpdatePage(pid: Uuid, partialPage: PartialPage, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: Page;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/pages/${encodeURIComponent(pid)}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: partialPage
    })));
}
/**
 * Partial update of a Page.
 */
export function partialUpdatePage(pid: Uuid, partialPage: PartialPage, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: Page;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/pages/${encodeURIComponent(pid)}`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: partialPage
    })));
}
/**
 * Delete a member resource of the Page resources.
 */
export function deleteOnePage(pid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/pages/${encodeURIComponent(pid)}`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * Retrieve text content extracted from ocr in selected bounding box
 */
export function findPageTextInBoundingBox(pid: Uuid, bbox: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            [key: string]: any;
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/pages/${encodeURIComponent(pid)}/text-in-bbox${QS.query(QS.explode({
        bbox
    }))}`, {
        ...opts
    }));
}
/**
 * Retrieve text content extracted from ocr in selected bounding boxes
 */
export function findPageTextInBoundingBoxBatch(pid: Uuid, body: {
    boundingBoxes: number[][];
}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            text?: string;
            tokens?: {
                [key: string]: any;
            };
        }[];
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/pages/${encodeURIComponent(pid)}/text-in-bbox/batch`, oazapfts.json({
        ...opts,
        method: "POST",
        body
    })));
}
/**
 * Retrieve all the member resources of the SettingKey collection resource in the response body.
 */
export function findSettingKeys({ userId, groupId, fluxId, clientOrganizationId, page, size, orderBy, reverse }: {
    userId?: Uuid;
    groupId?: Uuid;
    fluxId?: Uuid;
    clientOrganizationId?: Uuid;
    page?: number;
    size?: number;
    orderBy?: string[];
    reverse?: string[];
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            data?: SettingKeyV2[];
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/setting-keys${QS.query(QS.explode({
        userId,
        groupId,
        fluxId,
        clientOrganizationId,
        page,
        size,
        orderBy,
        reverse
    }))}`, {
        ...opts
    }));
}
/**
 * Update all setting keys
 */
export function updateSettingKeys(body?: any | any | any | any, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: {
            data?: SettingKey[];
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>("/setting-keys", oazapfts.json({
        ...opts,
        method: "POST",
        body
    })));
}
/**
 * Validate a list of setting keys value
 */
export function getSettingKeyValidations(settingKeyToValidatePayload: SettingKeyToValidatePayload, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: SettingKeyValidationResponse;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>("/setting-keys/validation", oazapfts.json({
        ...opts,
        method: "POST",
        body: settingKeyToValidatePayload
    })));
}
/**
 * Retrieve a member resource of the SettingKey resources in the response body.
 */
export function findOneSettingKey(skid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: SettingKey;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/setting-keys/${encodeURIComponent(skid)}`, {
        ...opts
    }));
}
/**
 * Complete update of a SettingKey.
 */
export function completeUpdateSettingKey(skid: Uuid, partialSettingKey: PartialSettingKey, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: SettingKey;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/setting-keys/${encodeURIComponent(skid)}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: partialSettingKey
    })));
}
/**
 * Partial update of a SettingKey.
 */
export function partialUpdateSettingKey(skid: Uuid, partialSettingKey: PartialSettingKey, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: SettingKey;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/setting-keys/${encodeURIComponent(skid)}`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: partialSettingKey
    })));
}
/**
 * Delete a member resource of the SettingKey resources.
 */
export function deleteOneSettingKey(skid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/setting-keys/${encodeURIComponent(skid)}`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * Retrieve ExportUiForm used by setting keys
 */
export function findSettingKeyExportUiForm({ locale }: {
    locale?: ("fr" | "en") | null;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ExportUiForm;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/setting-keys/export-ui-form${QS.query(QS.explode({
        locale
    }))}`, {
        ...opts
    }));
}
export function addEmailToWhiteList(body: {
    groupId?: Uuid;
    clientOrganizationId?: Uuid;
    email?: string;
}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText("/email-whitelist", oazapfts.json({
        ...opts,
        method: "POST",
        body
    })));
}
export function removeEmailFromWhiteList(body: {
    groupId?: Uuid;
    email?: string;
}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText("/email-whitelist", oazapfts.json({
        ...opts,
        method: "DELETE",
        body
    })));
}
export function retrieveEmailWhiteList({ groupId, organizationId }: {
    groupId?: Uuid;
    organizationId?: Uuid;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/email-whitelist/retrieve${QS.query(QS.explode({
        groupId,
        organizationId
    }))}`, {
        ...opts
    }));
}
export function createNewGroupEmailWebhook(body: {
    groupId?: Uuid;
    userId?: UuidNullable;
    emailPrefix?: string;
    /** Preparation of the folders this mailhook creates: true = intelligent (agentic), false = classic, null = platform default. */
    agentic?: boolean | null;
}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText("/email-webhook", oazapfts.json({
        ...opts,
        method: "POST",
        body
    })));
}
export function updateGroupEmailWebhook(body: {
    groupId?: Uuid;
    emailPrefix?: string;
    newEmailPrefix?: string;
    fluxId?: UuidNullable;
    clientOrganizationId?: UuidNullable;
    decType?: string | null;
    defaultUserId?: string | null;
    subscribers?: string | null;
    /** Preparation of the folders this mailhook creates: true = intelligent (agentic), false = classic, null = platform default. */
    agentic?: boolean | null;
}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText("/email-webhook", oazapfts.json({
        ...opts,
        method: "PUT",
        body
    })));
}
export function removeGroupEmailWebhook(body: {
    groupId?: Uuid;
    emailPrefix?: string;
}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText("/email-webhook", oazapfts.json({
        ...opts,
        method: "DELETE",
        body
    })));
}
export function retrieveAvailableEmailWebhooks({ groupId, organizationId }: {
    groupId?: Uuid;
    organizationId?: Uuid;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/email-webhooks/retrieve${QS.query(QS.explode({
        groupId,
        organizationId
    }))}`, {
        ...opts
    }));
}
export function retrieveValidationRuleErrors({ exportId, batchImportId }: {
    exportId?: Uuid;
    batchImportId?: Uuid;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/exports/validation-rules/errors${QS.query(QS.explode({
        exportId,
        batchImportId
    }))}`, {
        ...opts
    }));
}
/**
 * Retrieve a member resource of the Export resources in the response body.
 */
export function findOneExportData(exid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ExportData;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/exports/${encodeURIComponent(exid)}/data`, {
        ...opts
    }));
}
/**
 * Retrieve a state fields of the Export resources in the response body.
 */
export function findOnePartialExportData(exid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: PartialExportData;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/exports/${encodeURIComponent(exid)}`, {
        ...opts
    }));
}
/**
 * Get validation result for an export
 */
export function getExportValidation(exid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ExportValidation[];
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/exports/${encodeURIComponent(exid)}/validation`, {
        ...opts
    }));
}
/**
 * Create an export table resource.
 */
export function createExportTableV2(exid: Uuid, body: {
    grid: ExportTableGridPart;
}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ExportDataTable;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/exports-v2/${encodeURIComponent(exid)}/tables`, oazapfts.json({
        ...opts,
        method: "POST",
        body
    })));
}
/**
 * Add a Tuple of fields
 */
export function addExportFieldTupleV2(exid: Uuid, body: {
    /** id of the tupple to add */
    decEntryCategoryId: number;
}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            partialData?: ExportPartialUpdatedData;
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/exports-v2/${encodeURIComponent(exid)}/tuple`, oazapfts.json({
        ...opts,
        method: "POST",
        body
    })));
}
/**
 * Delete a Tuple of fields
 */
export function deleteExportFieldTupleV2(exid: Uuid, tupleId: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            partialData?: ExportPartialUpdatedData;
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/exports-v2/${encodeURIComponent(exid)}/tuple/${encodeURIComponent(tupleId)}`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * Consolidation of an export table resource. All duplicate rows will be merge into one
 */
export function doConsolidationOnExportTableV2(exid: Uuid, etid: Uuid, consolidateV2Payload: ConsolidateV2Payload, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ExportDataTable;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/exports-v2/${encodeURIComponent(exid)}/tables/${encodeURIComponent(etid)}/consolidation`, oazapfts.json({
        ...opts,
        method: "POST",
        body: consolidateV2Payload
    })));
}
/**
 * Consolidation of an export table resource. All duplicate rows will be merge into one
 */
export function undoConsolidationOnExportTableV2(exid: Uuid, etid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ExportDataTable;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/exports-v2/${encodeURIComponent(exid)}/tables/${encodeURIComponent(etid)}/consolidation`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * Delete an export table resource.
 */
export function deleteExportTableV2(exid: Uuid, etid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/exports-v2/${encodeURIComponent(exid)}/tables/${encodeURIComponent(etid)}`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * Add a row to an export table resource
 */
export function addExportTableRowV2(exid: Uuid, etid: Uuid, exportTableRowCreationPayload: ExportTableRowCreationPayload, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ExportDataTable;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/exports-v2/${encodeURIComponent(exid)}/tables/${encodeURIComponent(etid)}/add-row`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: exportTableRowCreationPayload
    })));
}
/**
 * Delete a row to an export table resource. Previous row will be merge with selected row (ocr data)
 */
export function deleteExportTableRowV2(exid: Uuid, etid: Uuid, exportTableRowDeletionPayload: ExportTableRowDeletionPayload, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ExportDataTable;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/exports-v2/${encodeURIComponent(exid)}/tables/${encodeURIComponent(etid)}/delete-row`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: exportTableRowDeletionPayload
    })));
}
/**
 * Patch a batch of cells in table
 */
export function patchExportTableCellsV2(exid: Uuid, etid: Uuid, exportTableCellBatchUpdatePayload: ExportTableCellBatchUpdatePayload, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ExportDataTable;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/exports-v2/${encodeURIComponent(exid)}/tables/${encodeURIComponent(etid)}/cells`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: exportTableCellBatchUpdatePayload
    })));
}
/**
 * add a grid part in table
 */
export function addExportTableGridPartV2(exid: Uuid, etid: Uuid, exportTableGridPartCreationPayload: ExportTableGridPartCreationPayload, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ExportDataTable;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/exports-v2/${encodeURIComponent(exid)}/tables/${encodeURIComponent(etid)}/grid`, oazapfts.json({
        ...opts,
        method: "POST",
        body: exportTableGridPartCreationPayload
    })));
}
/**
 * Patch a grid part in table
 */
export function updateExportTableGridPartV2(exid: Uuid, etid: Uuid, body: {
    grid: ExportTableGridPart;
}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ExportDataTable;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/exports-v2/${encodeURIComponent(exid)}/tables/${encodeURIComponent(etid)}/grid`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body
    })));
}
/**
 * Delete a grid part for a given page
 */
export function deleteExportTablePageV2(exid: Uuid, etid: Uuid, exportTablePageDeletionPayload: ExportTablePageDeletionPayload, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ExportDataTable;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/exports-v2/${encodeURIComponent(exid)}/tables/${encodeURIComponent(etid)}/grid`, oazapfts.json({
        ...opts,
        method: "DELETE",
        body: exportTablePageDeletionPayload
    })));
}
/**
 * Add a column to an export table resource, using selected positions to populate column data
 */
export function addExportTableColumnV2(exid: Uuid, etid: Uuid, body: {
    decEntryId: number;
    columnCells: {
        row: number;
        column?: number;
        value: string | null;
        ocr?: ExportDataItemOcr;
    }[];
}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ExportDataTable;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/exports-v2/${encodeURIComponent(exid)}/tables/${encodeURIComponent(etid)}/add-column`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body
    })));
}
/**
 * Delete a column to an export table resource.
 */
export function deleteExportTableColumnV2(exid: Uuid, etid: Uuid, exportTableColumnDeletionPayload: ExportTableColumnDeletionPayload, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ExportDataTable;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/exports-v2/${encodeURIComponent(exid)}/tables/${encodeURIComponent(etid)}/delete-column`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: exportTableColumnDeletionPayload
    })));
}
/**
 * Rename column
 */
export function renameExportTableColumnV2(exid: Uuid, etid: Uuid, body: {
    /** export index of the column to rename */
    refIndex: number;
    decEntryId: number;
}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ExportDataTable;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/exports-v2/${encodeURIComponent(exid)}/tables/${encodeURIComponent(etid)}/rename-column`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body
    })));
}
/**
 * Merge columns to table
 */
export function mergeColumnsToTableV2(exportId: Uuid, exportTableId: Uuid, body: {
    cells: {
        decEntryId: number;
        row: number;
        value: string;
        ocr?: ExportDataItemOcr;
    }[];
}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ExportDataTable;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/exports-v2/${encodeURIComponent(exportId)}/tables/${encodeURIComponent(exportTableId)}/merge-columns`, oazapfts.json({
        ...opts,
        method: "POST",
        body
    })));
}
/**
 * Create an export table total resource.
 */
export function createExportTableTotal(exid: Uuid, etid: Uuid, exportTableTotalCreationPayload: ExportTableTotalCreationPayload, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ExportDataTotal[];
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/exports-v2/${encodeURIComponent(exid)}/tables/${encodeURIComponent(etid)}/totals`, oazapfts.json({
        ...opts,
        method: "POST",
        body: exportTableTotalCreationPayload
    })));
}
/**
 * Update an export table total resource.
 */
export function updateExportTableTotal(exid: Uuid, etid: Uuid, totalId: Uuid, exportTableTotalUpdatePayload: ExportTableTotalUpdatePayload, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ExportDataTotal[];
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/exports-v2/${encodeURIComponent(exid)}/tables/${encodeURIComponent(etid)}/totals/${encodeURIComponent(totalId)}`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: exportTableTotalUpdatePayload
    })));
}
/**
 * Delete an export table total resource.
 */
export function deleteExportTableTotal(exid: Uuid, etid: Uuid, totalId: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ExportDataTotal[];
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/exports-v2/${encodeURIComponent(exid)}/tables/${encodeURIComponent(etid)}/totals/${encodeURIComponent(totalId)}`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * Apply total post-process on export.
 */
export function applyTotalPostProcessV2(exportId: Uuid, body: {
    documentId?: string | null;
    totalDecEntryId: number;
    postProcessId: string;
}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ExportDataTable;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/exports-v2/${encodeURIComponent(exportId)}/apply-total-post-process`, oazapfts.json({
        ...opts,
        method: "POST",
        body
    })));
}
/**
 * Partial update of a ExportField.
 */
export function partialUpdateExportDataExportFieldV2(exid: Uuid, efid: Uuid, body: {
    /** field value */
    value?: string | null;
    /** set to true if field is validated by user */
    isValidated?: boolean;
    ocr?: ExportDataItemOcr;
}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            partialData?: ExportPartialUpdatedData;
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/exports-v2/${encodeURIComponent(exid)}/fields/${encodeURIComponent(efid)}`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body
    })));
}
/**
 * Export Data to external SI with an id.
 */
export function callExportData(exid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/exports/${encodeURIComponent(exid)}/push`, {
        ...opts,
        method: "POST"
    }));
}
/**
 * Validate a declaration
 */
export function validateDeclaration(exid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/exports/${encodeURIComponent(exid)}/declaration/validate`, {
        ...opts,
        method: "POST"
    }));
}
/**
 * Cancel a declaration
 */
export function cancelDeclaration(exid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/exports/${encodeURIComponent(exid)}/declaration/cancel`, {
        ...opts,
        method: "POST"
    }));
}
/**
 * Cancel a declaration
 */
export function invaidateDeclaration(exid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/exports/${encodeURIComponent(exid)}/declaration/invalidate`, {
        ...opts,
        method: "POST"
    }));
}
/**
 * Modify a declaration
 */
export function modifyDeclaration(exid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/exports/${encodeURIComponent(exid)}/declaration/modify`, {
        ...opts,
        method: "POST"
    }));
}
/**
 * Rectify a declaration
 */
export function rectifyDeclaration(exid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/exports/${encodeURIComponent(exid)}/declaration/rectify`, {
        ...opts,
        method: "POST"
    }));
}
/**
 * Declaration incoming message hook called when new message is received
 */
export function handleIncomingDeclarationMessageHook(body: object, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText("/declarations/incoming-message-hook", oazapfts.json({
        ...opts,
        method: "POST",
        body
    })));
}
/**
 * The agentic declaration, merged with the form schema that produced it. Conditional: the ETag encodes the declaration id, its version and the locale; If-None-Match yields 304. Access is the batch import's.
 */
export function getDeclarationView(declarationId: Uuid, { locale }: {
    locale?: "fr" | "en" | "de";
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: DeclarationView;
    } | {
        status: 304;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/declarations/${encodeURIComponent(declarationId)}${QS.query(QS.explode({
        locale
    }))}`, {
        ...opts
    }));
}
/**
 * The declaration's correction history, in order. Access is the batch import's.
 */
export function listDeclarationEvents(declarationId: Uuid, { since }: {
    since?: number;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: DeclarationEvent[];
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/declarations/${encodeURIComponent(declarationId)}/events${QS.query(QS.explode({
        since
    }))}`, {
        ...opts
    }));
}
/**
 * Apply a batch of the declarant's corrections. Optimistic: baseVersion must be the stored version, otherwise 409 with the current version and the screen reloads. A batch already applied (same batchId) is not applied twice. A `validate` event with no path validates the whole declaration and is refused while a blocking anomaly remains.
 */
export function applyDeclarationEvents(declarationId: Uuid, declarationEventBatch: DeclarationEventBatch, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: DeclarationEventsApplied;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    }>(`/declarations/${encodeURIComponent(declarationId)}/events`, oazapfts.json({
        ...opts,
        method: "POST",
        body: declarationEventBatch
    })));
}
/**
 * Preview what a client referential automation would set on the declaration's articles (TEC-1792). Writes nothing to the declaration; a run that proposes something is recorded in the dossier history (AUTOMATION_RUN).
 */
export function runDeclarationAutomation(declarationId: Uuid, declarationAutomationRunRequest: DeclarationAutomationRunRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: DeclarationAutomationRun;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/declarations/${encodeURIComponent(declarationId)}/automations/run`, oazapfts.json({
        ...opts,
        method: "POST",
        body: declarationAutomationRunRequest
    })));
}
/**
 * Apply a client referential automation in one revertible gesture (TEC-1792). The server recomputes the values: the client only names the automation. Optimistic like the corrections: 409 when baseVersion is stale.
 */
export function applyDeclarationAutomation(declarationId: Uuid, declarationAutomationApplyRequest: DeclarationAutomationApplyRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: DeclarationAutomationApplied;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    }>(`/declarations/${encodeURIComponent(declarationId)}/automations/apply`, oazapfts.json({
        ...opts,
        method: "POST",
        body: declarationAutomationApplyRequest
    })));
}
/**
 * The declaration's correction history by gesture (one batch = one gesture), oldest first, with what can be reverted and what would be reverted with it. Access is the batch import's.
 */
export function listDeclarationGestures(declarationId: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            [key: string]: any;
        }[];
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/declarations/${encodeURIComponent(declarationId)}/gestures`, {
        ...opts
    }));
}
/**
 * Retrieve all the member resources of the ExportUiForm collection resource in the response body.
 */
export function findExportUiFormWithParameters({ exportId, schemaId, fluxId, dataSetId, exportDataTemplateId, scope, locale }: {
    exportId?: Uuid;
    schemaId?: Uuid;
    fluxId?: Uuid;
    dataSetId?: Uuid;
    exportDataTemplateId?: Uuid;
    scope?: ("flux-settings" | "declaration") | null;
    locale?: ("fr" | "en") | null;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ExportUiForm;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/export-ui-forms${QS.query(QS.explode({
        exportId,
        schemaId,
        fluxId,
        dataSetId,
        exportDataTemplateId,
        scope,
        locale
    }))}`, {
        ...opts
    }));
}
/**
 * Creates a new ExportUiForm.
 */
export function createExportUiForm(partialExportUiForm: PartialExportUiForm, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: ExportUiForm;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>("/export-ui-forms", oazapfts.json({
        ...opts,
        method: "POST",
        body: partialExportUiForm
    })));
}
/**
 * Retrieve a member resource of the ExportUiForm resources in the response body.
 */
export function findOneExportUiForm(eufid: Uuid, { scope, lang }: {
    scope?: ("flux-settings" | "declaration") | null;
    lang?: ("fr" | "en") | null;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ExportUiForm;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/export-ui-forms/${encodeURIComponent(eufid)}${QS.query(QS.explode({
        scope,
        lang
    }))}`, {
        ...opts
    }));
}
/**
 * Complete update of a ExportUiForm.
 */
export function completeUpdateExportUiForm(eufid: Uuid, partialExportUiForm: PartialExportUiForm, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ExportUiForm;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/export-ui-forms/${encodeURIComponent(eufid)}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: partialExportUiForm
    })));
}
/**
 * Partial update of a ExportUiForm.
 */
export function partialUpdateExportUiForm(eufid: Uuid, partialExportUiForm: PartialExportUiForm, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ExportUiForm;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/export-ui-forms/${encodeURIComponent(eufid)}`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: partialExportUiForm
    })));
}
/**
 * Delete a member resource of the ExportUiForm resources.
 */
export function deleteOneExportUiForm(eufid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/export-ui-forms/${encodeURIComponent(eufid)}`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * Retrieve all the member resources of the ExportDataTemplate collection resource in the response body.
 */
export function findExportDataTemplate({ page, size, orderBy, reverse }: {
    page?: number;
    size?: number;
    orderBy?: string[];
    reverse?: string[];
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            paging?: Paging;
            data?: ExportDataTemplate[];
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/export-data-templates${QS.query(QS.explode({
        page,
        size,
        orderBy,
        reverse
    }))}`, {
        ...opts
    }));
}
/**
 * Creates a new ExportDataTemplate.
 */
export function createExportDataTemplate(partialExportDataTemplate: PartialExportDataTemplate, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: ExportDataTemplate;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>("/export-data-templates", oazapfts.json({
        ...opts,
        method: "POST",
        body: partialExportDataTemplate
    })));
}
/**
 * Retrieve a member resource of the ExportDataTemplate resources in the response body.
 */
export function findOneExportDataTemplate(eid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ExportDataTemplate;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/export-data-templates/${encodeURIComponent(eid)}`, {
        ...opts
    }));
}
/**
 * Complete update of a ExportDataTemplate.
 */
export function completeUpdateExportDataTemplate(eid: Uuid, partialExportDataTemplate: PartialExportDataTemplate, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ExportDataTemplate;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/export-data-templates/${encodeURIComponent(eid)}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: partialExportDataTemplate
    })));
}
/**
 * Partial update of a ExportDataTemplate.
 */
export function partialUpdateExportDataTemplate(eid: Uuid, partialExportDataTemplate: PartialExportDataTemplate, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ExportDataTemplate;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/export-data-templates/${encodeURIComponent(eid)}`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: partialExportDataTemplate
    })));
}
/**
 * Delete a member resource of the ExportDataTemplate resources.
 */
export function deleteOneExportDataTemplate(eid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/export-data-templates/${encodeURIComponent(eid)}`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * Retrieve all the member resources of the ClientOrganization collection resource in the response body.
 */
export function findClientOrganization({ groupId, page, size, orderBy, reverse }: {
    groupId?: Uuid;
    page?: number;
    size?: number;
    orderBy?: string[];
    reverse?: string[];
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            paging?: Paging;
            data?: ClientOrganization[];
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/client-organizations${QS.query(QS.explode({
        groupId,
        page,
        size,
        orderBy,
        reverse
    }))}`, {
        ...opts
    }));
}
/**
 * Creates a new ClientOrganization.
 */
export function createClientOrganization(partialClientOrganization: PartialClientOrganization, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: ClientOrganization;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>("/client-organizations", oazapfts.json({
        ...opts,
        method: "POST",
        body: partialClientOrganization
    })));
}
/**
 * Retrieve a member resource of the ClientOrganization resources in the response body.
 */
export function findOneClientOrganization(coid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ClientOrganization;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/client-organizations/${encodeURIComponent(coid)}`, {
        ...opts
    }));
}
/**
 * Complete update of a ClientOrganization.
 */
export function completeUpdateClientOrganization(coid: Uuid, partialClientOrganization: PartialClientOrganization, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ClientOrganization;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/client-organizations/${encodeURIComponent(coid)}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: partialClientOrganization
    })));
}
/**
 * Partial update of a ClientOrganization.
 */
export function partialUpdateClientOrganization(coid: Uuid, partialClientOrganization: PartialClientOrganization, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ClientOrganization;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/client-organizations/${encodeURIComponent(coid)}`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: partialClientOrganization
    })));
}
/**
 * Delete a member resource of the ClientOrganization resources.
 */
export function deleteOneClientOrganization(coid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/client-organizations/${encodeURIComponent(coid)}`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * Retrieve all the member resources of the Configuration collection resource in the response body.
 */
export function findConfiguration({ groupId, orderBy, reverse }: {
    groupId?: Uuid;
    orderBy?: string[];
    reverse?: string[];
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            data?: Configuration[];
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/configurations${QS.query(QS.explode({
        groupId,
        orderBy,
        reverse
    }))}`, {
        ...opts
    }));
}
/**
 * Creates a new Configuration.
 */
export function createConfiguration(createConfigurationPayload: CreateConfigurationPayload, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: Configuration;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>("/configurations", oazapfts.json({
        ...opts,
        method: "POST",
        body: createConfigurationPayload
    })));
}
/**
 * Retrieve a member resource of the Configuration resources in the response body.
 */
export function findOneConfiguration(cid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: Configuration;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/configurations/${encodeURIComponent(cid)}`, {
        ...opts
    }));
}
/**
 * Complete update of a Configuration.
 */
export function completeUpdateConfiguration(cid: Uuid, partialConfiguration: PartialConfiguration, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: Configuration;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/configurations/${encodeURIComponent(cid)}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: partialConfiguration
    })));
}
/**
 * Partial update of a Configuration.
 */
export function partialUpdateConfiguration(cid: Uuid, partialConfiguration: PartialConfiguration, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: Configuration;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/configurations/${encodeURIComponent(cid)}`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: partialConfiguration
    })));
}
/**
 * Delete a member resource of the Configuration resources.
 */
export function deleteOneConfiguration(cid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/configurations/${encodeURIComponent(cid)}`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * List all available transports.
 */
export function findAllTransports(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: TransportCollection;
    } | {
        status: 401;
    } | {
        status: 500;
    }>("/transports", {
        ...opts
    }));
}
/**
 * Retrieve all group configuration fields with their options. If group parameter is provided, also includes selected values for that group.
 */
export function findGroupConfigurationFields({ group }: {
    group?: Uuid;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: GroupConfigurationFieldWithOptions[];
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/group_configuration_field${QS.query(QS.explode({
        group
    }))}`, {
        ...opts
    }));
}
/**
 * Retrieve all group configuration keys for a specific group
 */
export function findGroupConfigurationKeys(group: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: GroupConfigurationKey[];
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/group_configuration_key${QS.query(QS.explode({
        group
    }))}`, {
        ...opts
    }));
}
/**
 * Creates a new Group Configuration Key
 */
export function createGroupConfigurationKey(createGroupConfigurationKeyPayload: CreateGroupConfigurationKeyPayload, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: GroupConfigurationKey;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>("/group_configuration_key", oazapfts.json({
        ...opts,
        method: "POST",
        body: createGroupConfigurationKeyPayload
    })));
}
/**
 * Updates an existing Group Configuration Key
 */
export function updateGroupConfigurationKey(updateGroupConfigurationKeyPayload: UpdateGroupConfigurationKeyPayload, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: GroupConfigurationKey;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>("/group_configuration_key", oazapfts.json({
        ...opts,
        method: "PUT",
        body: updateGroupConfigurationKeyPayload
    })));
}
/**
 * Deletes a Group Configuration Key
 */
export function deleteGroupConfigurationKey(group: Uuid, groupConfigurationKeyId: number, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/group_configuration_key${QS.query(QS.explode({
        group,
        group_configuration_key_id: groupConfigurationKeyId
    }))}`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * Compute the form schema of a group for an integration, in a locale. Conditional: the ETag encodes structure hash, locale, build and layout versions; If-None-Match yields 304.
 */
export function getGroupFormSchema(gid: Uuid, decIntegrationId: number, { locale, decBuildVersionId }: {
    locale?: "fr" | "en" | "de";
    decBuildVersionId?: number;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: FormSchema;
    } | {
        status: 304;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/groups/${encodeURIComponent(gid)}/form-schemas/${encodeURIComponent(decIntegrationId)}${QS.query(QS.explode({
        locale,
        decBuildVersionId
    }))}`, {
        ...opts
    }));
}
/**
 * Retrieve the group layout, the presets available for its software, the standard, and what no longer applies to the current catalogue.
 */
export function getGroupFormLayout(gid: Uuid, decIntegrationId: number, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: FormLayoutState;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/groups/${encodeURIComponent(gid)}/form-layouts/${encodeURIComponent(decIntegrationId)}`, {
        ...opts
    }));
}
/**
 * Replace the group layout. Refused (400) when it names an unknown field, anchor, section or preset.
 */
export function updateGroupFormLayout(gid: Uuid, decIntegrationId: number, formLayout: FormLayout, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: FormLayoutState;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/groups/${encodeURIComponent(gid)}/form-layouts/${encodeURIComponent(decIntegrationId)}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: formLayout
    })));
}
/**
 * Retrieve the Nabu override layout for an integration.
 */
export function getNabuFormLayout(decIntegrationId: number, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: FormLayoutState;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/form-layouts/${encodeURIComponent(decIntegrationId)}`, {
        ...opts
    }));
}
/**
 * Replace the Nabu override layout for an integration.
 */
export function updateNabuFormLayout(decIntegrationId: number, formLayout: FormLayout, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: FormLayoutState;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/form-layouts/${encodeURIComponent(decIntegrationId)}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: formLayout
    })));
}
/**
 * List all available integrations.
 */
export function findAllIntegrations(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: IntegrationCollection;
    } | {
        status: 401;
    } | {
        status: 500;
    }>("/integrations", {
        ...opts
    }));
}
/**
 * Retrieve a member resource of the Transport resources in the response body.
 */
export function findOneTransport(tid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: Transport;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/transports/${encodeURIComponent(tid)}`, {
        ...opts
    }));
}
/**
 * Complete update of a Transport.
 */
export function completeUpdateTransport(tid: Uuid, partialTransport: PartialTransport, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: Transport;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/transports/${encodeURIComponent(tid)}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: partialTransport
    })));
}
/**
 * Partial update of a Transport.
 */
export function partialUpdateTransport(tid: Uuid, partialTransport: PartialTransport, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: Transport;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/transports/${encodeURIComponent(tid)}`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: partialTransport
    })));
}
/**
 * Delete a member resource of the Transport resources.
 */
export function deleteOneTransport(tid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/transports/${encodeURIComponent(tid)}`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * Retrieve all the member resources of the DataSet collection resource in the response body.
 */
export function findDataSet({ page, size, orderBy, reverse }: {
    page?: number;
    size?: number;
    orderBy?: string[];
    reverse?: string[];
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            paging?: Paging;
            data?: DataSet[];
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/data-sets${QS.query(QS.explode({
        page,
        size,
        orderBy,
        reverse
    }))}`, {
        ...opts
    }));
}
/**
 * Creates a new DataSet.
 */
export function createDataSet(partialDataSet: PartialDataSet, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: DataSet;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>("/data-sets", oazapfts.json({
        ...opts,
        method: "POST",
        body: partialDataSet
    })));
}
/**
 * Retrieve a member resource of the DataSet resources in the response body.
 */
export function findOneDataSet(dtsid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: DataSet;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/data-sets/${encodeURIComponent(dtsid)}`, {
        ...opts
    }));
}
/**
 * Complete update of a DataSet.
 */
export function completeUpdateDataSet(dtsid: Uuid, partialDataSet: PartialDataSet, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: DataSet;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/data-sets/${encodeURIComponent(dtsid)}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: partialDataSet
    })));
}
/**
 * Partial update of a DataSet.
 */
export function partialUpdateDataSet(dtsid: Uuid, partialDataSet: PartialDataSet, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: DataSet;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/data-sets/${encodeURIComponent(dtsid)}`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: partialDataSet
    })));
}
/**
 * Delete a member resource of the DataSet resources.
 */
export function deleteOneDataSet(dtsid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/data-sets/${encodeURIComponent(dtsid)}`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * Call login.
 */
export function callAccountLogin(loginParameter: LoginParameter, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: {
            session?: Uuid;
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>("/account/login", oazapfts.json({
        ...opts,
        method: "POST",
        body: loginParameter
    }));
}
/**
 * Impersonate a user. SUPERADMIN only. Returns a JWT for the target user.
 */
export function callAccountImpersonate(body: {
    uid: Uuid;
}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: {
            session?: Uuid;
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>("/account/impersonate", oazapfts.json({
        ...opts,
        method: "POST",
        body
    }));
}
/**
 * Call me.
 */
export function callAccountMe(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: UserProfile;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>("/account/me", {
        ...opts
    }));
}
/**
 * Keys of the feature flags visible to the connected user, re-read by the webapp every 15 s. The targeting itself is never returned. TEC-1701.
 */
export function listAccountFeatures(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: AccountFeatureList;
    } | {
        status: 401;
    } | {
        status: 500;
    }>("/account/features", {
        ...opts
    }));
}
/**
 * Call Groups
 */
export function callAccountGroups(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            data?: Group[];
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>("/account/groups", {
        ...opts
    }));
}
/**
 * Call Organization
 */
export function callAccountOrganization(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: Organization;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>("/account/organization", {
        ...opts
    }));
}
export type AccountAuthzGrantor = {
    userId: Uuid;
    /** First and last name, or the email without them. */
    name: string;
};
export type AccountAuthzAgency = {
    groupId: Uuid;
    root: boolean;
    /** Catalogue actions the member's accesses in force allow on this agency. */
    actions: string[];
    /** Up to three active members who can assign a role on this agency, the member excluded. */
    grantors: AccountAuthzGrantor[];
};
export type AccountAuthz = {
    mode: AuthzMode;
    /** A Nabu account: every action, everywhere. */
    superadmin: boolean;
    /** The agencies the member's accesses reach, and the root group in every case. Empty unless the mode is active. */
    agencies: AccountAuthzAgency[];
};
/**
 * The connected member's rights, agency by agency (TEC-1677). Written by hand, until the next client generation.
 */
export function getAccountAuthz(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            data: AccountAuthz;
        };
    } | {
        status: 401;
    } | {
        status: 500;
    } | {
        status: number;
    }>("/account/authz", {
        ...opts
    }));
}
/**
 * Call renewAccess.
 */
export function callAccountRenewAccess(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            Session?: Uuid;
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>("/account/renew-access", {
        ...opts
    }));
}
/**
 * Call logout.
 */
export function callAccountLogout(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText("/account/logout", {
        ...opts
    }));
}
/**
 * Call newAccess.
 */
export function callAccountNewAccess(body: {
    /** email address : string data model referred to the addr-spec defined in RFC 5322 (Email) */
    email?: string | null;
}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: RecoveryParameter;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>("/account/new-access", oazapfts.json({
        ...opts,
        method: "POST",
        body
    })));
}
/**
 * Lost password: always answers 200 at once, whether or not the email belongs to an active account. Only an active account gets the link, sent afterwards.
 */
export function callAccountLostAccess(body: {
    /** email address : string data model referred to the addr-spec defined in RFC 5322 (Email) */
    email?: string | null;
}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText("/account/lost-access", oazapfts.json({
        ...opts,
        method: "POST",
        body
    })));
}
/**
 * Call accessrecovery.
 */
export function callAccessRecovery(recoveryParameter: RecoveryParameter, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText("/account/access-recovery", oazapfts.json({
        ...opts,
        method: "POST",
        body: recoveryParameter
    })));
}
/**
 * Call attest.
 */
export function callAccountAttest(recoveryParameter: RecoveryParameter, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            uid?: Uuid;
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>("/account/attest", oazapfts.json({
        ...opts,
        method: "POST",
        body: recoveryParameter
    })));
}
/**
 * Call groupHierarchy.
 */
export function callOrganizationManagementGroupHierarchy(oid: Uuid, { gid }: {
    gid?: Uuid;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            [key: string]: any;
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/organization-management/group-hierarchy${QS.query(QS.explode({
        oid,
        gid
    }))}`, {
        ...opts
    }));
}
/**
 * Call newOrganization.
 */
export function callOrganizationManagementNewOrganization(baseOrganization: BaseOrganization, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            oid?: Uuid;
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>("/organization-management/new-organization", oazapfts.json({
        ...opts,
        method: "POST",
        body: baseOrganization
    })));
}
/**
 * Call add new Access Policy. - For internal calls, this route is accessed via a long-term JWT token stored in 1 Password
 */
export function callAddPolicy(body: {
    objId?: string;
    groupId?: string;
    organizationId?: string;
}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText("/access/add-policy", oazapfts.json({
        ...opts,
        method: "POST",
        body
    })));
}
/**
 * Call reload policies. - For internal calls, this route is accessed via a long-term JWT token stored in 1 Password
 */
export function callReloadPolicies(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText("/access/reload-policies", {
        ...opts
    }));
}
/**
 * Call add new Access Policy with Policies of an other Object - For internal calls, this route is accessed via a long-term JWT token stored in 1 Password
 */
export function callSynchronizePolicies(body: {
    objId?: Uuid;
    referenceId?: Uuid;
    referenceType?: ReferenceType;
}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText("/access/synchronize-policies", oazapfts.json({
        ...opts,
        method: "POST",
        body
    })));
}
/**
 * Retrieve all the member resources of the DocumentType collection resource in the response body.
 */
export function findDocumentType({ orderBy, reverse }: {
    orderBy?: string[];
    reverse?: string[];
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: DocumentType[];
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/document-types${QS.query(QS.explode({
        orderBy,
        reverse
    }))}`, {
        ...opts
    }));
}
/**
 * Creates a new DocumentType.
 */
export function createDocumentType(partialDocumentType: PartialDocumentType, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: DocumentType;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>("/document-types", oazapfts.json({
        ...opts,
        method: "POST",
        body: partialDocumentType
    })));
}
/**
 * Retrieve a member resource of the DocumentType resources in the response body.
 */
export function findOneDocumentType(dtid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: DocumentType;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/document-types/${encodeURIComponent(dtid)}`, {
        ...opts
    }));
}
/**
 * Complete update of a DocumentType.
 */
export function completeUpdateDocumentType(dtid: Uuid, partialDocumentType: PartialDocumentType, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: DocumentType;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/document-types/${encodeURIComponent(dtid)}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: partialDocumentType
    })));
}
/**
 * Partial update of a DocumentType.
 */
export function partialUpdateDocumentType(dtid: Uuid, partialDocumentType: PartialDocumentType, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: DocumentType;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/document-types/${encodeURIComponent(dtid)}`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: partialDocumentType
    })));
}
/**
 * Delete a member resource of the DocumentType resources.
 */
export function deleteOneDocumentType(dtid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/document-types/${encodeURIComponent(dtid)}`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * Call push.
 */
export function callBatchImportQueuePush(batchImportRequest: BatchImportRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: BatchImportReceipt;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>("/batch-import-queue/push", oazapfts.json({
        ...opts,
        method: "POST",
        body: batchImportRequest
    })));
}
/**
 * Call pushAddition.
 */
export function callBatchImportQueuePushAddition(batchImportAdditionRequest: BatchImportAdditionRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: BatchImportReceipt;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>("/batch-import-queue/push-addition", oazapfts.json({
        ...opts,
        method: "POST",
        body: batchImportAdditionRequest
    })));
}
/**
 * Retrieve all the member resources of the Layer collection resource in the response body.
 */
export function findLayer({ documentTypeId, contentType, page, size, orderBy, reverse }: {
    documentTypeId?: Uuid;
    contentType?: "pdf" | "excel";
    page?: number;
    size?: number;
    orderBy?: string[];
    reverse?: string[];
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            paging?: Paging;
            data?: Layer[];
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/layers${QS.query(QS.explode({
        documentTypeId,
        contentType,
        page,
        size,
        orderBy,
        reverse
    }))}`, {
        ...opts
    }));
}
/**
 * Retrieve all the member resources of the User Setting Key collection resource in the response body.
 */
export function findClientOrganizationSettingKey(coid: Uuid, { page, size, orderBy, reverse }: {
    page?: number;
    size?: number;
    orderBy?: string[];
    reverse?: string[];
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            paging?: Paging;
            data?: ClientOrganizationSettingKey[];
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/client-organizations/${encodeURIComponent(coid)}/setting-keys${QS.query(QS.explode({
        page,
        size,
        orderBy,
        reverse
    }))}`, {
        ...opts
    }));
}
/**
 * Creates a new SettingKey.
 */
export function createClientOrganizationSettingKey(coid: Uuid, partialClientOrganizationSettingKey: PartialClientOrganizationSettingKey, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: ClientOrganizationSettingKey;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/client-organizations/${encodeURIComponent(coid)}/setting-keys`, oazapfts.json({
        ...opts,
        method: "POST",
        body: partialClientOrganizationSettingKey
    })));
}
/**
 * Retrieve a member resource of the User Setting Key resources in the response body.
 */
export function findOneClientOrganizationSettingKey(coid: Uuid, mcoskid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ClientOrganizationSettingKey;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/client-organizations/${encodeURIComponent(coid)}/setting-keys/${encodeURIComponent(mcoskid)}`, {
        ...opts
    }));
}
/**
 * Partial update of a SettingKey.
 */
export function partialUpdateClientOrganizationSettingKey(coid: Uuid, mcoskid: Uuid, partialClientOrganizationSettingKey: PartialClientOrganizationSettingKey, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ClientOrganizationSettingKey;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/client-organizations/${encodeURIComponent(coid)}/setting-keys/${encodeURIComponent(mcoskid)}`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: partialClientOrganizationSettingKey
    })));
}
/**
 * Delete a member resource of the User Setting Key resources.
 */
export function deleteOneClientOrganizationSettingKey(coid: Uuid, mcoskid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/client-organizations/${encodeURIComponent(coid)}/setting-keys/${encodeURIComponent(mcoskid)}`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * Generate a token to access zendesk
 */
export function generateZendeskToken(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            zendeskToken?: string;
        };
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>("/zendesk/generate-token", {
        ...opts
    }));
}
/**
 * Generate an url for a specific user to access metabase iframe
 */
export function findDecSettingKeyOptions(availableFor: "flux" | "group" | "user" | "client-organization", { userId, groupId, decIntegrationId }: {
    userId?: Uuid;
    groupId?: Uuid;
    decIntegrationId?: number;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            data?: SettingKeyOptionV2[];
            ui?: {
                [key: string]: any;
            };
            form?: {
                [key: string]: any;
            };
        };
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/setting-keys-options${QS.query(QS.explode({
        userId,
        groupId,
        decIntegrationId,
        availableFor
    }))}`, {
        ...opts
    }));
}
/**
 * Generate an url for a specific user to access metabase iframe
 */
export function generateMetabaseIframeUrl({ locale }: {
    locale?: "EN" | "FR";
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            iframeUrl?: string;
        };
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/metabase/generate-iframe${QS.query(QS.explode({
        locale
    }))}`, {
        ...opts
    }));
}
/**
 * Creates a new Flux SettingKey
 */
export function createFlux(fluxCreationPayload: FluxCreationPayload, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: CreatedFlux;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>("/flux", oazapfts.json({
        ...opts,
        method: "POST",
        body: fluxCreationPayload
    })));
}
/**
 * Creates a new Flux with all associated setting keys
 */
export function createFluxV2(fluxCreationPayloadV2: FluxCreationPayloadV2, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: {
            fluxId?: Uuid;
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>("/flux-v2", oazapfts.json({
        ...opts,
        method: "POST",
        body: fluxCreationPayloadV2
    })));
}
/**
 * Retrieve one flux by id.
 */
export function retrieveFluxById(fid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: Flux;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/flux/${encodeURIComponent(fid)}`, {
        ...opts
    }));
}
/**
 * Partial update of a Flux.
 */
export function partialUpdateFlux(fid: Uuid, partialFlux: PartialFlux, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: Flux;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/flux/${encodeURIComponent(fid)}`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: partialFlux
    })));
}
/**
 * Delete a member resource of the Flux resources.
 */
export function deleteFlux(fid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/flux/${encodeURIComponent(fid)}`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * Duplicate a V2 flux with its setting keys
 */
export function duplicateFlux(fid: Uuid, body?: {
    name?: string;
} | null, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: {
            fluxId?: Uuid;
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/flux/${encodeURIComponent(fid)}/duplicate`, oazapfts.json({
        ...opts,
        method: "POST",
        body
    })));
}
/**
 * share flux to specified group
 */
export function createFluxShare(fid: Uuid, body: {
    groupId: Uuid;
    permission: Permission;
}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/flux/${encodeURIComponent(fid)}/shares`, oazapfts.json({
        ...opts,
        method: "POST",
        body
    })));
}
/**
 * Cancel flux sharing for a specific group
 */
export function cancelFluxShare(fid: Uuid, groupId: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/flux/${encodeURIComponent(fid)}/shares/${encodeURIComponent(groupId)}`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * Retrieve all the member resources of the Flux Setting Key collection resource in the response body.
 */
export function findFluxSettingKey(fid: Uuid, { page, size, orderBy, reverse }: {
    page?: number;
    size?: number;
    orderBy?: string[];
    reverse?: string[];
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            paging?: Paging;
            data?: FluxSettingKey[];
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/flux/${encodeURIComponent(fid)}/setting-keys${QS.query(QS.explode({
        page,
        size,
        orderBy,
        reverse
    }))}`, {
        ...opts
    }));
}
/**
 * Creates a new Flux SettingKey
 */
export function createFluxSettingKey(fid: Uuid, createFluxSettingKey: CreateFluxSettingKey, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: FluxSettingKey;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/flux/${encodeURIComponent(fid)}/setting-keys`, oazapfts.json({
        ...opts,
        method: "POST",
        body: createFluxSettingKey
    })));
}
/**
 * Partial update of a Flux SettingKey.
 */
export function partialUpdateFluxSettingKey(fid: Uuid, fskid: Uuid, patchFluxSettingKey: PatchFluxSettingKey, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: FluxSettingKey;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/flux/${encodeURIComponent(fid)}/setting-keys/${encodeURIComponent(fskid)}`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: patchFluxSettingKey
    })));
}
/**
 * Delete a member resource of the Flux Setting Key resources.
 */
export function deleteFluxSettingKey(fid: Uuid, fskid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/flux/${encodeURIComponent(fid)}/setting-keys/${encodeURIComponent(fskid)}`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * Call organizations.
 */
export function callSearchOrganizations({ name, page, size, orderBy, reverse }: {
    name?: string | null;
    page?: number;
    size?: number;
    orderBy?: string[];
    reverse?: string[];
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            paging?: Paging;
            data?: Organization[];
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/search/organizations${QS.query(QS.explode({
        name,
        page,
        size,
        orderBy,
        reverse
    }))}`, {
        ...opts
    }));
}
/**
 * Call groups.
 */
export function callSearchGroups({ name, oid, page, size, orderBy, reverse }: {
    name?: string | null;
    oid?: UuidNullable;
    page?: number;
    size?: number;
    orderBy?: string[];
    reverse?: string[];
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            paging?: Paging;
            data?: Group[];
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/search/groups${QS.query(QS.explode({
        name,
        oid,
        page,
        size,
        orderBy,
        reverse
    }))}`, {
        ...opts
    }));
}
/**
 * Call users.
 */
export function callSearchUsers({ term, oid, groupId, page, size, orderBy, reverse }: {
    term?: string | null;
    oid?: UuidNullable;
    groupId?: UuidNullable;
    page?: number;
    size?: number;
    orderBy?: string[];
    reverse?: string[];
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            paging?: Paging;
            data?: User[];
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/search/users${QS.query(QS.explode({
        term,
        oid,
        groupId,
        page,
        size,
        orderBy,
        reverse
    }))}`, {
        ...opts
    }));
}
/**
 * Call clientOrganizations.
 */
export function callSearchClientOrganizations({ name, oid, gid, page, size, orderBy, reverse }: {
    name?: string | null;
    oid?: UuidNullable;
    gid?: UuidNullable;
    page?: number;
    size?: number;
    orderBy?: string[];
    reverse?: string[];
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            paging?: Paging;
            data?: ClientOrganization[];
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/search/client-organizations${QS.query(QS.explode({
        name,
        oid,
        gid,
        page,
        size,
        orderBy,
        reverse
    }))}`, {
        ...opts
    }));
}
/**
 * Call Search Batch Import.
 */
export function callSearchBatchImport({ id, name, clientOrgaIds, startdate, enddate, sendDateFrom, sendDateTo, source, userIds, groupIds, states, decTypes, client, view, unifillStatus, tagIds, page, size, orderBy, reverse }: {
    id?: string | null;
    name?: string | null;
    clientOrgaIds?: string | null;
    startdate?: string | null;
    enddate?: string | null;
    sendDateFrom?: string | null;
    sendDateTo?: string | null;
    source?: string | null;
    userIds?: string | null;
    groupIds?: string | null;
    states?: string | null;
    decTypes?: string | null;
    client?: string | null;
    view?: "minimal" | "list";
    unifillStatus?: "done" | "processing" | "error";
    tagIds?: string | null;
    page?: number;
    size?: number;
    orderBy?: string[];
    reverse?: string[];
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            paging?: Paging;
            data?: BatchImport[];
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/search/batch-imports${QS.query(QS.explode({
        id,
        name,
        clientOrgaIds,
        startdate,
        enddate,
        sendDateFrom,
        sendDateTo,
        source,
        userIds,
        groupIds,
        states,
        decTypes,
        client,
        view,
        unifillStatus,
        tagIds,
        page,
        size,
        orderBy,
        reverse
    }))}`, {
        ...opts
    }));
}
/**
 * Get batch import count grouped by unifill status.
 */
export function getBatchImportCountByUnifillStatus({ id, name, clientOrgaIds, startdate, enddate, sendDateFrom, sendDateTo, source, userIds, groupIds, states, decTypes, client, tagIds }: {
    id?: string | null;
    name?: string | null;
    clientOrgaIds?: string | null;
    startdate?: string | null;
    enddate?: string | null;
    sendDateFrom?: string | null;
    sendDateTo?: string | null;
    source?: string | null;
    userIds?: string | null;
    groupIds?: string | null;
    states?: string | null;
    decTypes?: string | null;
    client?: string | null;
    tagIds?: string | null;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            /** The unifill status category */
            unifillStatus: UnifillStatus2;
            /** Number of batch imports with this status */
            count: number;
        }[];
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/search/batch-imports/counts${QS.query(QS.explode({
        id,
        name,
        clientOrgaIds,
        startdate,
        enddate,
        sendDateFrom,
        sendDateTo,
        source,
        userIds,
        groupIds,
        states,
        decTypes,
        client,
        tagIds
    }))}`, {
        ...opts
    }));
}
/**
 * Nombre de dossiers par statut affiché, avec les filtres de la liste hors statut. Statut affiché : ABANDONED quand le workflow a renoncé à attendre la validation (human-timeout, 15 jours), FAILED quand le dernier log a échoué sur une étape bloquante, sinon batch_import_log_status, en majuscules ; c'est le statut que filtre `states` dans GET /search/batch-imports. Un statut sans dossier est absent.
 */
export function getBatchImportCountByStatus({ id, name, clientOrgaIds, startdate, enddate, sendDateFrom, sendDateTo, source, userIds, groupIds, decTypes, client, tagIds }: {
    id?: string | null;
    name?: string | null;
    clientOrgaIds?: string | null;
    startdate?: string | null;
    enddate?: string | null;
    sendDateFrom?: string | null;
    sendDateTo?: string | null;
    source?: string | null;
    userIds?: string | null;
    groupIds?: string | null;
    decTypes?: string | null;
    client?: string | null;
    tagIds?: string | null;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            /** Statut affiché (UPLOAD, SEGMENTED, MAPPED, EXPORTED, FAILED…) → nombre de dossiers */
            counts: {
                [key: string]: number;
            };
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/search/batch-imports/status-counts${QS.query(QS.explode({
        id,
        name,
        clientOrgaIds,
        startdate,
        enddate,
        sendDateFrom,
        sendDateTo,
        source,
        userIds,
        groupIds,
        decTypes,
        client,
        tagIds
    }))}`, {
        ...opts
    }));
}
/**
 * Call layers with search options.
 */
export function callSearchLayers({ name, page, size, orderBy, reverse }: {
    name?: string | null;
    page?: number;
    size?: number;
    orderBy?: string[];
    reverse?: string[];
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            paging?: Paging;
            data?: Layer[];
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/search/layers${QS.query(QS.explode({
        name,
        page,
        size,
        orderBy,
        reverse
    }))}`, {
        ...opts
    }));
}
/**
 * Retrieve all the member resources of the Flux collection resource in the response body with search options.
 */
export function searchFlux({ name, startdate, enddate, groupId, decIntegrationId, page, size, orderBy, reverse }: {
    name?: string | null;
    startdate?: string | null;
    enddate?: string | null;
    groupId?: UuidNullable;
    decIntegrationId?: number;
    page?: number;
    size?: number;
    orderBy?: string[];
    reverse?: string[];
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            paging?: Paging;
            data?: Flux[];
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/search/flux${QS.query(QS.explode({
        name,
        startdate,
        enddate,
        groupId,
        decIntegrationId,
        page,
        size,
        orderBy,
        reverse
    }))}`, {
        ...opts
    }));
}
/**
 * Call Search Setting Key Option.
 */
export function searchSettingKeyOptions({ locale, scopes, orderBy, reverse }: {
    locale?: ("fr" | "en") | null;
    scopes?: string | null;
    orderBy?: string[];
    reverse?: string[];
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: SettingKeyOption[];
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/search/setting-key-options${QS.query(QS.explode({
        locale,
        scopes,
        orderBy,
        reverse
    }))}`, {
        ...opts
    }));
}
/**
 * Call Statistics User Global.
 */
export function callStatisticsUserGlobal({ startdate, enddate }: {
    startdate?: string | null;
    enddate?: string | null;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: Statistics;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/statistics/global${QS.query(QS.explode({
        startdate,
        enddate
    }))}`, {
        ...opts
    }));
}
/**
 * Team activity roster for the manager dashboard: processed, in progress, late, cadence and load per declarant of the resolved agency.
 */
export function getDashboardTeamActivity({ period, groupId }: {
    period?: "week" | "month";
    groupId?: string | null;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: DashboardTeamActivityResponse;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/dashboard/team-activity${QS.query(QS.explode({
        period,
        groupId
    }))}`, {
        ...opts
    }));
}
/**
 * Rolling 12-month volume of folders, split by declaration type (import / export / transit).
 */
export function getDashboardFluxVolume(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: DashboardFluxVolumeResponse;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>("/dashboard/flux-volume", {
        ...opts
    }));
}
/**
 * Lightweight polling endpoint for unread badge and change detection (ETag / 304).
 */
export function getNotificationsPulse({ ifNoneMatch }: {
    ifNoneMatch?: string;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: InAppNotificationPulse;
    } | {
        status: 304;
    } | {
        status: 401;
    } | {
        status: 500;
    }>("/notifications/pulse", {
        ...opts,
        headers: {
            ...opts && opts.headers,
            "If-None-Match": ifNoneMatch
        }
    }));
}
/**
 * List in-app notifications for the current user (newest first).
 */
export function listInAppNotifications({ limit, cursor }: {
    limit?: number;
    cursor?: string;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: InAppNotificationListResponse;
    } | {
        status: 401;
    } | {
        status: 500;
    }>(`/notifications${QS.query(QS.explode({
        limit,
        cursor
    }))}`, {
        ...opts
    }));
}
/**
 * Mark all notifications as read for the current user.
 */
export function markAllInAppNotificationsRead(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText("/notifications/mark-all-read", {
        ...opts,
        method: "POST"
    }));
}
/**
 * Clear all notifications for the current user.
 */
export function clearInAppNotifications(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText("/notifications/clear", {
        ...opts,
        method: "POST"
    }));
}
/**
 * Mark a single notification as read.
 */
export function markInAppNotificationRead(notificationId: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/notifications/${encodeURIComponent(notificationId)}/read`, {
        ...opts,
        method: "PATCH"
    }));
}
/**
 * List tags accessible to the user.
 */
export function listTags({ organizationId }: {
    organizationId?: Uuid;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            data?: Tag[];
        };
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>(`/tags${QS.query(QS.explode({
        organizationId
    }))}`, {
        ...opts
    }));
}
/**
 * Create a tag (organization-scoped or user's organization if organizationId omitted).
 */
export function createTag(createTagPayload: CreateTagPayload, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: Tag;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>("/tags", oazapfts.json({
        ...opts,
        method: "POST",
        body: createTagPayload
    })));
}
/**
 * Partial update of a tag (text and/or color).
 */
export function patchTag(tagId: Uuid, updateTagPayload?: UpdateTagPayload, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: Tag;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/tags/${encodeURIComponent(tagId)}`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: updateTagPayload
    })));
}
/**
 * Delete an organization-scoped tag.
 */
export function deleteTag(tagId: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/tags/${encodeURIComponent(tagId)}`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * List current user's saved searches. Optionally filter by scope (e.g. batch-import).
 */
export function listSavedSearches(scope: "batch-import", opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            data?: SavedSearch[];
        };
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>(`/saved-searches${QS.query(QS.explode({
        scope
    }))}`, {
        ...opts
    }));
}
/**
 * Create a saved search (name, scope, payload).
 */
export function createSavedSearch(createSavedSearchPayload: CreateSavedSearchPayload, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: SavedSearch;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>("/saved-searches", oazapfts.json({
        ...opts,
        method: "POST",
        body: createSavedSearchPayload
    })));
}
/**
 * Partial update of a saved search (name and/or payload).
 */
export function patchSavedSearch(savedSearchId: Uuid, updateSavedSearchPayload?: UpdateSavedSearchPayload, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: SavedSearch;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/saved-searches/${encodeURIComponent(savedSearchId)}`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: updateSavedSearchPayload
    })));
}
/**
 * Delete a saved search (must be owned by current user).
 */
export function deleteSavedSearch(savedSearchId: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/saved-searches/${encodeURIComponent(savedSearchId)}`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * List changelog releases. Dashboard users see PUBLISHED releases localized by locale with unread badge meta. SUPERADMIN may filter by status and receives staff-shaped releases.
 */
export function listChangelogReleases({ locale, status }: {
    locale?: "fr" | "en" | "de";
    status?: "DRAFT" | "PUBLISHED";
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ChangelogReleaseListResponse;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>(`/changelog/releases${QS.query(QS.explode({
        locale,
        status
    }))}`, {
        ...opts
    }));
}
/**
 * Create a DRAFT changelog release with optional items.
 */
export function createChangelogRelease(createChangelogReleasePayload: CreateChangelogReleasePayload, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: ChangelogReleaseStaff;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>("/changelog/releases", oazapfts.json({
        ...opts,
        method: "POST",
        body: createChangelogReleasePayload
    })));
}
/**
 * Create a DRAFT changelog release from Linear issues tagged changelog, then remove the label. SUPERADMIN only.
 */
export function importChangelogReleasesFromLinear(changelogLinearImportPayload?: ChangelogLinearImportPayload, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: ChangelogLinearImportResponse;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>("/changelog/releases/from-linear", oazapfts.json({
        ...opts,
        method: "POST",
        body: changelogLinearImportPayload
    })));
}
/**
 * Get changelog release detail (DRAFT or PUBLISHED, staff shape).
 */
export function getChangelogRelease(id: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ChangelogReleaseStaff;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/changelog/releases/${encodeURIComponent(id)}`, {
        ...opts
    }));
}
/**
 * Update a changelog release (DRAFT or PUBLISHED) and optionally replace items.
 */
export function patchChangelogRelease(id: Uuid, patchChangelogReleasePayload?: PatchChangelogReleasePayload, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ChangelogReleaseStaff;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/changelog/releases/${encodeURIComponent(id)}`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: patchChangelogReleasePayload
    })));
}
/**
 * Delete a changelog release (DRAFT or PUBLISHED).
 */
export function deleteChangelogRelease(id: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/changelog/releases/${encodeURIComponent(id)}`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * Publish a DRAFT changelog release.
 */
export function publishChangelogRelease(id: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ChangelogReleaseStaff;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/changelog/releases/${encodeURIComponent(id)}/publish`, {
        ...opts,
        method: "POST"
    }));
}
/**
 * Mark a published changelog release as read for the current user.
 */
export function acknowledgeChangelogRelease(releaseId: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/changelog/releases/${encodeURIComponent(releaseId)}/acknowledge`, {
        ...opts,
        method: "POST"
    }));
}
/**
 * Read a platform-wide setting with its default value and bounds. Returns the default when the setting was never written.
 */
export function getPlatformSetting(key: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: PlatformSetting;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/platform-settings/${encodeURIComponent(key)}`, {
        ...opts
    }));
}
/**
 * Update a platform-wide setting. The value must be an integer within the setting bounds.
 */
export function updatePlatformSetting(key: string, updatePlatformSettingPayload: UpdatePlatformSettingPayload, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: PlatformSetting;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/platform-settings/${encodeURIComponent(key)}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: updatePlatformSettingPayload
    })));
}
/**
 * List published PUBLIC help articles.
 */
export function listHelpArticles({ category, language }: {
    category?: HelpCategory;
    language?: HelpArticleLanguage;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: HelpArticleListResponse;
    } | {
        status: 401;
    } | {
        status: 500;
    }>(`/help-articles${QS.query(QS.explode({
        category,
        language
    }))}`, {
        ...opts
    }));
}
/**
 * Full-text search over published help articles.
 */
export function searchHelpArticles(q: string, { category, language }: {
    category?: HelpCategory;
    language?: HelpArticleLanguage;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: HelpArticleListResponse;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 500;
    }>(`/help-articles/search${QS.query(QS.explode({
        q,
        category,
        language
    }))}`, {
        ...opts
    }));
}
/**
 * Top frequent search terms aggregated from article keywords.
 */
export function getHelpFrequentSearches({ language }: {
    language?: HelpArticleLanguage;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: HelpFrequentSearchesResponse;
    } | {
        status: 401;
    } | {
        status: 500;
    }>(`/help-articles/frequent-searches${QS.query(QS.explode({
        language
    }))}`, {
        ...opts
    }));
}
/**
 * Trigger a full Notion help center sync.
 */
export function syncHelpArticles(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: HelpSyncRunResponse;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>("/help-articles/sync", {
        ...opts,
        method: "POST"
    }));
}
/**
 * List recent help center sync runs.
 */
export function listHelpArticleSyncRuns({ limit }: {
    limit?: number;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: HelpSyncRunListResponse;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>(`/help-articles/sync-runs${QS.query(QS.explode({
        limit
    }))}`, {
        ...opts
    }));
}
/**
 * Get a published help article by id.
 */
export function getHelpArticle(id: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: HelpArticleDetail;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/help-articles/${encodeURIComponent(id)}`, {
        ...opts
    }));
}
/**
 * Record a view for a published help article.
 */
export function recordHelpArticleView(id: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: HelpArticleViewResponse;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/help-articles/${encodeURIComponent(id)}/view`, {
        ...opts,
        method: "POST"
    }));
}
/**
 * Submit or update feedback for a help article.
 */
export function submitHelpArticleFeedback(id: Uuid, helpArticleFeedbackRequest: HelpArticleFeedbackRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: HelpArticleFeedbackResponse;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/help-articles/${encodeURIComponent(id)}/feedback`, oazapfts.json({
        ...opts,
        method: "POST",
        body: helpArticleFeedbackRequest
    })));
}
/**
 * Notion webhook endpoint for help center page updates.
 */
export function handleNotionHelpCenterHook(notionHelpCenterWebhookPayload: NotionHelpCenterWebhookPayload, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: HelpSyncRunResponse | {
            ok?: boolean;
        };
    } | {
        status: 401;
    } | {
        status: 500;
    }>("/notion/help-center-hook", oazapfts.json({
        ...opts,
        method: "POST",
        body: notionHelpCenterWebhookPayload
    })));
}
/**
 * Hyperline webhook endpoint for subscription credit grants.
 */
export function handleHyperlineWebhook(hyperlineWebhookPayload: HyperlineWebhookPayload, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: HyperlineWebhookResponse;
    } | {
        status: 401;
    } | {
        status: 500;
    }>("/hyperline/webhook", oazapfts.json({
        ...opts,
        method: "POST",
        body: hyperlineWebhookPayload
    })));
}
/**
 * List AI agent skills for an organization.
 */
export function listOrganizationAiAgentSkills(oid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: AiAgentSkillListResponse;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/organizations/${encodeURIComponent(oid)}/ai-agent-skills`, {
        ...opts
    }));
}
/**
 * Create an AI agent skill for an organization.
 */
export function createOrganizationAiAgentSkill(oid: Uuid, aiAgentSkillWritePayload: AiAgentSkillWritePayload, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: AiAgentSkill;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/organizations/${encodeURIComponent(oid)}/ai-agent-skills`, oazapfts.json({
        ...opts,
        method: "POST",
        body: aiAgentSkillWritePayload
    })));
}
/**
 * Update an AI agent skill.
 */
export function updateOrganizationAiAgentSkill(oid: Uuid, skillId: Uuid, aiAgentSkillWritePayload: AiAgentSkillWritePayload, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: AiAgentSkill;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/organizations/${encodeURIComponent(oid)}/ai-agent-skills/${encodeURIComponent(skillId)}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: aiAgentSkillWritePayload
    })));
}
/**
 * Delete an AI agent skill.
 */
export function deleteOrganizationAiAgentSkill(oid: Uuid, skillId: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/organizations/${encodeURIComponent(oid)}/ai-agent-skills/${encodeURIComponent(skillId)}`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * Get weekly scoring metrics for extraction A/B testing.
 */
export function getScoringMetricsWeekly({ startDate, endDate }: {
    startDate?: string | null;
    endDate?: string | null;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ScoringMetricsWeeklyResponse;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/scoring-metrics/weekly${QS.query(QS.explode({
        startDate,
        endDate
    }))}`, {
        ...opts
    }));
}
/**
 * Scoreboard d'éval versionné : une entrée par version enregistrée (pnpm eval record), du plus récent au plus ancien. Lecture seule du fichier embarqué apps/pipeline-eval/scoreboard/history.json.
 */
export function getEvalScoreboard(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: EvalScoreboardResponse;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>("/eval/scoreboard", {
        ...opts
    }));
}
/**
 * Détail d'une version du scoreboard : constats nommés, diff contre la version précédente, résumé rédigé.
 */
export function getEvalScoreboardVersion(version: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: EvalVersionDetail;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/eval/scoreboard/${encodeURIComponent(version)}`, {
        ...opts
    }));
}
/**
 * LLMService hook called on extraction done event
 */
export function handleLlmExtractionDoneHook(body: {
    documentId: Uuid;
}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText("/llm-service/extraction-done-hook", oazapfts.json({
        ...opts,
        method: "POST",
        body
    })));
}
/**
 * Retrieve all the member resources of the ImportSeed collection resource in the response body.
 */
export function findImportSeed({ page, size, orderBy, reverse }: {
    page?: number;
    size?: number;
    orderBy?: string[];
    reverse?: string[];
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            paging?: Paging;
            data?: ImportSeed[];
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/import-seed${QS.query(QS.explode({
        page,
        size,
        orderBy,
        reverse
    }))}`, {
        ...opts
    }));
}
/**
 * Creates a new ImportSeed.
 */
export function createImportSeed(importSeedPayload: ImportSeedPayload, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: ImportSeed;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>("/import-seed", oazapfts.json({
        ...opts,
        method: "POST",
        body: importSeedPayload
    })));
}
/**
 * Retrieve a member resource of the ImportSeed resources in the response body.
 */
export function findOneImportSeed(id: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ImportSeed;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/import-seed/${encodeURIComponent(id)}`, {
        ...opts
    }));
}
/**
 * Delete a member resource of the ImportSeed resources.
 */
export function deleteOneImportSeed(id: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/import-seed/${encodeURIComponent(id)}`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * Fallback upload vers S3
 */
export function uploadFileToS3Fallback(body: any, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: {
            bucket: string;
            key: string;
            etag?: string;
            contentType?: string;
        };
    } | {
        status: 413;
    }>("/s3-upload-fallback", oazapfts.multipart({
        ...opts,
        method: "POST",
        body
    })));
}
/**
 * Create a new workflow event subscription. The auth_config is encrypted at rest with AES-256-GCM using the WEBHOOK_SUBSCRIPTION_MASTER_KEY.
 */
export function createEventSubscription(createEventSubscriptionRequest: CreateEventSubscriptionRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: {
            workflowEventSubscriptionId?: string;
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>("/event-subscriptions", oazapfts.json({
        ...opts,
        method: "POST",
        body: createEventSubscriptionRequest
    })));
}
/**
 * Retrieve all the member resources of the AutomationGroup collection resource in the response body.
 */
export function findAutomationGroup({ groupId, configurationId, clientOrganizationId, active, page, size, orderBy, reverse }: {
    groupId?: Uuid;
    configurationId?: Uuid;
    clientOrganizationId?: Uuid;
    active?: boolean;
    page?: number;
    size?: number;
    orderBy?: string[];
    reverse?: string[];
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            paging?: Paging;
            data?: AutomationGroup[];
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/automation-groups${QS.query(QS.explode({
        groupId,
        configurationId,
        clientOrganizationId,
        active,
        page,
        size,
        orderBy,
        reverse
    }))}`, {
        ...opts
    }));
}
/**
 * Creates a new AutomationGroup.
 */
export function createAutomationGroup(createAutomationGroupRequest: CreateAutomationGroupRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: {
            automationGroupId?: string;
            s3UploadUrl?: string;
            s3ObjectKey?: string;
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    } | {
        status: number;
    }>("/automation-groups", oazapfts.json({
        ...opts,
        method: "POST",
        body: createAutomationGroupRequest
    })));
}
/**
 * Retrieve a member resource of the AutomationGroup resources in the response body.
 */
export function findOneAutomationGroup(id: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: AutomationGroup;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/automation-groups/${encodeURIComponent(id)}`, {
        ...opts
    }));
}
/**
 * Update a member resource of the AutomationGroup resources.
 */
export function partialUpdateAutomationGroup(id: Uuid, updateAutomationGroupPayload: UpdateAutomationGroupPayload, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: AutomationGroup;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/automation-groups/${encodeURIComponent(id)}`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: updateAutomationGroupPayload
    })));
}
/**
 * Delete a member resource of the AutomationGroup resources.
 */
export function deleteOneAutomationGroup(id: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/automation-groups/${encodeURIComponent(id)}`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * Prepare automation group databases by building SQLite databases
 */
export function prepareAutomationGroup(id: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            message?: string;
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/automation-groups/${encodeURIComponent(id)}/prepare`, {
        ...opts,
        method: "POST"
    }));
}
/**
 * Request a signed S3 URL to re-upload the automation group data grid
 */
export function uploadAutomationGroupDataGrid(id: Uuid, dataGridUploadRequest: DataGridUploadRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            s3UploadUrl?: string;
            s3ObjectKey?: string;
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/automation-groups/${encodeURIComponent(id)}/data-grid-upload`, oazapfts.json({
        ...opts,
        method: "POST",
        body: dataGridUploadRequest
    })));
}
/**
 * Run automations on an export table and return proposals
 */
export function runAutomations(exid: Uuid, etid: Uuid, { automationGroupId }: {
    automationGroupId?: Uuid;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            index?: number;
            payload?: {
                [key: string]: any;
            }[];
        }[];
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/exports-v2/${encodeURIComponent(exid)}/tables/${encodeURIComponent(etid)}/run-automations${QS.query(QS.explode({
        automationGroupId
    }))}`, {
        ...opts,
        method: "POST"
    }));
}
/**
 * Assemble a RAG payload for a document and forward it to the extraction service.
 */
export function storeDocumentRetrieval(pdid: Uuid, ragRetrievalStoreRequest: RagRetrievalStoreRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/documents/${encodeURIComponent(pdid)}/retrieval/store`, oazapfts.json({
        ...opts,
        method: "POST",
        body: ragRetrievalStoreRequest
    })));
}
/**
 * Paginated list of ingested RAG record identifiers. Forwards to the extraction service.
 */
export function listRagRecords({ limit, offset }: {
    limit?: number;
    offset?: number;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            [key: string]: any;
        };
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 422;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/rag/records${QS.query(QS.explode({
        limit,
        offset
    }))}`, {
        ...opts
    }));
}
/**
 * Fetch one RAG record by id. Forwards to the extraction service.
 */
export function getRagRecord(recordId: string, { idType }: {
    idType?: "document_uuid" | "object_uuid";
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            [key: string]: any;
        };
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 422;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/rag/records/${encodeURIComponent(recordId)}${QS.query(QS.explode({
        id_type: idType
    }))}`, {
        ...opts
    }));
}
/**
 * Match input text against the RAG index and return ranked matches. Forwards to the extraction service.
 */
export function ragRetrievalTest(body: {
    [key: string]: any;
}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            [key: string]: any;
        }[];
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 422;
    } | {
        status: 500;
    } | {
        status: number;
    }>("/rag/retrieval-test", oazapfts.json({
        ...opts,
        method: "POST",
        body
    })));
}
/**
 * Enriched credit balance for the caller's organization (bandeau + packs).
 */
export function getBillingCredits(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: BillingCreditsResponse;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>("/billing/credits", {
        ...opts
    }));
}
/**
 * Current organization subscription summary for Abonnement page.
 */
export function getBillingSubscription(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: BillingSubscriptionResponse;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>("/billing/subscription", {
        ...opts
    }));
}
/**
 * First-time self-serve activation: create Hyperline subscription from template and grant plan envelope. Required when subscriptionActivation is pending. Requires an active payment method on the Hyperline customer (otherwise 400 PAYMENT_METHOD_REQUIRED).
 */
export function activateBillingSubscription(body?: {
    planId?: PlanId;
    cycle?: Cycle;
}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: BillingSubscriptionResponse;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>("/billing/subscription/activate", oazapfts.json({
        ...opts,
        method: "POST",
        body
    })));
}
/**
 * Change billing cycle (monthly/annual). Effective at next renewal.
 */
export function updateBillingSubscriptionCycle(body: {
    cycle: Cycle;
}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: BillingSubscriptionMutationResponse;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>("/billing/subscription/cycle", oazapfts.json({
        ...opts,
        method: "PUT",
        body
    })));
}
/**
 * Change plan (starter/growth self-serve). Enterprise returns CONTACT_REQUIRED.
 */
export function updateBillingSubscriptionPlan(body: {
    planId: PlanId2;
}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: BillingSubscriptionMutationResponse;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>("/billing/subscription/plan", oazapfts.json({
        ...opts,
        method: "PUT",
        body
    })));
}
/**
 * Purchase credit packs (or custom quantity) via Hyperline.
 */
export function purchaseBillingCredits(body: {
    quantity: number;
}, { idempotencyKey }: {
    idempotencyKey?: string;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: BillingCreditsPurchaseResponse;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>("/billing/credits/purchase", oazapfts.json({
        ...opts,
        method: "POST",
        body,
        headers: {
            ...opts && opts.headers,
            "Idempotency-Key": idempotencyKey
        }
    })));
}
/**
 * List available billing plans (Starter, Growth, Enterprise) for the given cycle.
 */
export function getBillingPlans({ cycle }: {
    cycle?: "monthly" | "annual";
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: BillingPlansResponse;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>(`/billing/plans${QS.query(QS.explode({
        cycle
    }))}`, {
        ...opts
    }));
}
/**
 * List payment methods (cards) for the caller's organization. Custom Facturation UI.
 */
export function getBillingPaymentMethods(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: BillingPaymentMethodsResponse;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>("/billing/payment-methods", {
        ...opts
    }));
}
/**
 * Confirm a Stripe payment method after client-side SetupIntent confirmation (add-only). Proxies Hyperline external payment-methods API.
 */
export function confirmBillingPaymentMethod(body: {
    providerPaymentMethodId: string;
    intentId: string;
    clientProviderId: string;
    paymentMethodType?: PaymentMethodType;
    state?: State3;
}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: BillingPaymentMethodConfirmResponse;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>("/billing/payment-methods", oazapfts.json({
        ...opts,
        method: "POST",
        body
    })));
}
/**
 * Start add-card flow: returns Stripe SetupIntent fields (via Hyperline internal intent API). Front confirms card with Stripe Elements, then POST /billing/payment-methods.
 */
export function setupBillingPaymentMethod(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: BillingPaymentMethodSetupResponse;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>("/billing/payment-methods/setup", {
        ...opts,
        method: "POST"
    }));
}
/**
 * Set a payment method as the default (Principale) card.
 */
export function setDefaultBillingPaymentMethod(id: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: BillingPaymentMethodDefaultResponse;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/billing/payment-methods/${encodeURIComponent(id)}/set-default`, {
        ...opts,
        method: "POST"
    }));
}
/**
 * Delete a payment method. Blocked when it is the last active card and subscription is active (PAYMENT_METHOD_REQUIRED).
 */
export function deleteBillingPaymentMethod(id: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/billing/payment-methods/${encodeURIComponent(id)}`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * Invoice history for the caller's organization (newest first). Display numbers are Nabu-formatted.
 */
export function getBillingInvoices(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: BillingInvoicesResponse;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>("/billing/invoices", {
        ...opts
    }));
}
/**
 * Signed PDF URL for an invoice belonging to the caller's organization.
 */
export function getBillingInvoiceDocument(id: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: BillingInvoiceDocumentResponse;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/billing/invoices/${encodeURIComponent(id)}/document`, {
        ...opts
    }));
}
/**
 * Admin: organizations list of the console (SUPERADMIN). The optional term matches the organization name and its users (first name, last name, email), ignoring case and accents, on part of the text; every word must match, in any order. Organizations matched by their name come first.
 */
export function listAdminOrganizations({ term, page, size }: {
    term?: string | null;
    page?: number;
    size?: number;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: AdminOrganizationCollection;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>(`/admin/organizations${QS.query(QS.explode({
        term,
        page,
        size
    }))}`, {
        ...opts
    }));
}
/**
 * Admin: where an organization stands in the console organizations list (SUPERADMIN), with the search of the list: rank, total and the organizations just before and after, for the arrows of the organization page. An organization the search does not find keeps its place between its neighbors, without being counted.
 */
export function findAdminOrganizationNeighbors(oid: Uuid, { term }: {
    term?: string | null;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: AdminOrganizationNeighbors;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>(`/admin/organizations/${encodeURIComponent(oid)}/neighbors${QS.query(QS.explode({
        term
    }))}`, {
        ...opts
    }));
}
/**
 * Admin: subscriptions table of the console (SUPERADMIN). One row per organization, read from the copy of the Hyperline subscriptions kept in the database, ordered by next due date (closest first, none last). Hyperline is not called.
 */
export function listAdminSubscriptions(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: AdminSubscriptionCollection;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>("/admin/subscriptions", {
        ...opts
    }));
}
/**
 * Admin: replaces the copy of the Hyperline subscriptions, then returns the subscriptions table (SUPERADMIN). A failed synchronization keeps the previous copy and is reported in sync.lastError, with a 200.
 */
export function syncAdminSubscriptions(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: AdminSubscriptionCollection;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>("/admin/subscriptions/sync", {
        ...opts,
        method: "POST"
    }));
}
/**
 * Admin: every help article copied from Notion, published or not, internal ones included, without their content, plus the latest sync runs (SUPERADMIN).
 */
export function getAdminHelpCenter(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: AdminHelpCenter;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>("/admin/help-center", {
        ...opts
    }));
}
/**
 * Admin: starts a full Notion help center sync without waiting for it and returns the run, finishedAt null while it runs. A manual run already in progress is returned instead of starting another (SUPERADMIN).
 */
export function startAdminHelpCenterSync(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 202;
        data: HelpSyncRunResponse;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>("/admin/help-center/sync", {
        ...opts,
        method: "POST"
    }));
}
/**
 * Admin: figures of the console dashboard for a period, all organizations (SUPERADMIN). Days are compared like the filters of the declarations list, so a card and its filtered list give the same total. Active users and the subscriptions MRR are computed live when the period ends today (and recorded for the day), read from the record of the day a past period ends otherwise. A figure that fails, or has no record, is null.
 */
export function getAdminDashboard($from: string, to: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: AdminDashboard;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>(`/admin/dashboard${QS.query(QS.explode({
        "from": $from,
        to
    }))}`, {
        ...opts
    }));
}
/**
 * Admin: client names containing a text, for the Client filter of the console declarations list (SUPERADMIN). The client is the domestic party of the declaration: importer or consignee for an import, exporter or shipper for an export. Case-insensitive, accents not ignored; deleted batch imports excluded. Twenty names at most, the most frequent first.
 */
export function listAdminDeclarationClients(term: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: AdminDeclarationClientCollection;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>(`/admin/declarations/clients${QS.query(QS.explode({
        term
    }))}`, {
        ...opts
    }));
}
/**
 * Admin: search bar of the console header (SUPERADMIN). Organizations by name, agencies by their name or their organization's, users by name or email, declarations by Nabu reference, client reference or dossier name. Case and accents ignored, on part of the text; every word must match the same field, in any order. The first five results of each category, with the number of matches; deleted batch imports excluded, the root group of an organization is not an agency.
 */
export function getAdminSearch(term: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: AdminSearchResult;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>(`/admin/search${QS.query(QS.explode({
        term
    }))}`, {
        ...opts
    }));
}
/**
 * Admin: users table of the console (SUPERADMIN). One row per user and organization: a user belongs to their organization and to the organization of each of their groups. The optional term matches the user name or email, ignoring case and accents, on part of the text; every word must match, in any order. Filters combine. Missing values (no agency, never logged in) come last in both sort directions.
 */
export function listAdminUsers({ term, organizationId, role, status, sortBy, sortDirection, page, size }: {
    term?: string | null;
    organizationId?: UuidNullable;
    role?: string;
    status?: string;
    sortBy?: "name" | "email" | "organization" | "agency" | "role" | "status" | "createdAt" | "lastLoginAt";
    sortDirection?: "asc" | "desc";
    page?: number;
    size?: number;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: AdminUserCollection;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>(`/admin/users${QS.query(QS.explode({
        term,
        organizationId,
        role,
        status,
        sortBy,
        sortDirection,
        page,
        size
    }))}`, {
        ...opts
    }));
}
/**
 * Admin: one user for the console user page (SUPERADMIN). Status, organizations and agencies follow the rules of the users table; memberships list the user's organization first, then those of their groups.
 */
export function findAdminUser(uid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: AdminUserDetail;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/admin/users/${encodeURIComponent(uid)}`, {
        ...opts
    }));
}
/**
 * Admin: where a row of the console users table stands in the list (SUPERADMIN), with the search, filters and sort of the table: rank, total and the rows just before and after, for the arrows of the user page. A user has one row per organization: rowOrganizationId picks it. A row that no longer matches the filters keeps its place between its neighbors, without being counted.
 */
export function findAdminUserNeighbors(uid: Uuid, rowOrganizationId: Uuid, { term, organizationId, role, status, sortBy, sortDirection }: {
    term?: string | null;
    organizationId?: UuidNullable;
    role?: string;
    status?: string;
    sortBy?: "name" | "email" | "organization" | "agency" | "role" | "status" | "createdAt" | "lastLoginAt";
    sortDirection?: "asc" | "desc";
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: AdminUserNeighbors;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>(`/admin/users/${encodeURIComponent(uid)}/neighbors${QS.query(QS.explode({
        rowOrganizationId,
        term,
        organizationId,
        role,
        status,
        sortBy,
        sortDirection
    }))}`, {
        ...opts
    }));
}
/**
 * Admin: interventions of a SUPERADMIN on this user from the console, newest first, with the values before and after (SUPERADMIN). At most 100 events. Action codes only, no localized copy.
 */
export function listAdminUserAuditEvents(uid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: AdminAuditEventList;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>(`/admin/users/${encodeURIComponent(uid)}/audit-events`, {
        ...opts
    }));
}
/**
 * Admin: send this user the lost password email, as POST /account/lost-access does, and trace it (SUPERADMIN). A disabled user gets no link.
 */
export function sendAdminUserPasswordReset(uid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/admin/users/${encodeURIComponent(uid)}/password-reset`, {
        ...opts,
        method: "POST"
    }));
}
/**
 * Admin: internal notes of an organization (SUPERADMIN), newest first. Never visible to clients. The notes of its agencies are not included.
 */
export function listAdminOrganizationNotes(oid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: AdminInternalNoteCollection;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/admin/organizations/${encodeURIComponent(oid)}/notes`, {
        ...opts
    }));
}
/**
 * Admin: add an internal note to an organization (SUPERADMIN). The requester is its author.
 */
export function createAdminOrganizationNote(oid: Uuid, adminInternalNoteInput: AdminInternalNoteInput, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: AdminInternalNote;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/admin/organizations/${encodeURIComponent(oid)}/notes`, oazapfts.json({
        ...opts,
        method: "POST",
        body: adminInternalNoteInput
    })));
}
/**
 * Admin: internal notes of an agency (SUPERADMIN), newest first. Never visible to clients. The root group of an organization is not an agency: its notes are the organization's.
 */
export function listAdminGroupNotes(gid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: AdminInternalNoteCollection;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/admin/groups/${encodeURIComponent(gid)}/notes`, {
        ...opts
    }));
}
/**
 * Admin: add an internal note to an agency (SUPERADMIN). The requester is its author. On the root group of an organization, the note goes to the organization.
 */
export function createAdminGroupNote(gid: Uuid, adminInternalNoteInput: AdminInternalNoteInput, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: AdminInternalNote;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/admin/groups/${encodeURIComponent(gid)}/notes`, oazapfts.json({
        ...opts,
        method: "POST",
        body: adminInternalNoteInput
    })));
}
/**
 * Admin: internal notes of a user (SUPERADMIN), newest first. Never visible to clients. They stay on the user page: neither the notes of their organization nor of their agency are included, and theirs do not appear there.
 */
export function listAdminUserNotes(uid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: AdminInternalNoteCollection;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/admin/users/${encodeURIComponent(uid)}/notes`, {
        ...opts
    }));
}
/**
 * Admin: add an internal note to a user (SUPERADMIN). The requester is its author.
 */
export function createAdminUserNote(uid: Uuid, adminInternalNoteInput: AdminInternalNoteInput, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: AdminInternalNote;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/admin/users/${encodeURIComponent(uid)}/notes`, oazapfts.json({
        ...opts,
        method: "POST",
        body: adminInternalNoteInput
    })));
}
/**
 * Admin: change the text of an internal note (SUPERADMIN). Only its author can.
 */
export function updateAdminNote(noteId: Uuid, adminInternalNoteInput: AdminInternalNoteInput, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: AdminInternalNote;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/admin/notes/${encodeURIComponent(noteId)}`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: adminInternalNoteInput
    })));
}
/**
 * Admin: delete an internal note (SUPERADMIN). Only its author can.
 */
export function deleteAdminNote(noteId: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/admin/notes/${encodeURIComponent(noteId)}`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * Admin: full organization billing state (SUPERADMIN).
 */
export function getAdminOrganizationSubscription(oid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: AdminOrganizationSubscriptionResponse;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/admin/organizations/${encodeURIComponent(oid)}/subscription`, {
        ...opts
    }));
}
/**
 * Admin: enable/disable Hyperline billing; optionally set plan/cycle and assign template subscription.
 */
export function updateAdminOrganizationHyperlineBilling(oid: Uuid, body: {
    enabled: boolean;
    planId?: PlanId2;
    cycle?: Cycle;
    /** When enabling, create Hyperline subscription from template if missing (default true) */
    assignSubscription?: boolean;
}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: AdminOrganizationSubscriptionResponse;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/admin/organizations/${encodeURIComponent(oid)}/subscription/hyperline-billing`, oazapfts.json({
        ...opts,
        method: "PUT",
        body
    })));
}
/**
 * Admin: set plan including enterprise (immediate Hyperline sync).
 */
export function updateAdminOrganizationSubscriptionPlan(oid: Uuid, body: {
    planId: PlanId2;
}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: BillingSubscriptionMutationResponse;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/admin/organizations/${encodeURIComponent(oid)}/subscription/plan`, oazapfts.json({
        ...opts,
        method: "PUT",
        body
    })));
}
/**
 * Admin: set billing cycle (effective next renewal).
 */
export function updateAdminOrganizationSubscriptionCycle(oid: Uuid, body: {
    cycle: Cycle;
}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: BillingSubscriptionMutationResponse;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/admin/organizations/${encodeURIComponent(oid)}/subscription/cycle`, oazapfts.json({
        ...opts,
        method: "PUT",
        body
    })));
}
/**
 * Admin: toggle soft-block when credits are exhausted.
 */
export function updateAdminOrganizationBlockOnExhaustion(oid: Uuid, body: {
    enabled: boolean;
}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: AdminOrganizationSubscriptionResponse;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/admin/organizations/${encodeURIComponent(oid)}/subscription/block-on-exhaustion`, oazapfts.json({
        ...opts,
        method: "PUT",
        body
    })));
}
/**
 * Admin: free Hyperline credit topup (gift).
 */
export function giftAdminOrganizationCredits(oid: Uuid, body: {
    credits: number;
    memo?: string;
    /** Admin-defined expiry for gifted credits (ISO 8601) */
    expiresAt: string;
}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: AdminCreditGiftResponse;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/admin/organizations/${encodeURIComponent(oid)}/subscription/credits/gift`, oazapfts.json({
        ...opts,
        method: "POST",
        body
    })));
}
/**
 * Admin: set or reset pricing overrides (null resets a field).
 */
export function updateAdminOrganizationPricingOverrides(oid: Uuid, body: {
    declarationCost?: number | null;
    articleCost?: number | null;
    extraCreditPrice?: number | null;
    /** Override included credits per billing period; null resets to plan envelope. Applied at next grant/renew. */
    envelopeCredits?: number | null;
}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: AdminOrganizationSubscriptionResponse;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/admin/organizations/${encodeURIComponent(oid)}/subscription/pricing-overrides`, oazapfts.json({
        ...opts,
        method: "PUT",
        body
    })));
}
/**
 * Admin: list billing intervention events for an organization (SUPERADMIN). Action codes only — no localized copy.
 */
export function listAdminOrganizationBillingEvents(oid: Uuid, { page, size }: {
    page?: number;
    size?: number;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: AdminBillingEventsList;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/admin/organizations/${encodeURIComponent(oid)}/subscription/events${QS.query(QS.explode({
        page,
        size
    }))}`, {
        ...opts
    }));
}
/**
 * Admin: feature flags with their targeting, targeted users resolved (SUPERADMIN). TEC-1701.
 */
export function listAdminFeatureFlags(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: AdminFeatureFlagList;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>("/admin/feature-flags", {
        ...opts
    }));
}
/**
 * Admin: create a feature flag, disabled and untargeted, with an audit event (SUPERADMIN). The key is read by the code and cannot change. TEC-1701.
 */
export function createAdminFeatureFlag(adminFeatureFlagCreation: AdminFeatureFlagCreation, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: AdminFeatureFlag;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 409;
    } | {
        status: 500;
    }>("/admin/feature-flags", oazapfts.json({
        ...opts,
        method: "POST",
        body: adminFeatureFlagCreation
    })));
}
/**
 * Admin: creations and changes of feature flags, newest first, with the values before and after (SUPERADMIN). At most 100 events. TEC-1701.
 */
export function listAdminFeatureFlagAuditEvents(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: AdminFeatureFlagAuditEventList;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>("/admin/feature-flags/audit-events", {
        ...opts
    }));
}
/**
 * Admin: enable or disable a feature flag, change its targeted roles and users, or rename it, applied at once with an audit event (SUPERADMIN). A disabled flag keeps its targeting. TEC-1701.
 */
export function updateAdminFeatureFlag(flagId: Uuid, adminFeatureFlagUpdate: AdminFeatureFlagUpdate, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: AdminFeatureFlag;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/admin/feature-flags/${encodeURIComponent(flagId)}`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: adminFeatureFlagUpdate
    })));
}
/**
 * Product tours served to the connected user: published and online, evaluated on the published snapshot only (targeted role, linked feature flag visible), texts in the requested locale with a per-field fallback (requested, then fr, then en; blank = missing), with the user's state. The draft edited in the console is never served. The state is null when none is stored or when it predates the last relaunch. Gated by the product_tours feature flag.
 */
export function listProductTours({ locale }: {
    locale?: "fr" | "en" | "de";
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ProductTourPublicList;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>(`/product-tours${QS.query(QS.explode({
        locale
    }))}`, {
        ...opts
    }));
}
/**
 * Store the connected user's state for a product tour (completed or dismissed), with the tour's current version, in user.ui_preferences.productTours. Gated by the product_tours feature flag.
 */
export function setProductTourState(tourId: Uuid, productTourStateUpdate: ProductTourStateUpdate, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/product-tours/${encodeURIComponent(tourId)}/state`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: productTourStateUpdate
    })));
}
/**
 * Admin: all product tours, most recently updated first, with completion stats (SUPERADMIN).
 */
export function adminListProductTours(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ProductTourStaffList;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>("/admin/product-tours", {
        ...opts
    }));
}
/**
 * Admin: create a product tour, never published (DRAFT), with an audit event (SUPERADMIN). The key cannot change.
 */
export function adminCreateProductTour(productTourCreation: ProductTourCreation, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: ProductTourStaff;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 409;
    } | {
        status: 500;
    }>("/admin/product-tours", oazapfts.json({
        ...opts,
        method: "POST",
        body: productTourCreation
    })));
}
/**
 * Admin: one product tour with its completion stats (SUPERADMIN).
 */
export function adminGetProductTour(tourId: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ProductTourStaff;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/admin/product-tours/${encodeURIComponent(tourId)}`, {
        ...opts
    }));
}
/**
 * Admin: save the draft of a product tour, with an audit event (SUPERADMIN). Steps are replaced as a whole. The draft is never served: users keep the published snapshot until the next publish (TEC-1634).
 */
export function adminUpdateProductTour(tourId: Uuid, productTourUpdate: ProductTourUpdate, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ProductTourStaff;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/admin/product-tours/${encodeURIComponent(tourId)}`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: productTourUpdate
    })));
}
/**
 * Admin: delete a product tour, with an audit event (SUPERADMIN).
 */
export function adminDeleteProductTour(tourId: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/admin/product-tours/${encodeURIComponent(tourId)}`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * Admin: publish the draft (SUPERADMIN): copied into the served snapshot, version + 1. The first publish puts the tour online; later publishes keep the online switch as is. Requires fr and en titles, at least one step, fr and en title and body on every step, unique step ids.
 */
export function adminPublishProductTour(tourId: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ProductTourStaff;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/admin/product-tours/${encodeURIComponent(tourId)}/publish`, {
        ...opts,
        method: "POST"
    }));
}
/**
 * Admin: reset the draft to the published snapshot, with an audit event (SUPERADMIN). TEC-1634.
 */
export function adminDiscardProductTourDraft(tourId: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ProductTourStaff;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/admin/product-tours/${encodeURIComponent(tourId)}/discard`, {
        ...opts,
        method: "POST"
    }));
}
/**
 * Admin: switch a published tour online or off, applied at once, the draft untouched, with an audit event (SUPERADMIN). TEC-1634.
 */
export function adminSetProductTourEnabled(tourId: Uuid, productTourEnabledUpdate: ProductTourEnabledUpdate, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ProductTourStaff;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/admin/product-tours/${encodeURIComponent(tourId)}/enabled`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: productTourEnabledUpdate
    })));
}
/**
 * Admin: relaunch for everyone (SUPERADMIN), on a published tour, online or disabled: user states stored before now are ignored, the tour starts again on its own.
 */
export function adminRelaunchProductTour(tourId: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ProductTourStaff;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/admin/product-tours/${encodeURIComponent(tourId)}/relaunch`, {
        ...opts,
        method: "POST"
    }));
}
/**
 * Admin: answers to the end-of-declaration questionnaire scored 0-10, with the NPS summary, each user's profile (average of their scores) and the tags (SUPERADMIN). Legacy 1-5 ratings are excluded. TEC-1704.
 */
export function getAdminNps(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            data: AdminNps;
        };
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>("/admin/nps", {
        ...opts
    }));
}
/**
 * Admin: create an NPS tag, colored from the palette in creation order (SUPERADMIN). Names are unique regardless of case. TEC-1704.
 */
export function createAdminNpsTag(adminNpsTagCreation: AdminNpsTagCreation, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: AdminNpsTag;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 409;
    } | {
        status: 500;
    }>("/admin/nps/tags", oazapfts.json({
        ...opts,
        method: "POST",
        body: adminNpsTagCreation
    })));
}
/**
 * Admin: put a tag on an NPS response; putting it twice changes nothing (SUPERADMIN). TEC-1704.
 */
export function addAdminNpsResponseTag(responseId: Uuid, tagId: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/admin/nps/responses/${encodeURIComponent(responseId)}/tags/${encodeURIComponent(tagId)}`, {
        ...opts,
        method: "PUT"
    }));
}
/**
 * Admin: remove a tag from an NPS response; the tag stays available (SUPERADMIN). TEC-1704.
 */
export function removeAdminNpsResponseTag(responseId: Uuid, tagId: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/admin/nps/responses/${encodeURIComponent(responseId)}/tags/${encodeURIComponent(tagId)}`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * Admin: model calls made by the platform during a period, by dossier and by processing step: tokens, models, cost frozen at the price of the call day, duration, errors and kept-values rate (SUPERADMIN). A dossier enters if it has a call in the period, and only the calls of the period count; its calls outside the period are reported apart. Days are UTC. With organizationId, only the dossiers of that organization (root group and agencies) count, and calls outside any dossier are left out (TEC-1718). TEC-1703.
 */
export function getAdminAiConsumption($from: string, to: string, { organizationId }: {
    organizationId?: Uuid;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            data: AdminAiConsumption;
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>(`/admin/ai-consumption${QS.query(QS.explode({
        "from": $from,
        to,
        organizationId
    }))}`, {
        ...opts
    }));
}
/**
 * Admin: Nabu assistant of an organization (SUPERADMIN): access, monthly spending cap in USD and spending of the current UTC calendar month (chat and dictation of its dossiers). TEC-1718.
 */
export function getAdminOrganizationAiAssistant(oid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            data: AdminOrganizationAiAssistant;
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/admin/organizations/${encodeURIComponent(oid)}/ai-assistant`, {
        ...opts
    }));
}
/**
 * Admin: open or close the Nabu assistant to every user of an organization and set its monthly spending cap in USD (SUPERADMIN). Once the cap is reached, the assistant is blocked until the next UTC month; 0 blocks it. Logged in the admin audit trail. TEC-1718.
 */
export function updateAdminOrganizationAiAssistant(oid: Uuid, body: {
    enabled: boolean;
    /** Monthly spending cap in USD, 2 decimals kept */
    monthlyCapUsd: number;
}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            data: AdminOrganizationAiAssistant;
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/admin/organizations/${encodeURIComponent(oid)}/ai-assistant`, oazapfts.json({
        ...opts,
        method: "PUT",
        body
    })));
}
/**
 * Nabu catalogue of rights (modules, action prefixes, actions, capacities, Nabu roles) with its labels in the requested language, in the catalogue order. The webapp and the console keep no copy of it. version changes as soon as a code or a label changes, whatever the language. TEC-1670.
 */
export function getAuthzCatalogue({ lang }: {
    lang?: "fr" | "en" | "de";
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: AuthzCatalogue;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 500;
    }>(`/authz/catalogue${QS.query(QS.explode({
        lang
    }))}`, {
        ...opts
    }));
}
/**
 * Roles of an organization, copied from a Nabu role (ADR 0032). Needs roles.read on one of its agencies. TEC-1682.
 */
export function listAuthzRoles(oid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            data: AuthzOrgRole[];
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/organizations/${encodeURIComponent(oid)}/authz/roles`, {
        ...opts
    }));
}
/**
 * Create a role by copying a Nabu role: followed capacities and frozen copies (5 roles at most). Needs roles.create on the organization root. Logged in the audit trail. TEC-1682.
 */
export function createAuthzRole(oid: Uuid, authzRoleDefinition: AuthzRoleDefinition, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: {
            data: AuthzOrgRole;
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    }>(`/organizations/${encodeURIComponent(oid)}/authz/roles`, oazapfts.json({
        ...opts,
        method: "POST",
        body: authzRoleDefinition
    })));
}
/**
 * Rename a role or change its capacities and copies. Needs roles.update on the organization root. TEC-1682.
 */
export function updateAuthzRole(oid: Uuid, roleId: Uuid, authzRolePatch: AuthzRolePatch, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            data: AuthzOrgRole;
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    }>(`/organizations/${encodeURIComponent(oid)}/authz/roles/${encodeURIComponent(roleId)}`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: authzRolePatch
    })));
}
/**
 * Delete a role nobody holds anymore. Needs roles.delete on the organization root. TEC-1682.
 */
export function deleteAuthzRole(oid: Uuid, roleId: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/organizations/${encodeURIComponent(oid)}/authz/roles/${encodeURIComponent(roleId)}`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * Move these members from a role to this one, same agencies and dates (first save of a copy). TEC-1682.
 */
export function moveAuthzRoleHolders(oid: Uuid, roleId: Uuid, authzMoveHoldersRequest: AuthzMoveHoldersRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            data: {
                moved: number;
            };
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    }>(`/organizations/${encodeURIComponent(oid)}/authz/roles/${encodeURIComponent(roleId)}/holders`, oazapfts.json({
        ...opts,
        method: "POST",
        body: authzMoveHoldersRequest
    })));
}
/**
 * Accesses on the agencies of an organization the caller can read (users.read). TEC-1682.
 */
export function listAuthzGrants(oid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            data: AuthzGrant[];
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/organizations/${encodeURIComponent(oid)}/authz/grants`, {
        ...opts
    }));
}
/**
 * Give a member a role on agencies, one access per agency. Needs users.assign_role on each, never beyond the caller's own rights, never to oneself. TEC-1682.
 */
export function createAuthzGrants(oid: Uuid, authzGrantRequest: AuthzGrantRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
        data: {
            data: AuthzGrant[];
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    }>(`/organizations/${encodeURIComponent(oid)}/authz/grants`, oazapfts.json({
        ...opts,
        method: "POST",
        body: authzGrantRequest
    })));
}
/**
 * Remove an access. Refused if it would leave the organization without an administrator of its roles. TEC-1682.
 */
export function deleteAuthzGrant(oid: Uuid, grantId: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/organizations/${encodeURIComponent(oid)}/authz/grants/${encodeURIComponent(grantId)}`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * Give a member the same role on all their accesses in the organization (a root access if they have none). TEC-1682.
 */
export function assignAuthzMemberRole(oid: Uuid, uid: Uuid, authzRoleRef: AuthzRoleRef, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            data: AuthzGrant[];
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 409;
    } | {
        status: 500;
    }>(`/organizations/${encodeURIComponent(oid)}/authz/members/${encodeURIComponent(uid)}/role`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: authzRoleRef
    })));
}
export enum Type {
    Service = "SERVICE",
    Team = "TEAM",
    Office = "OFFICE",
    Organization = "ORGANIZATION",
    Undefined = "UNDEFINED"
}
export enum AuthzMode {
    Legacy = "legacy",
    Observation = "observation",
    Active = "active"
}
export enum Role {
    User = "USER",
    Manager = "MANAGER",
    Admin = "ADMIN",
    Superadmin = "SUPERADMIN",
    Guest = "GUEST",
    Agent = "AGENT"
}
export enum Position {
    RegisteredCustomsRepresentative = "REGISTERED_CUSTOMS_REPRESENTATIVE",
    CustomsManager = "CUSTOMS_MANAGER",
    CustomsTeamManager = "CUSTOMS_TEAM_MANAGER",
    InformationSystemsManager = "INFORMATION_SYSTEMS_MANAGER",
    NabuAdministrator = "NABU_ADMINISTRATOR",
    SystemAgent = "SYSTEM_AGENT"
}
export enum Language {
    Fr = "fr",
    FrFr = "fr-FR",
    En = "en",
    EnEn = "en-EN",
    De = "de"
}
export enum Theme {
    Light = "light",
    Dark = "dark",
    Auto = "auto"
}
export enum DeclarationInterface {
    Classic = "classic",
    Beta = "beta"
}
export enum PreparationMode {
    Classic = "classic",
    Intelligent = "intelligent"
}
export enum PanelPlacement {
    Hidden = "hidden",
    Floating = "floating",
    Left = "left",
    Right = "right"
}
export enum ControlPanelPlacement {
    Tab = "tab",
    Hidden = "hidden",
    Floating = "floating",
    Left = "left",
    Right = "right"
}
export enum DeclarationHomeTab {
    Headers = "headers",
    Articles = "articles",
    Delivery = "delivery",
    Regulation = "regulation",
    Control = "control"
}
export enum State {
    Generated = "generated",
    InReview = "in_review",
    Ready = "ready",
    Sent = "sent",
    Accepted = "accepted",
    Rejected = "rejected",
    Superseded = "superseded"
}
export enum ExecutionState {
    Running = "RUNNING",
    Pending = "PENDING",
    Succeeded = "SUCCEEDED",
    Errored = "ERRORED"
}
export enum BatchImportLogStatus {
    Upload = "UPLOAD",
    Segmentation = "SEGMENTATION",
    Segmented = "SEGMENTED",
    Extracting = "EXTRACTING",
    Mapping = "MAPPING",
    Mapped = "MAPPED",
    Export = "EXPORT",
    Exported = "EXPORTED",
    ExportFailed = "EXPORT_FAILED",
    Failed = "FAILED"
}
export enum DisplayStatus {
    Upload = "UPLOAD",
    Segmentation = "SEGMENTATION",
    Segmented = "SEGMENTED",
    Extracting = "EXTRACTING",
    Mapping = "MAPPING",
    Mapped = "MAPPED",
    Export = "EXPORT",
    Exported = "EXPORTED",
    ExportFailed = "EXPORT_FAILED",
    Failed = "FAILED",
    Abandoned = "ABANDONED"
}
export enum Source {
    Email = "EMAIL",
    Ftp = "FTP",
    Api = "API",
    Service = "SERVICE"
}
export enum Type2 {
    Ftp = "FTP",
    Sftp = "SFTP",
    Api = "API"
}
export enum BatchImportLogStatus2 {
    Upload = "UPLOAD",
    Segmentation = "SEGMENTATION",
    Mapping = "MAPPING",
    Mapped = "MAPPED",
    Export = "EXPORT",
    Exported = "EXPORTED"
}
export enum BatchImportLogStatus3 {
    Mapped = "MAPPED",
    Segmented = "SEGMENTED",
    Exported = "EXPORTED"
}
export enum UnifillStatus {
    Processing = "processing",
    Done = "done",
    Error = "error"
}
export enum ExtractionSource {
    Internal = "internal",
    Rossum = "rossum"
}
export enum State2 {
    Pending = "PENDING",
    Running = "RUNNING",
    Incomplete = "INCOMPLETE",
    Canceled = "CANCELED",
    Failed = "FAILED",
    Succeeded = "SUCCEEDED"
}
export enum Type3 {
    User = "user",
    System = "system"
}
export enum ExtractionSource2 {
    ExternalLlm = "external_llm",
    ExternalRossum = "external_rossum",
    Internal = "internal"
}
export enum ExportUiFormDataCategory {
    Field = "field",
    Multivalue = "multivalue",
    ExportForm = "export-form",
    Section = "section",
    Tuple = "tuple",
    Suffix = "suffix"
}
export enum Type4 {
    Set = "set",
    Clear = "clear",
    ClearColumn = "clear_column",
    SetColumn = "set_column",
    AddLine = "add_line",
    RemoveLine = "remove_line",
    AddTuple = "add_tuple",
    RemoveTuple = "remove_tuple",
    Validate = "validate",
    ReviewIssue = "review_issue",
    Consolidate = "consolidate",
    Unconsolidate = "unconsolidate",
    SetTotalReference = "set_total_reference",
    ClearTotalReference = "clear_total_reference",
    DistributeTotal = "distribute_total",
    Revert = "revert"
}
export enum Basis {
    Manual = "manual",
    Lines = "lines",
    Reading = "reading"
}
export enum Type5 {
    Ftp = "FTP",
    Sftp = "SFTP",
    Api = "API"
}
export enum UserPosition {
    RegisteredCustomsRepresentative = "REGISTERED_CUSTOMS_REPRESENTATIVE",
    CustomsManager = "CUSTOMS_MANAGER",
    CustomsTeamManager = "CUSTOMS_TEAM_MANAGER",
    InformationSystemsManager = "INFORMATION_SYSTEMS_MANAGER",
    NabuAdministrator = "NABU_ADMINISTRATOR",
    SystemAgent = "SYSTEM_AGENT"
}
export enum UserLanguage {
    Fr = "fr",
    FrFr = "fr-FR",
    En = "en",
    EnEn = "en-EN",
    De = "de"
}
export enum ReferenceType {
    BatchImport = "BATCH_IMPORT"
}
export enum ContentType {
    ApplicationPdf = "application/pdf",
    ImagePng = "image/png",
    ImageJpeg = "image/jpeg",
    ApplicationVndMsExcel = "application/vnd.ms-excel",
    ApplicationVndOpenxmlformatsOfficedocumentSpreadsheetmlSheet = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ApplicationVndOasisOpendocumentSpreadsheet = "application/vnd.oasis.opendocument.spreadsheet",
    ApplicationVndMsExcelSheetMacroenabled12 = "application/vnd.ms-excel.sheet.macroenabled.12",
    ApplicationVndMsOutlook = "application/vnd.ms-outlook",
    ApplicationZip = "application/zip",
    ApplicationJson = "application/json"
}
export enum ContentType2 {
    ApplicationPdf = "application/pdf",
    ImagePng = "image/png",
    ImageJpeg = "image/jpeg",
    ApplicationVndOpenxmlformatsOfficedocumentSpreadsheetmlSheet = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ApplicationVndMsExcel = "application/vnd.ms-excel",
    ApplicationVndMsExcelSheetMacroenabled12 = "application/vnd.ms-excel.sheet.macroenabled.12",
    TextCsv = "text/csv"
}
export enum ForceWorkflow {
    V2 = "v2"
}
export enum Position2 {
    User = "USER",
    Manager = "MANAGER",
    Admin = "ADMIN",
    Superadmin = "SUPERADMIN",
    Guest = "GUEST",
    Agent = "AGENT"
}
export enum Permission {
    Write = "write",
    Read = "read"
}
export enum UnifillStatus2 {
    Done = "done",
    Processing = "processing",
    Error = "error"
}
export enum Scope {
    Flux = "flux",
    User = "user",
    Group = "group",
    ClientOrga = "client-orga"
}
export enum Locale {
    Fr = "fr",
    En = "en"
}
export enum Period {
    Week = "week",
    Month = "month"
}
export enum Type6 {
    DeclarationStatusChanged = "declaration_status_changed",
    DeclarationCommentAdded = "declaration_comment_added",
    DeclarationSentByCollaborator = "declaration_sent_by_collaborator",
    DeclarationReturnedForCorrection = "declaration_returned_for_correction",
    AppUpdate = "app_update"
}
export enum Scope2 {
    BatchImport = "batch-import"
}
export enum Status {
    Draft = "DRAFT",
    Published = "PUBLISHED"
}
export enum Kind {
    Feature = "FEATURE",
    Fix = "FIX"
}
export enum DeploymentEnv {
    Dev = "dev",
    Staging = "staging",
    Prod = "prod"
}
export enum HelpCategory {
    DeclarationDouaniere = "declaration_douaniere",
    ExtractionDonnee = "extraction_donnee",
    DocumentsDossiers = "documents_dossiers",
    ClassificationDocumentaire = "classification_documentaire",
    AutomatisationMetier = "automatisation_metier",
    Integrations = "integrations"
}
export enum HelpArticleLanguage {
    Fr = "fr",
    En = "en",
    De = "de"
}
export enum Trigger {
    Webhook = "WEBHOOK",
    Manual = "MANUAL"
}
export enum Status2 {
    Success = "SUCCESS",
    Partial = "PARTIAL",
    Failed = "FAILED"
}
export enum AiAgentSkillIcon {
    Book = "book",
    Lightning = "lightning",
    Grid = "grid",
    Document = "document",
    Search = "search",
    Layers = "layers",
    Shield = "shield",
    Shuffle = "shuffle"
}
export enum AuthType {
    Hmac = "hmac",
    Oauth2Cc = "oauth2_cc"
}
export enum Type7 {
    Hmac = "hmac"
}
export enum Type8 {
    Oauth2Cc = "oauth2_cc"
}
export enum Relation {
    Eq = "eq",
    Lt = "lt",
    Gt = "gt",
    Includes = "includes"
}
export enum EnrollmentReason {
    Active = "active",
    ManualBilling = "manual_billing",
    NotConfigured = "not_configured"
}
export enum SubscriptionActivation {
    Pending = "pending",
    Active = "active"
}
export enum Threshold {
    Normal = "normal",
    Low = "low",
    Exhausted = "exhausted"
}
export enum Mode {
    Sandbox = "sandbox",
    Production = "production"
}
export enum Id {
    Starter = "starter",
    Growth = "growth",
    Enterprise = "enterprise"
}
export enum BillingCycle {
    Monthly = "monthly",
    Annual = "annual"
}
export enum PlanId {
    Starter = "starter",
    Growth = "growth"
}
export enum Cycle {
    Monthly = "monthly",
    Annual = "annual"
}
export enum PlanId2 {
    Starter = "starter",
    Growth = "growth",
    Enterprise = "enterprise"
}
export enum EffectiveAt {
    Immediate = "immediate"
}
export enum Brand {
    Visa = "visa",
    Mastercard = "mastercard",
    Amex = "amex",
    Other = "other"
}
export enum Status3 {
    Active = "active",
    Pending = "pending",
    Expired = "expired",
    Errored = "errored"
}
export enum PaymentMethodType {
    Card = "card"
}
export enum State3 {
    Active = "active"
}
export enum Kind2 {
    StripeSetup = "stripe_setup"
}
export enum Status4 {
    Paid = "paid",
    Pending = "pending",
    Failed = "failed"
}
export enum Status5 {
    Active = "active",
    Trial = "trial",
    Unpaid = "unpaid",
    Cancelled = "cancelled",
    None = "none"
}
export enum NabuBilling {
    Active = "active",
    ManualBilling = "manual_billing",
    NotConfigured = "not_configured"
}
export enum Access {
    Public = "PUBLIC",
    Internal = "INTERNAL"
}
export enum Status6 {
    Published = "PUBLISHED",
    Unpublished = "UNPUBLISHED"
}
export enum Status7 {
    Active = "active",
    Disabled = "disabled",
    Invited = "invited"
}
export enum Action {
    UserUpdated = "user_updated",
    UiPreferencesUpdated = "ui_preferences_updated",
    InvitationSent = "invitation_sent",
    PasswordResetSent = "password_reset_sent"
}
export enum Status8 {
    Active = "active",
    Trial = "trial",
    Unpaid = "unpaid",
    Cancelled = "cancelled"
}
export enum AdminBillingEventAction {
    HyperlineBillingEnabled = "hyperline_billing_enabled",
    HyperlineBillingDisabled = "hyperline_billing_disabled",
    PlanChanged = "plan_changed",
    CycleChanged = "cycle_changed",
    BlockOnExhaustionChanged = "block_on_exhaustion_changed",
    CreditsGifted = "credits_gifted",
    PricingOverridesChanged = "pricing_overrides_changed"
}
export enum Action2 {
    FeatureFlagCreated = "feature_flag_created",
    FeatureFlagUpdated = "feature_flag_updated"
}
export enum Status9 {
    Completed = "COMPLETED",
    Dismissed = "DISMISSED"
}
export enum ProductTourPlacement {
    Auto = "auto",
    Top = "top",
    Bottom = "bottom",
    Left = "left",
    Right = "right"
}
export enum Status10 {
    Draft = "DRAFT",
    Online = "ONLINE",
    Disabled = "DISABLED"
}
export enum NpsCategory {
    Promoter = "promoter",
    Passive = "passive",
    Detractor = "detractor"
}
export enum Currency {
    Usd = "USD"
}
export enum AdminAiConsumptionStepKey {
    Split = "split",
    Read = "read",
    Match = "match",
    Complete = "complete",
    Ai = "ai"
}
export enum Deleted {
    No = "no",
    Soft = "soft",
    Hard = "hard"
}
export enum Status11 {
    Measured = "measured",
    Auto = "auto",
    Unmeasured = "unmeasured",
    Pending = "pending",
    None = "none"
}
export enum Status12 {
    Available = "available",
    Disabled = "disabled",
    QuotaReached = "quota_reached"
}
export enum Lang {
    Fr = "fr",
    En = "en",
    De = "de"
}
export enum SourcePreset {
    Guest = "guest",
    Declarant = "declarant",
    Manager = "manager",
    Admin = "admin"
}
export enum Preset {
    Guest = "guest",
    Declarant = "declarant",
    Manager = "manager",
    Admin = "admin"
}
export enum Origin {
    Migration = "migration",
    Manual = "manual"
}

/**
 * Fetches a new schema
 */
export function findOneNewSchema(
  decIntegrationId: number,
  groupId: string,
  opts?: Oazapfts.RequestOpts
) {
  return oazapfts.ok(
    oazapfts.fetchJson<
      | {
          status: 200
          data: { data: Schema2 }
        }
      | {
          status: 201
        }
      | {
          status: 400
        }
      | {
          status: 401
        }
      | {
          status: 403
        }
      | {
          status: 404
        }
      | {
          status: 409
        }
      | {
          status: 500
        }
      | {
          status: number
        }
    >(
      `/forms/dec_form/retrieve${QS.query(
        QS.explode({
          groupId,
          decIntegrationId,
        })
      )}`,
      {
        ...opts,
      }
    )
  )
}

export type DecLabel = {
  code: string
  locale: string
  value: string | null
  id: number
  gid: string | null
}

/**
 * Fetches new schema labels
 */
export function findNewSchemaLabels(
  groupId: string,
  decIntegrationId: number,
  locale: string,
  opts?: Oazapfts.RequestOpts
) {
  return oazapfts.ok(
    oazapfts.fetchJson<
      | {
          status: 200
          data: { decLabelIntls: DecLabel[] }
        }
      | {
          status: 201
        }
      | {
          status: 400
        }
      | {
          status: 401
        }
      | {
          status: 403
        }
      | {
          status: 404
        }
      | {
          status: 409
        }
      | {
          status: 500
        }
      | {
          status: number
        }
    >(
      `/forms/dec_label_intls${QS.query(
        QS.explode({
          groupId,
          decIntegrationId,
          locale,
        })
      )}`,
      {
        ...opts,
      }
    )
  )
}

export type GroupAddress = {
  createdAt?: string
  updatedAt?: string
  oaid?: Uuid
  /** string data model with a sequence of 16 characters (String16) */
  tag?: string
  address?: Uuid
}

/**
 * Retrieve information about a member resource of the Address resources in the response body.
 */
export function headFindOneAddress(aid: Uuid, opts?: Oazapfts.RequestOpts) {
  return oazapfts.ok(
    oazapfts.fetchText(`/addresses/${encodeURIComponent(aid)}`, {
      ...opts,
      method: 'HEAD',
    })
  )
}
/**
 * Retrieve a member resource of the Address resources in the response body.
 */
export function findOneAddress(aid: Uuid, opts?: Oazapfts.RequestOpts) {
  return oazapfts.ok(
    oazapfts.fetchJson<
      | {
          status: 200
          data: Address
        }
      | {
          status: 400
        }
      | {
          status: 401
        }
      | {
          status: 403
        }
      | {
          status: 404
        }
      | {
          status: 500
        }
      | {
          status: number
        }
    >(`/addresses/${encodeURIComponent(aid)}`, {
      ...opts,
    })
  )
}

export type Address = {
  createdAt?: string
  updatedAt?: string
  aid?: Uuid
  /** string data model with a sequence of 32 characters (String32) */
  givenName?: string
  /** string data model with a sequence of 32 characters (String32) */
  surname?: string
  /** string data model with a sequence of 32 characters (String32) */
  companyName?: string
  /** string data model with a sequence of 16 characters (String16) */
  streetNo?: string
  /** string data model with a sequence of 128 characters (String128) */
  streetName?: string
  /** string data model with a sequence of 16 characters (String16) */
  streetType?: string
  /** string data model with a sequence of 16 characters (String16) */
  floor?: string
  /** string data model with a sequence of 64 characters (String64) */
  town?: string
  /** string data model with a sequence of 128 characters (String128) */
  region?: string
  /** string data model with a sequence of 16 characters (String16) */
  postCode?: string
  /** country code : string data model with a sequence of three-letter code (ISO 3166 alpha-3)  (CountryCodeISO3) */
  country?: string
}

export type PartialDocument = {
  batchImportId?: Uuid
  layerId?: Uuid
  documentType?: DocumentType
  /** List of DocumentPage */
  pages: DocumentPage[]
}

/**
 * Delete a member resource of the SettingKey resources.
 */
export function deleteOneGroupSettings(
  gid: Uuid,
  mskid: Uuid,
  opts?: Oazapfts.RequestOpts
) {
  return oazapfts.ok(
    oazapfts.fetchText(
      `/groups/${encodeURIComponent(gid)}/settings/${encodeURIComponent(
        mskid
      )}`,
      {
        ...opts,
        method: 'DELETE',
      }
    )
  )
}

/**
 * Partial update of a SettingKey.
 */
export function partialUpdateGroupSettings(
  gid: Uuid,
  mskid: Uuid,
  partialSettingKey: PartialSettingKey,
  opts?: Oazapfts.RequestOpts
) {
  return oazapfts.ok(
    oazapfts.fetchJson<
      | {
          status: 200
          data: SettingKey
        }
      | {
          status: 400
        }
      | {
          status: 401
        }
      | {
          status: 403
        }
      | {
          status: 404
        }
      | {
          status: 409
        }
      | {
          status: 500
        }
      | {
          status: number
        }
    >(
      `/groups/${encodeURIComponent(gid)}/settings/${encodeURIComponent(
        mskid
      )}`,
      oazapfts.json({
        ...opts,
        method: 'PATCH',
        body: partialSettingKey,
      })
    )
  )
}

/**
 * Fetches validation rules
 */

export type ValidationResponseErrorDetailed = {
  operation: string
  labelCode: string // ex SHIPMENT.CONSIGNMENT.NETMASS,
  value: number
  should: 'eq' | 'lt' | 'gt' | 'lte' | 'gte' | 'ne' | 'in' | 'nin' | 'regex'
  constraintValue: number
  constraintLabelCode: string // ex SHIPMENT.CONSIGNMENT.GROSSMASS,
  ruleErrorLabelCode: string // ex test,
  result: boolean
}

export type ValidationResponseError = {
  ruleErrorLabelCode: string
  name: string
  detailedErrors: ValidationResponseErrorDetailed[]
}
export interface ValidationResponse {
  cellsLength: number
  errorCounter: number
  errors: ValidationResponseError[]
  fieldsLength: number
  labelToPathDict: string[] // not used
  success: boolean
  uniqueDetailedErrorsLabelCode: string[] // ex "SHIPMENT.CONSIGNMENT.NETMASS"
  uniqueDetailedErrorsLabelCodeConstraints: string[] // ex "SHIPMENT.CONSIGNMENT.GROSSMASS"
  unusedValidationRulesCounter: number
  usedValidationRulesCounter: number
}

export function findValidationRules(
  exid: string,
  fbid: string,
  version?: string,
  opts?: Oazapfts.RequestOpts
) {
  return oazapfts.ok(
    oazapfts.fetchJson<
      | {
          status: 200
          data: ValidationResponse
        }
      | {
          status: 201
        }
      | {
          status: 400
        }
      | {
          status: 401
        }
      | {
          status: 403
        }
      | {
          status: 404
        }
      | {
          status: 409
        }
      | {
          status: 500
        }
      | {
          status: number
        }
    >(
      `/forms/validation_rules/retrieve${QS.query(
        QS.explode({
          exid,
          fbid,
          version: version || 'BUILD',
        })
      )}`,
      {
        ...opts,
      }
    )
  )
}

/*
 * Routes d'export V1 retirées du contrat de la gateway le 08/10/2026 (9b6dd601b, « retirer RabbitMQ et les
 * routes de l'ancien schéma »), mais encore appelées par l'ancien écran d'extraction (lib/ExtractionStore,
 * `isNewSchema` à faux). Recopiées telles qu'oazapfts les générait, pour que le client compile en attendant
 * de passer ces appels en V2 ou de retirer ce chemin. La gateway ne les sert plus.
 */
export type ExportFieldPartialUpdatePayload = {
    /** form json path associated with this field */
    formSchemaId?: string;
    /** field value */
    value?: string | null;
    /** set to true if field is validated by user */
    isValidated?: boolean;
    ocr?: ExportDataItemOcr;
};
export type ExportTableColumnCreationPayload = {
    columnName: string;
    columnCells: {
        row: number;
        column?: number;
        value: string | null;
        ocr?: {
            text: string | null;
            rawText: string | null;
            pageId: Uuid;
            position: number[];
            confidence?: number | null;
        };
    }[];
};
export type ExportTableGridUpdatePayload = {
    grid: ExportTableGridPart;
    toUpdateCells?: {
        id: Uuid;
        value?: string | null;
        isValidated?: boolean;
        readOnly?: boolean;
        ocr?: {
            text: string | null;
            rawText: string | null;
            pageId: Uuid;
            position: number[];
            confidence?: number | null;
        };
    }[];
};
export type ExportTableColumnRenamePayload = {
    /** export index of the column to rename */
    refIndex: number;
    columnName: string;
};
export type ExportFieldTupleCreationPayload = {
    /** json path of the tuple to add */
    schemaPath: string;
};
/**
 * Create an export table resource.
 */
export function createExportTable(exid: Uuid, body: {
    schemaPath: string;
    grid: ExportTableGridPart;
}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ExportDataTable;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/exports/${encodeURIComponent(exid)}/tables`, oazapfts.json({
        ...opts,
        method: "POST",
        body
    })));
}
/**
 * Delete an export table resource.
 */
export function deleteExportTable(exid: Uuid, etid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/exports/${encodeURIComponent(exid)}/tables/${encodeURIComponent(etid)}`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * Delete a grid part for a given page
 */
export function deleteExportTablePage(exid: Uuid, etid: Uuid, exportTablePageDeletionPayload: ExportTablePageDeletionPayload, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ExportDataTable;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/exports/${encodeURIComponent(exid)}/tables/${encodeURIComponent(etid)}/grid`, oazapfts.json({
        ...opts,
        method: "DELETE",
        body: exportTablePageDeletionPayload
    })));
}
/**
 * Add a column to an export table resource, using selected positions to populate column data
 */
export function addExportTableColumn(exid: Uuid, etid: Uuid, exportTableColumnCreationPayload: ExportTableColumnCreationPayload, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ExportDataTable;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/exports/${encodeURIComponent(exid)}/tables/${encodeURIComponent(etid)}/add-column`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: exportTableColumnCreationPayload
    })));
}
/**
 * Delete a column to an export table resource.
 */
export function deleteExportTableColumn(exid: Uuid, etid: Uuid, exportTableColumnDeletionPayload: ExportTableColumnDeletionPayload, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ExportDataTable;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/exports/${encodeURIComponent(exid)}/tables/${encodeURIComponent(etid)}/delete-column`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: exportTableColumnDeletionPayload
    })));
}
/**
 * Rename column
 */
export function renameExportTableColumn(exid: Uuid, etid: Uuid, exportTableColumnRenamePayload: ExportTableColumnRenamePayload, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ExportDataTable;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/exports/${encodeURIComponent(exid)}/tables/${encodeURIComponent(etid)}/rename-column`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: exportTableColumnRenamePayload
    })));
}
/**
 * Add a row to an export table resource
 */
export function addExportTableRow(exid: Uuid, etid: Uuid, exportTableRowCreationPayload: ExportTableRowCreationPayload, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ExportDataTable;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/exports/${encodeURIComponent(exid)}/tables/${encodeURIComponent(etid)}/add-row`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: exportTableRowCreationPayload
    })));
}
/**
 * Delete a row to an export table resource. Previous row will be merge with selected row (ocr data)
 */
export function deleteExportTableRow(exid: Uuid, etid: Uuid, exportTableRowDeletionPayload: ExportTableRowDeletionPayload, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ExportDataTable;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/exports/${encodeURIComponent(exid)}/tables/${encodeURIComponent(etid)}/delete-row`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: exportTableRowDeletionPayload
    })));
}
/**
 * add a grid part in table
 */
export function addExportTableGridPart(exid: Uuid, etid: Uuid, exportTableGridPartCreationPayload: ExportTableGridPartCreationPayload, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ExportDataTable;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/exports/${encodeURIComponent(exid)}/tables/${encodeURIComponent(etid)}/grid`, oazapfts.json({
        ...opts,
        method: "POST",
        body: exportTableGridPartCreationPayload
    })));
}
/**
 * Patch a grid part in table
 */
export function updateExportTableGridPart(exid: Uuid, etid: Uuid, exportTableGridUpdatePayload: ExportTableGridUpdatePayload, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ExportDataTable;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/exports/${encodeURIComponent(exid)}/tables/${encodeURIComponent(etid)}/grid`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: exportTableGridUpdatePayload
    })));
}
/**
 * Patch a batch of cells in table
 */
export function patchBatchExportTableCell(exid: Uuid, etid: Uuid, exportTableCellBatchUpdatePayload: ExportTableCellBatchUpdatePayload, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ExportDataTable;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/exports/${encodeURIComponent(exid)}/tables/${encodeURIComponent(etid)}/cells`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: exportTableCellBatchUpdatePayload
    })));
}
/**
 * Consolidation of an export table resource. All duplicate rows will be merge into one
 */
export function consolidateExportTable(exid: Uuid, etid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ExportDataTable;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/exports/${encodeURIComponent(exid)}/tables/${encodeURIComponent(etid)}/consolidation`, {
        ...opts,
        method: "POST"
    }));
}
/**
 * Consolidation of an export table resource. All duplicate rows will be merge into one
 */
export function removeExportTableConsolidation(exid: Uuid, etid: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ExportDataTable;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/exports/${encodeURIComponent(exid)}/tables/${encodeURIComponent(etid)}/consolidation`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * Add a Tuple of fields
 */
export function addExportFieldTuple(exid: Uuid, exportFieldTupleCreationPayload: ExportFieldTupleCreationPayload, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            partialData?: ExportPartialUpdatedData;
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/exports/${encodeURIComponent(exid)}/tuple`, oazapfts.json({
        ...opts,
        method: "POST",
        body: exportFieldTupleCreationPayload
    })));
}
/**
 * Delete a Tuple of fields
 */
export function deleteExportFieldTuple(exid: Uuid, tupleId: Uuid, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            partialData?: ExportPartialUpdatedData;
        };
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    } | {
        status: number;
    }>(`/exports/${encodeURIComponent(exid)}/tuple/${encodeURIComponent(tupleId)}`, {
        ...opts,
        method: "DELETE"
    }));
}

/** Named dataset row on a batch import (inline in OpenAPI `BatchImport.datasets`). */
export type BatchImportDataset = NonNullable<BatchImport['datasets']>[number]

export type BatchImportHistoryActionType =
  | 'DECLARATION_MODIFIED'
  | 'DECLARATION_SENT'
  | 'AUTOMATION_RUN'
  | 'EXTRACTION_RERUN'
  | 'CLASSIFICATION_RERUN'
  | 'MERGE'
  | 'MARKED_ERROR'
  | 'TAG_ADDED'
  | 'CLIENT_CHANGED'

/**
 * Retrieve the live agentic status of a BatchImport.
 */
export function getAgentStatus(fbid: Uuid, opts?: Oazapfts.RequestOpts) {
  return oazapfts.fetchJson<{
    status: 200
    data: { status: string | null; updatedAt: string | null }
  }>(`/batch-imports/${encodeURIComponent(fbid)}/agent-status`, {
    ...opts,
  })
}
